export const COLOR_TRANSPARENT = "eon-transparent";
// export const COLOR_WHITE = "eon-white";
// export const COLOR_ULTRALIGHTGREY = "eon-ultralightgrey";
// export const COLOR_LIGHTGREY = "eon-lightgrey";
// export const COLOR_MIDDLEGREY = "eon-middlegrey";
// export const COLOR_DARKGREY = "eon-darkgrey";
// export const COLOR_BLACK = "eon-black";

export const COLOR_PINK500 = "eon-pink500";
export const COLOR_PINK700 = "eon-pink700";
export const COLOR_PURPLE500 = "eon-purple500";
export const COLOR_ORANGE500 = "eon-orange500";
export const COLOR_YELLOW500 = "eon-yellow500";
export const COLOR_BLUE500 = "eon-blue500";
export const COLOR_BLUE700 = "eon-blue700";
export const COLOR_BLUE900 = "eon-blue900";
export const COLOR_BRIGHTBLUE500 = "eon-brightblue500";
export const COLOR_GREEN500 = "eon-green500";
export const COLOR_GREEN900 = "eon-green900";
export const COLOR_BRIGHTGREEN500 = "eon-brightgreen500";
export const COLOR_PINK = "eon-pink";
export const COLOR_DARK_PINK = "eon-dark-pink";
export const COLOR_BRIGHT_BLUE = "eon-bright-blue";
export const COLOR_CYAN = "eon-cyan";
export const COLOR_DARKBLUE = "eon-darkblue";
export const COLOR_RED = "eon-red";
export const COLOR_YELLOW = "eon-yellow";
export const COLOR_GREEN = "eon-green";
export const COLOR_WHITE = "eon-white";
export const COLOR_BRIGHT = "eon-bright";
export const COLOR_DARK = "eon-dark";
export const COLOR_DARK900 = "eon-dark900";
export const COLOR_DARK700 = "eon-dark700";
export const COLOR_DARK600 = "eon-dark600";
export const COLOR_DARK400 = "eon-dark400";
export const COLOR_DARK300 = "eon-dark300";
export const COLOR_DARK100 = "eon-dark100";
export const COLOR_BLUE = "eon-blue";
export const COLOR_ULTRALIGHTGREY = "eon-ultralightgrey";
export const COLOR_LIGHT_GREEN = "eon-light-green";
export const COLOR_LIGHT_RED = "eon-light-red";
export const COLOR_LIGHT_YELLOW = "eon-light-yellow";
export const COLOR_LIGHT_BLUE = "eon-light-blue";
export const COLOR_PINK500_FONT = "eon-pink500-font";
export const COLOR_PINK700_FONT = "eon-pink700-font";
export const COLOR_PURPLE500_FONT = "eon-purple500-font";
export const COLOR_ORANGE500_FONT = "eon-orange500-font";
export const COLOR_YELLOW500_FONT = "eon-yellow500-font";
export const COLOR_BLUE500_FONT = "eon-blue500-font";
export const COLOR_BLUE700_FONT = "eon-blue700-font";
export const COLOR_BLUE900_FONT = "eon-blue900-font";
export const COLOR_BRIGHTBLUE500_FONT = "eon-brightblue500-font";
export const COLOR_GREEN500_FONT = "eon-green500-font";
export const COLOR_GREEN900_FONT = "eon-green900-font";
export const COLOR_BRIGHTGREEN500_FONT = "eon-brightgreen500-font";
export const COLOR_PINK_FONT = "eon-pink-font";
export const COLOR_DARK_PINK_FONT = "eon-dark-pink-font";
export const COLOR_BRIGHT_BLUE_FONT = "eon-bright-blue-font";
export const COLOR_CYAN_FONT = "eon-cyan-font";
export const COLOR_DARKBLUE_FONT = "eon-darkblue-font";
export const COLOR_RED_FONT = "eon-red-font";
export const COLOR_YELLOW_FONT = "eon-yellow-font";
export const COLOR_GREEN_FONT = "eon-green-font";
export const COLOR_WHITE_FONT = "eon-white-font";
export const COLOR_BRIGHT_FONT = "eon-bright-font";
export const COLOR_DARK_FONT = "eon-dark-font";
export const COLOR_DARK900_FONT = "eon-dark900-font";
export const COLOR_DARK700_FONT = "eon-dark700-font";
export const COLOR_DARK600_FONT = "eon-dark600-font";
export const COLOR_DARK400_FONT = "eon-dark400-font";
export const COLOR_DARK300_FONT = "eon-dark300-font";
export const COLOR_DARK100_FONT = "eon-dark100-font";
export const COLOR_BLUE_FONT = "eon-blue-font";
export const COLOR_ULTRALIGHTGREY_FONT = "eon-ultralightgrey-font";
export const COLOR_LIGHT_GREEN_FONT = "eon-light-green-font";
export const COLOR_LIGHT_RED_FONT = "eon-light-red-font";
export const COLOR_LIGHT_YELLOW_FONT = "eon-light-yellow-font";
export const COLOR_LIGHT_BLUE_FONT = "eon-light-blue-font";
export const COLOR_GREY_BLUE = "eon-grey-blue";
export const COLOR_LIGHTER_BLUE = "eon-lighter-blue";
export const COLOR_BRIGHT_YELLOW = "eon-bright-yellow";
export const COLOR_DARK_YELLOW = "eon-dark-yellow";
export const COLOR_DARK_YELLOW_ACTIVE = "eon-dark-yellow-active";
export const COLOR_MIDDLEGREY = "eon-middlegrey";
export const COLOR_DARKGREY = "eon-darkgrey";
export const COLOR_LIGHTGREY = "eon-lightgrey";
export const COLOR_PINK_ACTIVE = "eon-pink-active";
export const COLOR_TAB_BORDER_COLOR = "eon-tab-border-color";
export const COLOR_SYSTEM_SUCCESS_LIGHT = "eon-system-success-light";
export const COLOR_SYSTEM_SUCCESS = "eon-system-success";
export const COLOR_SYSTEM_WARNING_LIGHT = "eon-system-warning-light";
export const COLOR_SYSTEM_WARNING = "eon-system-warning";
export const COLOR_SYSTEM_ERROR_LIGHT = "eon-system-error-light";
export const COLOR_SYSTEM_ERROR = "eon-system-error";
export const COLOR_SYSTEM_HIGHLIGHT = "eon-system-highlight";
export const COLOR_PINK500_SHADE_1 = "eon-pink500-shade-1";
export const COLOR_PINK500_SHADE_2 = "eon-pink500-shade-2";
export const COLOR_PINK500_TINT_1 = "eon-pink500-tint-1";
export const COLOR_PINK500_TINT_2 = "eon-pink500-tint-2";
export const COLOR_PINK500_5 = "eon-pink500-5";
export const COLOR_PINK500_10 = "eon-pink500-10";
export const COLOR_PINK500_15 = "eon-pink500-15";
export const COLOR_PINK500_20 = "eon-pink500-20";
export const COLOR_PINK500_25 = "eon-pink500-25";
export const COLOR_PINK500_30 = "eon-pink500-30";
export const COLOR_PINK500_35 = "eon-pink500-35";
export const COLOR_PINK500_40 = "eon-pink500-40";
export const COLOR_PINK500_45 = "eon-pink500-45";
export const COLOR_PINK500_50 = "eon-pink500-50";
export const COLOR_PINK500_55 = "eon-pink500-55";
export const COLOR_PINK500_60 = "eon-pink500-60";
export const COLOR_PINK500_65 = "eon-pink500-65";
export const COLOR_PINK500_70 = "eon-pink500-70";
export const COLOR_PINK500_75 = "eon-pink500-75";
export const COLOR_PINK500_80 = "eon-pink500-80";
export const COLOR_PINK500_85 = "eon-pink500-85";
export const COLOR_PINK500_90 = "eon-pink500-90";
export const COLOR_PINK500_95 = "eon-pink500-95";
export const COLOR_PINK500_OPACITY_5 = "eon-pink500-opacity-5";
export const COLOR_PINK500_OPACITY_10 = "eon-pink500-opacity-10";
export const COLOR_PINK500_OPACITY_15 = "eon-pink500-opacity-15";
export const COLOR_PINK500_OPACITY_20 = "eon-pink500-opacity-20";
export const COLOR_PINK500_OPACITY_25 = "eon-pink500-opacity-25";
export const COLOR_PINK500_OPACITY_30 = "eon-pink500-opacity-30";
export const COLOR_PINK500_OPACITY_35 = "eon-pink500-opacity-35";
export const COLOR_PINK500_OPACITY_40 = "eon-pink500-opacity-40";
export const COLOR_PINK500_OPACITY_45 = "eon-pink500-opacity-45";
export const COLOR_PINK500_OPACITY_50 = "eon-pink500-opacity-50";
export const COLOR_PINK500_OPACITY_55 = "eon-pink500-opacity-55";
export const COLOR_PINK500_OPACITY_60 = "eon-pink500-opacity-60";
export const COLOR_PINK500_OPACITY_65 = "eon-pink500-opacity-65";
export const COLOR_PINK500_OPACITY_70 = "eon-pink500-opacity-70";
export const COLOR_PINK500_OPACITY_75 = "eon-pink500-opacity-75";
export const COLOR_PINK500_OPACITY_80 = "eon-pink500-opacity-80";
export const COLOR_PINK500_OPACITY_85 = "eon-pink500-opacity-85";
export const COLOR_PINK500_OPACITY_90 = "eon-pink500-opacity-90";
export const COLOR_PINK500_OPACITY_95 = "eon-pink500-opacity-95";
export const COLOR_PINK700_SHADE_1 = "eon-pink700-shade-1";
export const COLOR_PINK700_SHADE_2 = "eon-pink700-shade-2";
export const COLOR_PINK700_TINT_1 = "eon-pink700-tint-1";
export const COLOR_PINK700_TINT_2 = "eon-pink700-tint-2";
export const COLOR_PINK700_5 = "eon-pink700-5";
export const COLOR_PINK700_10 = "eon-pink700-10";
export const COLOR_PINK700_15 = "eon-pink700-15";
export const COLOR_PINK700_20 = "eon-pink700-20";
export const COLOR_PINK700_25 = "eon-pink700-25";
export const COLOR_PINK700_30 = "eon-pink700-30";
export const COLOR_PINK700_35 = "eon-pink700-35";
export const COLOR_PINK700_40 = "eon-pink700-40";
export const COLOR_PINK700_45 = "eon-pink700-45";
export const COLOR_PINK700_50 = "eon-pink700-50";
export const COLOR_PINK700_55 = "eon-pink700-55";
export const COLOR_PINK700_60 = "eon-pink700-60";
export const COLOR_PINK700_65 = "eon-pink700-65";
export const COLOR_PINK700_70 = "eon-pink700-70";
export const COLOR_PINK700_75 = "eon-pink700-75";
export const COLOR_PINK700_80 = "eon-pink700-80";
export const COLOR_PINK700_85 = "eon-pink700-85";
export const COLOR_PINK700_90 = "eon-pink700-90";
export const COLOR_PINK700_95 = "eon-pink700-95";
export const COLOR_PINK700_OPACITY_5 = "eon-pink700-opacity-5";
export const COLOR_PINK700_OPACITY_10 = "eon-pink700-opacity-10";
export const COLOR_PINK700_OPACITY_15 = "eon-pink700-opacity-15";
export const COLOR_PINK700_OPACITY_20 = "eon-pink700-opacity-20";
export const COLOR_PINK700_OPACITY_25 = "eon-pink700-opacity-25";
export const COLOR_PINK700_OPACITY_30 = "eon-pink700-opacity-30";
export const COLOR_PINK700_OPACITY_35 = "eon-pink700-opacity-35";
export const COLOR_PINK700_OPACITY_40 = "eon-pink700-opacity-40";
export const COLOR_PINK700_OPACITY_45 = "eon-pink700-opacity-45";
export const COLOR_PINK700_OPACITY_50 = "eon-pink700-opacity-50";
export const COLOR_PINK700_OPACITY_55 = "eon-pink700-opacity-55";
export const COLOR_PINK700_OPACITY_60 = "eon-pink700-opacity-60";
export const COLOR_PINK700_OPACITY_65 = "eon-pink700-opacity-65";
export const COLOR_PINK700_OPACITY_70 = "eon-pink700-opacity-70";
export const COLOR_PINK700_OPACITY_75 = "eon-pink700-opacity-75";
export const COLOR_PINK700_OPACITY_80 = "eon-pink700-opacity-80";
export const COLOR_PINK700_OPACITY_85 = "eon-pink700-opacity-85";
export const COLOR_PINK700_OPACITY_90 = "eon-pink700-opacity-90";
export const COLOR_PINK700_OPACITY_95 = "eon-pink700-opacity-95";
export const COLOR_PURPLE500_SHADE_1 = "eon-purple500-shade-1";
export const COLOR_PURPLE500_SHADE_2 = "eon-purple500-shade-2";
export const COLOR_PURPLE500_TINT_1 = "eon-purple500-tint-1";
export const COLOR_PURPLE500_TINT_2 = "eon-purple500-tint-2";
export const COLOR_PURPLE500_5 = "eon-purple500-5";
export const COLOR_PURPLE500_10 = "eon-purple500-10";
export const COLOR_PURPLE500_15 = "eon-purple500-15";
export const COLOR_PURPLE500_20 = "eon-purple500-20";
export const COLOR_PURPLE500_25 = "eon-purple500-25";
export const COLOR_PURPLE500_30 = "eon-purple500-30";
export const COLOR_PURPLE500_35 = "eon-purple500-35";
export const COLOR_PURPLE500_40 = "eon-purple500-40";
export const COLOR_PURPLE500_45 = "eon-purple500-45";
export const COLOR_PURPLE500_50 = "eon-purple500-50";
export const COLOR_PURPLE500_55 = "eon-purple500-55";
export const COLOR_PURPLE500_60 = "eon-purple500-60";
export const COLOR_PURPLE500_65 = "eon-purple500-65";
export const COLOR_PURPLE500_70 = "eon-purple500-70";
export const COLOR_PURPLE500_75 = "eon-purple500-75";
export const COLOR_PURPLE500_80 = "eon-purple500-80";
export const COLOR_PURPLE500_85 = "eon-purple500-85";
export const COLOR_PURPLE500_90 = "eon-purple500-90";
export const COLOR_PURPLE500_95 = "eon-purple500-95";
export const COLOR_PURPLE500_OPACITY_5 = "eon-purple500-opacity-5";
export const COLOR_PURPLE500_OPACITY_10 = "eon-purple500-opacity-10";
export const COLOR_PURPLE500_OPACITY_15 = "eon-purple500-opacity-15";
export const COLOR_PURPLE500_OPACITY_20 = "eon-purple500-opacity-20";
export const COLOR_PURPLE500_OPACITY_25 = "eon-purple500-opacity-25";
export const COLOR_PURPLE500_OPACITY_30 = "eon-purple500-opacity-30";
export const COLOR_PURPLE500_OPACITY_35 = "eon-purple500-opacity-35";
export const COLOR_PURPLE500_OPACITY_40 = "eon-purple500-opacity-40";
export const COLOR_PURPLE500_OPACITY_45 = "eon-purple500-opacity-45";
export const COLOR_PURPLE500_OPACITY_50 = "eon-purple500-opacity-50";
export const COLOR_PURPLE500_OPACITY_55 = "eon-purple500-opacity-55";
export const COLOR_PURPLE500_OPACITY_60 = "eon-purple500-opacity-60";
export const COLOR_PURPLE500_OPACITY_65 = "eon-purple500-opacity-65";
export const COLOR_PURPLE500_OPACITY_70 = "eon-purple500-opacity-70";
export const COLOR_PURPLE500_OPACITY_75 = "eon-purple500-opacity-75";
export const COLOR_PURPLE500_OPACITY_80 = "eon-purple500-opacity-80";
export const COLOR_PURPLE500_OPACITY_85 = "eon-purple500-opacity-85";
export const COLOR_PURPLE500_OPACITY_90 = "eon-purple500-opacity-90";
export const COLOR_PURPLE500_OPACITY_95 = "eon-purple500-opacity-95";
export const COLOR_ORANGE500_SHADE_1 = "eon-orange500-shade-1";
export const COLOR_ORANGE500_SHADE_2 = "eon-orange500-shade-2";
export const COLOR_ORANGE500_TINT_1 = "eon-orange500-tint-1";
export const COLOR_ORANGE500_TINT_2 = "eon-orange500-tint-2";
export const COLOR_ORANGE500_5 = "eon-orange500-5";
export const COLOR_ORANGE500_10 = "eon-orange500-10";
export const COLOR_ORANGE500_15 = "eon-orange500-15";
export const COLOR_ORANGE500_20 = "eon-orange500-20";
export const COLOR_ORANGE500_25 = "eon-orange500-25";
export const COLOR_ORANGE500_30 = "eon-orange500-30";
export const COLOR_ORANGE500_35 = "eon-orange500-35";
export const COLOR_ORANGE500_40 = "eon-orange500-40";
export const COLOR_ORANGE500_45 = "eon-orange500-45";
export const COLOR_ORANGE500_50 = "eon-orange500-50";
export const COLOR_ORANGE500_55 = "eon-orange500-55";
export const COLOR_ORANGE500_60 = "eon-orange500-60";
export const COLOR_ORANGE500_65 = "eon-orange500-65";
export const COLOR_ORANGE500_70 = "eon-orange500-70";
export const COLOR_ORANGE500_75 = "eon-orange500-75";
export const COLOR_ORANGE500_80 = "eon-orange500-80";
export const COLOR_ORANGE500_85 = "eon-orange500-85";
export const COLOR_ORANGE500_90 = "eon-orange500-90";
export const COLOR_ORANGE500_95 = "eon-orange500-95";
export const COLOR_ORANGE500_OPACITY_5 = "eon-orange500-opacity-5";
export const COLOR_ORANGE500_OPACITY_10 = "eon-orange500-opacity-10";
export const COLOR_ORANGE500_OPACITY_15 = "eon-orange500-opacity-15";
export const COLOR_ORANGE500_OPACITY_20 = "eon-orange500-opacity-20";
export const COLOR_ORANGE500_OPACITY_25 = "eon-orange500-opacity-25";
export const COLOR_ORANGE500_OPACITY_30 = "eon-orange500-opacity-30";
export const COLOR_ORANGE500_OPACITY_35 = "eon-orange500-opacity-35";
export const COLOR_ORANGE500_OPACITY_40 = "eon-orange500-opacity-40";
export const COLOR_ORANGE500_OPACITY_45 = "eon-orange500-opacity-45";
export const COLOR_ORANGE500_OPACITY_50 = "eon-orange500-opacity-50";
export const COLOR_ORANGE500_OPACITY_55 = "eon-orange500-opacity-55";
export const COLOR_ORANGE500_OPACITY_60 = "eon-orange500-opacity-60";
export const COLOR_ORANGE500_OPACITY_65 = "eon-orange500-opacity-65";
export const COLOR_ORANGE500_OPACITY_70 = "eon-orange500-opacity-70";
export const COLOR_ORANGE500_OPACITY_75 = "eon-orange500-opacity-75";
export const COLOR_ORANGE500_OPACITY_80 = "eon-orange500-opacity-80";
export const COLOR_ORANGE500_OPACITY_85 = "eon-orange500-opacity-85";
export const COLOR_ORANGE500_OPACITY_90 = "eon-orange500-opacity-90";
export const COLOR_ORANGE500_OPACITY_95 = "eon-orange500-opacity-95";
export const COLOR_YELLOW500_SHADE_1 = "eon-yellow500-shade-1";
export const COLOR_YELLOW500_SHADE_2 = "eon-yellow500-shade-2";
export const COLOR_YELLOW500_TINT_1 = "eon-yellow500-tint-1";
export const COLOR_YELLOW500_TINT_2 = "eon-yellow500-tint-2";
export const COLOR_YELLOW500_5 = "eon-yellow500-5";
export const COLOR_YELLOW500_10 = "eon-yellow500-10";
export const COLOR_YELLOW500_15 = "eon-yellow500-15";
export const COLOR_YELLOW500_20 = "eon-yellow500-20";
export const COLOR_YELLOW500_25 = "eon-yellow500-25";
export const COLOR_YELLOW500_30 = "eon-yellow500-30";
export const COLOR_YELLOW500_35 = "eon-yellow500-35";
export const COLOR_YELLOW500_40 = "eon-yellow500-40";
export const COLOR_YELLOW500_45 = "eon-yellow500-45";
export const COLOR_YELLOW500_50 = "eon-yellow500-50";
export const COLOR_YELLOW500_55 = "eon-yellow500-55";
export const COLOR_YELLOW500_60 = "eon-yellow500-60";
export const COLOR_YELLOW500_65 = "eon-yellow500-65";
export const COLOR_YELLOW500_70 = "eon-yellow500-70";
export const COLOR_YELLOW500_75 = "eon-yellow500-75";
export const COLOR_YELLOW500_80 = "eon-yellow500-80";
export const COLOR_YELLOW500_85 = "eon-yellow500-85";
export const COLOR_YELLOW500_90 = "eon-yellow500-90";
export const COLOR_YELLOW500_95 = "eon-yellow500-95";
export const COLOR_YELLOW500_OPACITY_5 = "eon-yellow500-opacity-5";
export const COLOR_YELLOW500_OPACITY_10 = "eon-yellow500-opacity-10";
export const COLOR_YELLOW500_OPACITY_15 = "eon-yellow500-opacity-15";
export const COLOR_YELLOW500_OPACITY_20 = "eon-yellow500-opacity-20";
export const COLOR_YELLOW500_OPACITY_25 = "eon-yellow500-opacity-25";
export const COLOR_YELLOW500_OPACITY_30 = "eon-yellow500-opacity-30";
export const COLOR_YELLOW500_OPACITY_35 = "eon-yellow500-opacity-35";
export const COLOR_YELLOW500_OPACITY_40 = "eon-yellow500-opacity-40";
export const COLOR_YELLOW500_OPACITY_45 = "eon-yellow500-opacity-45";
export const COLOR_YELLOW500_OPACITY_50 = "eon-yellow500-opacity-50";
export const COLOR_YELLOW500_OPACITY_55 = "eon-yellow500-opacity-55";
export const COLOR_YELLOW500_OPACITY_60 = "eon-yellow500-opacity-60";
export const COLOR_YELLOW500_OPACITY_65 = "eon-yellow500-opacity-65";
export const COLOR_YELLOW500_OPACITY_70 = "eon-yellow500-opacity-70";
export const COLOR_YELLOW500_OPACITY_75 = "eon-yellow500-opacity-75";
export const COLOR_YELLOW500_OPACITY_80 = "eon-yellow500-opacity-80";
export const COLOR_YELLOW500_OPACITY_85 = "eon-yellow500-opacity-85";
export const COLOR_YELLOW500_OPACITY_90 = "eon-yellow500-opacity-90";
export const COLOR_YELLOW500_OPACITY_95 = "eon-yellow500-opacity-95";
export const COLOR_BLUE500_SHADE_1 = "eon-blue500-shade-1";
export const COLOR_BLUE500_SHADE_2 = "eon-blue500-shade-2";
export const COLOR_BLUE500_TINT_1 = "eon-blue500-tint-1";
export const COLOR_BLUE500_TINT_2 = "eon-blue500-tint-2";
export const COLOR_BLUE500_5 = "eon-blue500-5";
export const COLOR_BLUE500_10 = "eon-blue500-10";
export const COLOR_BLUE500_15 = "eon-blue500-15";
export const COLOR_BLUE500_20 = "eon-blue500-20";
export const COLOR_BLUE500_25 = "eon-blue500-25";
export const COLOR_BLUE500_30 = "eon-blue500-30";
export const COLOR_BLUE500_35 = "eon-blue500-35";
export const COLOR_BLUE500_40 = "eon-blue500-40";
export const COLOR_BLUE500_45 = "eon-blue500-45";
export const COLOR_BLUE500_50 = "eon-blue500-50";
export const COLOR_BLUE500_55 = "eon-blue500-55";
export const COLOR_BLUE500_60 = "eon-blue500-60";
export const COLOR_BLUE500_65 = "eon-blue500-65";
export const COLOR_BLUE500_70 = "eon-blue500-70";
export const COLOR_BLUE500_75 = "eon-blue500-75";
export const COLOR_BLUE500_80 = "eon-blue500-80";
export const COLOR_BLUE500_85 = "eon-blue500-85";
export const COLOR_BLUE500_90 = "eon-blue500-90";
export const COLOR_BLUE500_95 = "eon-blue500-95";
export const COLOR_BLUE500_OPACITY_5 = "eon-blue500-opacity-5";
export const COLOR_BLUE500_OPACITY_10 = "eon-blue500-opacity-10";
export const COLOR_BLUE500_OPACITY_15 = "eon-blue500-opacity-15";
export const COLOR_BLUE500_OPACITY_20 = "eon-blue500-opacity-20";
export const COLOR_BLUE500_OPACITY_25 = "eon-blue500-opacity-25";
export const COLOR_BLUE500_OPACITY_30 = "eon-blue500-opacity-30";
export const COLOR_BLUE500_OPACITY_35 = "eon-blue500-opacity-35";
export const COLOR_BLUE500_OPACITY_40 = "eon-blue500-opacity-40";
export const COLOR_BLUE500_OPACITY_45 = "eon-blue500-opacity-45";
export const COLOR_BLUE500_OPACITY_50 = "eon-blue500-opacity-50";
export const COLOR_BLUE500_OPACITY_55 = "eon-blue500-opacity-55";
export const COLOR_BLUE500_OPACITY_60 = "eon-blue500-opacity-60";
export const COLOR_BLUE500_OPACITY_65 = "eon-blue500-opacity-65";
export const COLOR_BLUE500_OPACITY_70 = "eon-blue500-opacity-70";
export const COLOR_BLUE500_OPACITY_75 = "eon-blue500-opacity-75";
export const COLOR_BLUE500_OPACITY_80 = "eon-blue500-opacity-80";
export const COLOR_BLUE500_OPACITY_85 = "eon-blue500-opacity-85";
export const COLOR_BLUE500_OPACITY_90 = "eon-blue500-opacity-90";
export const COLOR_BLUE500_OPACITY_95 = "eon-blue500-opacity-95";
export const COLOR_BLUE700_SHADE_1 = "eon-blue700-shade-1";
export const COLOR_BLUE700_SHADE_2 = "eon-blue700-shade-2";
export const COLOR_BLUE700_TINT_1 = "eon-blue700-tint-1";
export const COLOR_BLUE700_TINT_2 = "eon-blue700-tint-2";
export const COLOR_BLUE700_5 = "eon-blue700-5";
export const COLOR_BLUE700_10 = "eon-blue700-10";
export const COLOR_BLUE700_15 = "eon-blue700-15";
export const COLOR_BLUE700_20 = "eon-blue700-20";
export const COLOR_BLUE700_25 = "eon-blue700-25";
export const COLOR_BLUE700_30 = "eon-blue700-30";
export const COLOR_BLUE700_35 = "eon-blue700-35";
export const COLOR_BLUE700_40 = "eon-blue700-40";
export const COLOR_BLUE700_45 = "eon-blue700-45";
export const COLOR_BLUE700_50 = "eon-blue700-50";
export const COLOR_BLUE700_55 = "eon-blue700-55";
export const COLOR_BLUE700_60 = "eon-blue700-60";
export const COLOR_BLUE700_65 = "eon-blue700-65";
export const COLOR_BLUE700_70 = "eon-blue700-70";
export const COLOR_BLUE700_75 = "eon-blue700-75";
export const COLOR_BLUE700_80 = "eon-blue700-80";
export const COLOR_BLUE700_85 = "eon-blue700-85";
export const COLOR_BLUE700_90 = "eon-blue700-90";
export const COLOR_BLUE700_95 = "eon-blue700-95";
export const COLOR_BLUE700_OPACITY_5 = "eon-blue700-opacity-5";
export const COLOR_BLUE700_OPACITY_10 = "eon-blue700-opacity-10";
export const COLOR_BLUE700_OPACITY_15 = "eon-blue700-opacity-15";
export const COLOR_BLUE700_OPACITY_20 = "eon-blue700-opacity-20";
export const COLOR_BLUE700_OPACITY_25 = "eon-blue700-opacity-25";
export const COLOR_BLUE700_OPACITY_30 = "eon-blue700-opacity-30";
export const COLOR_BLUE700_OPACITY_35 = "eon-blue700-opacity-35";
export const COLOR_BLUE700_OPACITY_40 = "eon-blue700-opacity-40";
export const COLOR_BLUE700_OPACITY_45 = "eon-blue700-opacity-45";
export const COLOR_BLUE700_OPACITY_50 = "eon-blue700-opacity-50";
export const COLOR_BLUE700_OPACITY_55 = "eon-blue700-opacity-55";
export const COLOR_BLUE700_OPACITY_60 = "eon-blue700-opacity-60";
export const COLOR_BLUE700_OPACITY_65 = "eon-blue700-opacity-65";
export const COLOR_BLUE700_OPACITY_70 = "eon-blue700-opacity-70";
export const COLOR_BLUE700_OPACITY_75 = "eon-blue700-opacity-75";
export const COLOR_BLUE700_OPACITY_80 = "eon-blue700-opacity-80";
export const COLOR_BLUE700_OPACITY_85 = "eon-blue700-opacity-85";
export const COLOR_BLUE700_OPACITY_90 = "eon-blue700-opacity-90";
export const COLOR_BLUE700_OPACITY_95 = "eon-blue700-opacity-95";
export const COLOR_BLUE900_SHADE_1 = "eon-blue900-shade-1";
export const COLOR_BLUE900_SHADE_2 = "eon-blue900-shade-2";
export const COLOR_BLUE900_TINT_1 = "eon-blue900-tint-1";
export const COLOR_BLUE900_TINT_2 = "eon-blue900-tint-2";
export const COLOR_BLUE900_5 = "eon-blue900-5";
export const COLOR_BLUE900_10 = "eon-blue900-10";
export const COLOR_BLUE900_15 = "eon-blue900-15";
export const COLOR_BLUE900_20 = "eon-blue900-20";
export const COLOR_BLUE900_25 = "eon-blue900-25";
export const COLOR_BLUE900_30 = "eon-blue900-30";
export const COLOR_BLUE900_35 = "eon-blue900-35";
export const COLOR_BLUE900_40 = "eon-blue900-40";
export const COLOR_BLUE900_45 = "eon-blue900-45";
export const COLOR_BLUE900_50 = "eon-blue900-50";
export const COLOR_BLUE900_55 = "eon-blue900-55";
export const COLOR_BLUE900_60 = "eon-blue900-60";
export const COLOR_BLUE900_65 = "eon-blue900-65";
export const COLOR_BLUE900_70 = "eon-blue900-70";
export const COLOR_BLUE900_75 = "eon-blue900-75";
export const COLOR_BLUE900_80 = "eon-blue900-80";
export const COLOR_BLUE900_85 = "eon-blue900-85";
export const COLOR_BLUE900_90 = "eon-blue900-90";
export const COLOR_BLUE900_95 = "eon-blue900-95";
export const COLOR_BLUE900_OPACITY_5 = "eon-blue900-opacity-5";
export const COLOR_BLUE900_OPACITY_10 = "eon-blue900-opacity-10";
export const COLOR_BLUE900_OPACITY_15 = "eon-blue900-opacity-15";
export const COLOR_BLUE900_OPACITY_20 = "eon-blue900-opacity-20";
export const COLOR_BLUE900_OPACITY_25 = "eon-blue900-opacity-25";
export const COLOR_BLUE900_OPACITY_30 = "eon-blue900-opacity-30";
export const COLOR_BLUE900_OPACITY_35 = "eon-blue900-opacity-35";
export const COLOR_BLUE900_OPACITY_40 = "eon-blue900-opacity-40";
export const COLOR_BLUE900_OPACITY_45 = "eon-blue900-opacity-45";
export const COLOR_BLUE900_OPACITY_50 = "eon-blue900-opacity-50";
export const COLOR_BLUE900_OPACITY_55 = "eon-blue900-opacity-55";
export const COLOR_BLUE900_OPACITY_60 = "eon-blue900-opacity-60";
export const COLOR_BLUE900_OPACITY_65 = "eon-blue900-opacity-65";
export const COLOR_BLUE900_OPACITY_70 = "eon-blue900-opacity-70";
export const COLOR_BLUE900_OPACITY_75 = "eon-blue900-opacity-75";
export const COLOR_BLUE900_OPACITY_80 = "eon-blue900-opacity-80";
export const COLOR_BLUE900_OPACITY_85 = "eon-blue900-opacity-85";
export const COLOR_BLUE900_OPACITY_90 = "eon-blue900-opacity-90";
export const COLOR_BLUE900_OPACITY_95 = "eon-blue900-opacity-95";
export const COLOR_BRIGHTBLUE500_SHADE_1 = "eon-brightblue500-shade-1";
export const COLOR_BRIGHTBLUE500_SHADE_2 = "eon-brightblue500-shade-2";
export const COLOR_BRIGHTBLUE500_TINT_1 = "eon-brightblue500-tint-1";
export const COLOR_BRIGHTBLUE500_TINT_2 = "eon-brightblue500-tint-2";
export const COLOR_BRIGHTBLUE500_5 = "eon-brightblue500-5";
export const COLOR_BRIGHTBLUE500_10 = "eon-brightblue500-10";
export const COLOR_BRIGHTBLUE500_15 = "eon-brightblue500-15";
export const COLOR_BRIGHTBLUE500_20 = "eon-brightblue500-20";
export const COLOR_BRIGHTBLUE500_25 = "eon-brightblue500-25";
export const COLOR_BRIGHTBLUE500_30 = "eon-brightblue500-30";
export const COLOR_BRIGHTBLUE500_35 = "eon-brightblue500-35";
export const COLOR_BRIGHTBLUE500_40 = "eon-brightblue500-40";
export const COLOR_BRIGHTBLUE500_45 = "eon-brightblue500-45";
export const COLOR_BRIGHTBLUE500_50 = "eon-brightblue500-50";
export const COLOR_BRIGHTBLUE500_55 = "eon-brightblue500-55";
export const COLOR_BRIGHTBLUE500_60 = "eon-brightblue500-60";
export const COLOR_BRIGHTBLUE500_65 = "eon-brightblue500-65";
export const COLOR_BRIGHTBLUE500_70 = "eon-brightblue500-70";
export const COLOR_BRIGHTBLUE500_75 = "eon-brightblue500-75";
export const COLOR_BRIGHTBLUE500_80 = "eon-brightblue500-80";
export const COLOR_BRIGHTBLUE500_85 = "eon-brightblue500-85";
export const COLOR_BRIGHTBLUE500_90 = "eon-brightblue500-90";
export const COLOR_BRIGHTBLUE500_95 = "eon-brightblue500-95";
export const COLOR_BRIGHTBLUE500_OPACITY_5 = "eon-brightblue500-opacity-5";
export const COLOR_BRIGHTBLUE500_OPACITY_10 = "eon-brightblue500-opacity-10";
export const COLOR_BRIGHTBLUE500_OPACITY_15 = "eon-brightblue500-opacity-15";
export const COLOR_BRIGHTBLUE500_OPACITY_20 = "eon-brightblue500-opacity-20";
export const COLOR_BRIGHTBLUE500_OPACITY_25 = "eon-brightblue500-opacity-25";
export const COLOR_BRIGHTBLUE500_OPACITY_30 = "eon-brightblue500-opacity-30";
export const COLOR_BRIGHTBLUE500_OPACITY_35 = "eon-brightblue500-opacity-35";
export const COLOR_BRIGHTBLUE500_OPACITY_40 = "eon-brightblue500-opacity-40";
export const COLOR_BRIGHTBLUE500_OPACITY_45 = "eon-brightblue500-opacity-45";
export const COLOR_BRIGHTBLUE500_OPACITY_50 = "eon-brightblue500-opacity-50";
export const COLOR_BRIGHTBLUE500_OPACITY_55 = "eon-brightblue500-opacity-55";
export const COLOR_BRIGHTBLUE500_OPACITY_60 = "eon-brightblue500-opacity-60";
export const COLOR_BRIGHTBLUE500_OPACITY_65 = "eon-brightblue500-opacity-65";
export const COLOR_BRIGHTBLUE500_OPACITY_70 = "eon-brightblue500-opacity-70";
export const COLOR_BRIGHTBLUE500_OPACITY_75 = "eon-brightblue500-opacity-75";
export const COLOR_BRIGHTBLUE500_OPACITY_80 = "eon-brightblue500-opacity-80";
export const COLOR_BRIGHTBLUE500_OPACITY_85 = "eon-brightblue500-opacity-85";
export const COLOR_BRIGHTBLUE500_OPACITY_90 = "eon-brightblue500-opacity-90";
export const COLOR_BRIGHTBLUE500_OPACITY_95 = "eon-brightblue500-opacity-95";
export const COLOR_GREEN500_SHADE_1 = "eon-green500-shade-1";
export const COLOR_GREEN500_SHADE_2 = "eon-green500-shade-2";
export const COLOR_GREEN500_TINT_1 = "eon-green500-tint-1";
export const COLOR_GREEN500_TINT_2 = "eon-green500-tint-2";
export const COLOR_GREEN500_5 = "eon-green500-5";
export const COLOR_GREEN500_10 = "eon-green500-10";
export const COLOR_GREEN500_15 = "eon-green500-15";
export const COLOR_GREEN500_20 = "eon-green500-20";
export const COLOR_GREEN500_25 = "eon-green500-25";
export const COLOR_GREEN500_30 = "eon-green500-30";
export const COLOR_GREEN500_35 = "eon-green500-35";
export const COLOR_GREEN500_40 = "eon-green500-40";
export const COLOR_GREEN500_45 = "eon-green500-45";
export const COLOR_GREEN500_50 = "eon-green500-50";
export const COLOR_GREEN500_55 = "eon-green500-55";
export const COLOR_GREEN500_60 = "eon-green500-60";
export const COLOR_GREEN500_65 = "eon-green500-65";
export const COLOR_GREEN500_70 = "eon-green500-70";
export const COLOR_GREEN500_75 = "eon-green500-75";
export const COLOR_GREEN500_80 = "eon-green500-80";
export const COLOR_GREEN500_85 = "eon-green500-85";
export const COLOR_GREEN500_90 = "eon-green500-90";
export const COLOR_GREEN500_95 = "eon-green500-95";
export const COLOR_GREEN500_OPACITY_5 = "eon-green500-opacity-5";
export const COLOR_GREEN500_OPACITY_10 = "eon-green500-opacity-10";
export const COLOR_GREEN500_OPACITY_15 = "eon-green500-opacity-15";
export const COLOR_GREEN500_OPACITY_20 = "eon-green500-opacity-20";
export const COLOR_GREEN500_OPACITY_25 = "eon-green500-opacity-25";
export const COLOR_GREEN500_OPACITY_30 = "eon-green500-opacity-30";
export const COLOR_GREEN500_OPACITY_35 = "eon-green500-opacity-35";
export const COLOR_GREEN500_OPACITY_40 = "eon-green500-opacity-40";
export const COLOR_GREEN500_OPACITY_45 = "eon-green500-opacity-45";
export const COLOR_GREEN500_OPACITY_50 = "eon-green500-opacity-50";
export const COLOR_GREEN500_OPACITY_55 = "eon-green500-opacity-55";
export const COLOR_GREEN500_OPACITY_60 = "eon-green500-opacity-60";
export const COLOR_GREEN500_OPACITY_65 = "eon-green500-opacity-65";
export const COLOR_GREEN500_OPACITY_70 = "eon-green500-opacity-70";
export const COLOR_GREEN500_OPACITY_75 = "eon-green500-opacity-75";
export const COLOR_GREEN500_OPACITY_80 = "eon-green500-opacity-80";
export const COLOR_GREEN500_OPACITY_85 = "eon-green500-opacity-85";
export const COLOR_GREEN500_OPACITY_90 = "eon-green500-opacity-90";
export const COLOR_GREEN500_OPACITY_95 = "eon-green500-opacity-95";
export const COLOR_GREEN900_SHADE_1 = "eon-green900-shade-1";
export const COLOR_GREEN900_SHADE_2 = "eon-green900-shade-2";
export const COLOR_GREEN900_TINT_1 = "eon-green900-tint-1";
export const COLOR_GREEN900_TINT_2 = "eon-green900-tint-2";
export const COLOR_GREEN900_5 = "eon-green900-5";
export const COLOR_GREEN900_10 = "eon-green900-10";
export const COLOR_GREEN900_15 = "eon-green900-15";
export const COLOR_GREEN900_20 = "eon-green900-20";
export const COLOR_GREEN900_25 = "eon-green900-25";
export const COLOR_GREEN900_30 = "eon-green900-30";
export const COLOR_GREEN900_35 = "eon-green900-35";
export const COLOR_GREEN900_40 = "eon-green900-40";
export const COLOR_GREEN900_45 = "eon-green900-45";
export const COLOR_GREEN900_50 = "eon-green900-50";
export const COLOR_GREEN900_55 = "eon-green900-55";
export const COLOR_GREEN900_60 = "eon-green900-60";
export const COLOR_GREEN900_65 = "eon-green900-65";
export const COLOR_GREEN900_70 = "eon-green900-70";
export const COLOR_GREEN900_75 = "eon-green900-75";
export const COLOR_GREEN900_80 = "eon-green900-80";
export const COLOR_GREEN900_85 = "eon-green900-85";
export const COLOR_GREEN900_90 = "eon-green900-90";
export const COLOR_GREEN900_95 = "eon-green900-95";
export const COLOR_GREEN900_OPACITY_5 = "eon-green900-opacity-5";
export const COLOR_GREEN900_OPACITY_10 = "eon-green900-opacity-10";
export const COLOR_GREEN900_OPACITY_15 = "eon-green900-opacity-15";
export const COLOR_GREEN900_OPACITY_20 = "eon-green900-opacity-20";
export const COLOR_GREEN900_OPACITY_25 = "eon-green900-opacity-25";
export const COLOR_GREEN900_OPACITY_30 = "eon-green900-opacity-30";
export const COLOR_GREEN900_OPACITY_35 = "eon-green900-opacity-35";
export const COLOR_GREEN900_OPACITY_40 = "eon-green900-opacity-40";
export const COLOR_GREEN900_OPACITY_45 = "eon-green900-opacity-45";
export const COLOR_GREEN900_OPACITY_50 = "eon-green900-opacity-50";
export const COLOR_GREEN900_OPACITY_55 = "eon-green900-opacity-55";
export const COLOR_GREEN900_OPACITY_60 = "eon-green900-opacity-60";
export const COLOR_GREEN900_OPACITY_65 = "eon-green900-opacity-65";
export const COLOR_GREEN900_OPACITY_70 = "eon-green900-opacity-70";
export const COLOR_GREEN900_OPACITY_75 = "eon-green900-opacity-75";
export const COLOR_GREEN900_OPACITY_80 = "eon-green900-opacity-80";
export const COLOR_GREEN900_OPACITY_85 = "eon-green900-opacity-85";
export const COLOR_GREEN900_OPACITY_90 = "eon-green900-opacity-90";
export const COLOR_GREEN900_OPACITY_95 = "eon-green900-opacity-95";
export const COLOR_BRIGHTGREEN500_SHADE_1 = "eon-brightgreen500-shade-1";
export const COLOR_BRIGHTGREEN500_SHADE_2 = "eon-brightgreen500-shade-2";
export const COLOR_BRIGHTGREEN500_TINT_1 = "eon-brightgreen500-tint-1";
export const COLOR_BRIGHTGREEN500_TINT_2 = "eon-brightgreen500-tint-2";
export const COLOR_BRIGHTGREEN500_5 = "eon-brightgreen500-5";
export const COLOR_BRIGHTGREEN500_10 = "eon-brightgreen500-10";
export const COLOR_BRIGHTGREEN500_15 = "eon-brightgreen500-15";
export const COLOR_BRIGHTGREEN500_20 = "eon-brightgreen500-20";
export const COLOR_BRIGHTGREEN500_25 = "eon-brightgreen500-25";
export const COLOR_BRIGHTGREEN500_30 = "eon-brightgreen500-30";
export const COLOR_BRIGHTGREEN500_35 = "eon-brightgreen500-35";
export const COLOR_BRIGHTGREEN500_40 = "eon-brightgreen500-40";
export const COLOR_BRIGHTGREEN500_45 = "eon-brightgreen500-45";
export const COLOR_BRIGHTGREEN500_50 = "eon-brightgreen500-50";
export const COLOR_BRIGHTGREEN500_55 = "eon-brightgreen500-55";
export const COLOR_BRIGHTGREEN500_60 = "eon-brightgreen500-60";
export const COLOR_BRIGHTGREEN500_65 = "eon-brightgreen500-65";
export const COLOR_BRIGHTGREEN500_70 = "eon-brightgreen500-70";
export const COLOR_BRIGHTGREEN500_75 = "eon-brightgreen500-75";
export const COLOR_BRIGHTGREEN500_80 = "eon-brightgreen500-80";
export const COLOR_BRIGHTGREEN500_85 = "eon-brightgreen500-85";
export const COLOR_BRIGHTGREEN500_90 = "eon-brightgreen500-90";
export const COLOR_BRIGHTGREEN500_95 = "eon-brightgreen500-95";
export const COLOR_BRIGHTGREEN500_OPACITY_5 = "eon-brightgreen500-opacity-5";
export const COLOR_BRIGHTGREEN500_OPACITY_10 = "eon-brightgreen500-opacity-10";
export const COLOR_BRIGHTGREEN500_OPACITY_15 = "eon-brightgreen500-opacity-15";
export const COLOR_BRIGHTGREEN500_OPACITY_20 = "eon-brightgreen500-opacity-20";
export const COLOR_BRIGHTGREEN500_OPACITY_25 = "eon-brightgreen500-opacity-25";
export const COLOR_BRIGHTGREEN500_OPACITY_30 = "eon-brightgreen500-opacity-30";
export const COLOR_BRIGHTGREEN500_OPACITY_35 = "eon-brightgreen500-opacity-35";
export const COLOR_BRIGHTGREEN500_OPACITY_40 = "eon-brightgreen500-opacity-40";
export const COLOR_BRIGHTGREEN500_OPACITY_45 = "eon-brightgreen500-opacity-45";
export const COLOR_BRIGHTGREEN500_OPACITY_50 = "eon-brightgreen500-opacity-50";
export const COLOR_BRIGHTGREEN500_OPACITY_55 = "eon-brightgreen500-opacity-55";
export const COLOR_BRIGHTGREEN500_OPACITY_60 = "eon-brightgreen500-opacity-60";
export const COLOR_BRIGHTGREEN500_OPACITY_65 = "eon-brightgreen500-opacity-65";
export const COLOR_BRIGHTGREEN500_OPACITY_70 = "eon-brightgreen500-opacity-70";
export const COLOR_BRIGHTGREEN500_OPACITY_75 = "eon-brightgreen500-opacity-75";
export const COLOR_BRIGHTGREEN500_OPACITY_80 = "eon-brightgreen500-opacity-80";
export const COLOR_BRIGHTGREEN500_OPACITY_85 = "eon-brightgreen500-opacity-85";
export const COLOR_BRIGHTGREEN500_OPACITY_90 = "eon-brightgreen500-opacity-90";
export const COLOR_BRIGHTGREEN500_OPACITY_95 = "eon-brightgreen500-opacity-95";
export const COLOR_PINK_SHADE_1 = "eon-pink-shade-1";
export const COLOR_PINK_SHADE_2 = "eon-pink-shade-2";
export const COLOR_PINK_TINT_1 = "eon-pink-tint-1";
export const COLOR_PINK_TINT_2 = "eon-pink-tint-2";
export const COLOR_PINK_5 = "eon-pink-5";
export const COLOR_PINK_10 = "eon-pink-10";
export const COLOR_PINK_15 = "eon-pink-15";
export const COLOR_PINK_20 = "eon-pink-20";
export const COLOR_PINK_25 = "eon-pink-25";
export const COLOR_PINK_30 = "eon-pink-30";
export const COLOR_PINK_35 = "eon-pink-35";
export const COLOR_PINK_40 = "eon-pink-40";
export const COLOR_PINK_45 = "eon-pink-45";
export const COLOR_PINK_50 = "eon-pink-50";
export const COLOR_PINK_55 = "eon-pink-55";
export const COLOR_PINK_60 = "eon-pink-60";
export const COLOR_PINK_65 = "eon-pink-65";
export const COLOR_PINK_70 = "eon-pink-70";
export const COLOR_PINK_75 = "eon-pink-75";
export const COLOR_PINK_80 = "eon-pink-80";
export const COLOR_PINK_85 = "eon-pink-85";
export const COLOR_PINK_90 = "eon-pink-90";
export const COLOR_PINK_95 = "eon-pink-95";
export const COLOR_PINK_OPACITY_5 = "eon-pink-opacity-5";
export const COLOR_PINK_OPACITY_10 = "eon-pink-opacity-10";
export const COLOR_PINK_OPACITY_15 = "eon-pink-opacity-15";
export const COLOR_PINK_OPACITY_20 = "eon-pink-opacity-20";
export const COLOR_PINK_OPACITY_25 = "eon-pink-opacity-25";
export const COLOR_PINK_OPACITY_30 = "eon-pink-opacity-30";
export const COLOR_PINK_OPACITY_35 = "eon-pink-opacity-35";
export const COLOR_PINK_OPACITY_40 = "eon-pink-opacity-40";
export const COLOR_PINK_OPACITY_45 = "eon-pink-opacity-45";
export const COLOR_PINK_OPACITY_50 = "eon-pink-opacity-50";
export const COLOR_PINK_OPACITY_55 = "eon-pink-opacity-55";
export const COLOR_PINK_OPACITY_60 = "eon-pink-opacity-60";
export const COLOR_PINK_OPACITY_65 = "eon-pink-opacity-65";
export const COLOR_PINK_OPACITY_70 = "eon-pink-opacity-70";
export const COLOR_PINK_OPACITY_75 = "eon-pink-opacity-75";
export const COLOR_PINK_OPACITY_80 = "eon-pink-opacity-80";
export const COLOR_PINK_OPACITY_85 = "eon-pink-opacity-85";
export const COLOR_PINK_OPACITY_90 = "eon-pink-opacity-90";
export const COLOR_PINK_OPACITY_95 = "eon-pink-opacity-95";
export const COLOR_DARK_PINK_SHADE_1 = "eon-dark-pink-shade-1";
export const COLOR_DARK_PINK_SHADE_2 = "eon-dark-pink-shade-2";
export const COLOR_DARK_PINK_TINT_1 = "eon-dark-pink-tint-1";
export const COLOR_DARK_PINK_TINT_2 = "eon-dark-pink-tint-2";
export const COLOR_DARK_PINK_5 = "eon-dark-pink-5";
export const COLOR_DARK_PINK_10 = "eon-dark-pink-10";
export const COLOR_DARK_PINK_15 = "eon-dark-pink-15";
export const COLOR_DARK_PINK_20 = "eon-dark-pink-20";
export const COLOR_DARK_PINK_25 = "eon-dark-pink-25";
export const COLOR_DARK_PINK_30 = "eon-dark-pink-30";
export const COLOR_DARK_PINK_35 = "eon-dark-pink-35";
export const COLOR_DARK_PINK_40 = "eon-dark-pink-40";
export const COLOR_DARK_PINK_45 = "eon-dark-pink-45";
export const COLOR_DARK_PINK_50 = "eon-dark-pink-50";
export const COLOR_DARK_PINK_55 = "eon-dark-pink-55";
export const COLOR_DARK_PINK_60 = "eon-dark-pink-60";
export const COLOR_DARK_PINK_65 = "eon-dark-pink-65";
export const COLOR_DARK_PINK_70 = "eon-dark-pink-70";
export const COLOR_DARK_PINK_75 = "eon-dark-pink-75";
export const COLOR_DARK_PINK_80 = "eon-dark-pink-80";
export const COLOR_DARK_PINK_85 = "eon-dark-pink-85";
export const COLOR_DARK_PINK_90 = "eon-dark-pink-90";
export const COLOR_DARK_PINK_95 = "eon-dark-pink-95";
export const COLOR_DARK_PINK_OPACITY_5 = "eon-dark-pink-opacity-5";
export const COLOR_DARK_PINK_OPACITY_10 = "eon-dark-pink-opacity-10";
export const COLOR_DARK_PINK_OPACITY_15 = "eon-dark-pink-opacity-15";
export const COLOR_DARK_PINK_OPACITY_20 = "eon-dark-pink-opacity-20";
export const COLOR_DARK_PINK_OPACITY_25 = "eon-dark-pink-opacity-25";
export const COLOR_DARK_PINK_OPACITY_30 = "eon-dark-pink-opacity-30";
export const COLOR_DARK_PINK_OPACITY_35 = "eon-dark-pink-opacity-35";
export const COLOR_DARK_PINK_OPACITY_40 = "eon-dark-pink-opacity-40";
export const COLOR_DARK_PINK_OPACITY_45 = "eon-dark-pink-opacity-45";
export const COLOR_DARK_PINK_OPACITY_50 = "eon-dark-pink-opacity-50";
export const COLOR_DARK_PINK_OPACITY_55 = "eon-dark-pink-opacity-55";
export const COLOR_DARK_PINK_OPACITY_60 = "eon-dark-pink-opacity-60";
export const COLOR_DARK_PINK_OPACITY_65 = "eon-dark-pink-opacity-65";
export const COLOR_DARK_PINK_OPACITY_70 = "eon-dark-pink-opacity-70";
export const COLOR_DARK_PINK_OPACITY_75 = "eon-dark-pink-opacity-75";
export const COLOR_DARK_PINK_OPACITY_80 = "eon-dark-pink-opacity-80";
export const COLOR_DARK_PINK_OPACITY_85 = "eon-dark-pink-opacity-85";
export const COLOR_DARK_PINK_OPACITY_90 = "eon-dark-pink-opacity-90";
export const COLOR_DARK_PINK_OPACITY_95 = "eon-dark-pink-opacity-95";
export const COLOR_BRIGHT_BLUE_SHADE_1 = "eon-bright-blue-shade-1";
export const COLOR_BRIGHT_BLUE_SHADE_2 = "eon-bright-blue-shade-2";
export const COLOR_BRIGHT_BLUE_TINT_1 = "eon-bright-blue-tint-1";
export const COLOR_BRIGHT_BLUE_TINT_2 = "eon-bright-blue-tint-2";
export const COLOR_BRIGHT_BLUE_5 = "eon-bright-blue-5";
export const COLOR_BRIGHT_BLUE_10 = "eon-bright-blue-10";
export const COLOR_BRIGHT_BLUE_15 = "eon-bright-blue-15";
export const COLOR_BRIGHT_BLUE_20 = "eon-bright-blue-20";
export const COLOR_BRIGHT_BLUE_25 = "eon-bright-blue-25";
export const COLOR_BRIGHT_BLUE_30 = "eon-bright-blue-30";
export const COLOR_BRIGHT_BLUE_35 = "eon-bright-blue-35";
export const COLOR_BRIGHT_BLUE_40 = "eon-bright-blue-40";
export const COLOR_BRIGHT_BLUE_45 = "eon-bright-blue-45";
export const COLOR_BRIGHT_BLUE_50 = "eon-bright-blue-50";
export const COLOR_BRIGHT_BLUE_55 = "eon-bright-blue-55";
export const COLOR_BRIGHT_BLUE_60 = "eon-bright-blue-60";
export const COLOR_BRIGHT_BLUE_65 = "eon-bright-blue-65";
export const COLOR_BRIGHT_BLUE_70 = "eon-bright-blue-70";
export const COLOR_BRIGHT_BLUE_75 = "eon-bright-blue-75";
export const COLOR_BRIGHT_BLUE_80 = "eon-bright-blue-80";
export const COLOR_BRIGHT_BLUE_85 = "eon-bright-blue-85";
export const COLOR_BRIGHT_BLUE_90 = "eon-bright-blue-90";
export const COLOR_BRIGHT_BLUE_95 = "eon-bright-blue-95";
export const COLOR_BRIGHT_BLUE_OPACITY_5 = "eon-bright-blue-opacity-5";
export const COLOR_BRIGHT_BLUE_OPACITY_10 = "eon-bright-blue-opacity-10";
export const COLOR_BRIGHT_BLUE_OPACITY_15 = "eon-bright-blue-opacity-15";
export const COLOR_BRIGHT_BLUE_OPACITY_20 = "eon-bright-blue-opacity-20";
export const COLOR_BRIGHT_BLUE_OPACITY_25 = "eon-bright-blue-opacity-25";
export const COLOR_BRIGHT_BLUE_OPACITY_30 = "eon-bright-blue-opacity-30";
export const COLOR_BRIGHT_BLUE_OPACITY_35 = "eon-bright-blue-opacity-35";
export const COLOR_BRIGHT_BLUE_OPACITY_40 = "eon-bright-blue-opacity-40";
export const COLOR_BRIGHT_BLUE_OPACITY_45 = "eon-bright-blue-opacity-45";
export const COLOR_BRIGHT_BLUE_OPACITY_50 = "eon-bright-blue-opacity-50";
export const COLOR_BRIGHT_BLUE_OPACITY_55 = "eon-bright-blue-opacity-55";
export const COLOR_BRIGHT_BLUE_OPACITY_60 = "eon-bright-blue-opacity-60";
export const COLOR_BRIGHT_BLUE_OPACITY_65 = "eon-bright-blue-opacity-65";
export const COLOR_BRIGHT_BLUE_OPACITY_70 = "eon-bright-blue-opacity-70";
export const COLOR_BRIGHT_BLUE_OPACITY_75 = "eon-bright-blue-opacity-75";
export const COLOR_BRIGHT_BLUE_OPACITY_80 = "eon-bright-blue-opacity-80";
export const COLOR_BRIGHT_BLUE_OPACITY_85 = "eon-bright-blue-opacity-85";
export const COLOR_BRIGHT_BLUE_OPACITY_90 = "eon-bright-blue-opacity-90";
export const COLOR_BRIGHT_BLUE_OPACITY_95 = "eon-bright-blue-opacity-95";
export const COLOR_CYAN_SHADE_1 = "eon-cyan-shade-1";
export const COLOR_CYAN_SHADE_2 = "eon-cyan-shade-2";
export const COLOR_CYAN_TINT_1 = "eon-cyan-tint-1";
export const COLOR_CYAN_TINT_2 = "eon-cyan-tint-2";
export const COLOR_CYAN_5 = "eon-cyan-5";
export const COLOR_CYAN_10 = "eon-cyan-10";
export const COLOR_CYAN_15 = "eon-cyan-15";
export const COLOR_CYAN_20 = "eon-cyan-20";
export const COLOR_CYAN_25 = "eon-cyan-25";
export const COLOR_CYAN_30 = "eon-cyan-30";
export const COLOR_CYAN_35 = "eon-cyan-35";
export const COLOR_CYAN_40 = "eon-cyan-40";
export const COLOR_CYAN_45 = "eon-cyan-45";
export const COLOR_CYAN_50 = "eon-cyan-50";
export const COLOR_CYAN_55 = "eon-cyan-55";
export const COLOR_CYAN_60 = "eon-cyan-60";
export const COLOR_CYAN_65 = "eon-cyan-65";
export const COLOR_CYAN_70 = "eon-cyan-70";
export const COLOR_CYAN_75 = "eon-cyan-75";
export const COLOR_CYAN_80 = "eon-cyan-80";
export const COLOR_CYAN_85 = "eon-cyan-85";
export const COLOR_CYAN_90 = "eon-cyan-90";
export const COLOR_CYAN_95 = "eon-cyan-95";
export const COLOR_CYAN_OPACITY_5 = "eon-cyan-opacity-5";
export const COLOR_CYAN_OPACITY_10 = "eon-cyan-opacity-10";
export const COLOR_CYAN_OPACITY_15 = "eon-cyan-opacity-15";
export const COLOR_CYAN_OPACITY_20 = "eon-cyan-opacity-20";
export const COLOR_CYAN_OPACITY_25 = "eon-cyan-opacity-25";
export const COLOR_CYAN_OPACITY_30 = "eon-cyan-opacity-30";
export const COLOR_CYAN_OPACITY_35 = "eon-cyan-opacity-35";
export const COLOR_CYAN_OPACITY_40 = "eon-cyan-opacity-40";
export const COLOR_CYAN_OPACITY_45 = "eon-cyan-opacity-45";
export const COLOR_CYAN_OPACITY_50 = "eon-cyan-opacity-50";
export const COLOR_CYAN_OPACITY_55 = "eon-cyan-opacity-55";
export const COLOR_CYAN_OPACITY_60 = "eon-cyan-opacity-60";
export const COLOR_CYAN_OPACITY_65 = "eon-cyan-opacity-65";
export const COLOR_CYAN_OPACITY_70 = "eon-cyan-opacity-70";
export const COLOR_CYAN_OPACITY_75 = "eon-cyan-opacity-75";
export const COLOR_CYAN_OPACITY_80 = "eon-cyan-opacity-80";
export const COLOR_CYAN_OPACITY_85 = "eon-cyan-opacity-85";
export const COLOR_CYAN_OPACITY_90 = "eon-cyan-opacity-90";
export const COLOR_CYAN_OPACITY_95 = "eon-cyan-opacity-95";
export const COLOR_DARKBLUE_SHADE_1 = "eon-darkblue-shade-1";
export const COLOR_DARKBLUE_SHADE_2 = "eon-darkblue-shade-2";
export const COLOR_DARKBLUE_TINT_1 = "eon-darkblue-tint-1";
export const COLOR_DARKBLUE_TINT_2 = "eon-darkblue-tint-2";
export const COLOR_DARKBLUE_5 = "eon-darkblue-5";
export const COLOR_DARKBLUE_10 = "eon-darkblue-10";
export const COLOR_DARKBLUE_15 = "eon-darkblue-15";
export const COLOR_DARKBLUE_20 = "eon-darkblue-20";
export const COLOR_DARKBLUE_25 = "eon-darkblue-25";
export const COLOR_DARKBLUE_30 = "eon-darkblue-30";
export const COLOR_DARKBLUE_35 = "eon-darkblue-35";
export const COLOR_DARKBLUE_40 = "eon-darkblue-40";
export const COLOR_DARKBLUE_45 = "eon-darkblue-45";
export const COLOR_DARKBLUE_50 = "eon-darkblue-50";
export const COLOR_DARKBLUE_55 = "eon-darkblue-55";
export const COLOR_DARKBLUE_60 = "eon-darkblue-60";
export const COLOR_DARKBLUE_65 = "eon-darkblue-65";
export const COLOR_DARKBLUE_70 = "eon-darkblue-70";
export const COLOR_DARKBLUE_75 = "eon-darkblue-75";
export const COLOR_DARKBLUE_80 = "eon-darkblue-80";
export const COLOR_DARKBLUE_85 = "eon-darkblue-85";
export const COLOR_DARKBLUE_90 = "eon-darkblue-90";
export const COLOR_DARKBLUE_95 = "eon-darkblue-95";
export const COLOR_DARKBLUE_OPACITY_5 = "eon-darkblue-opacity-5";
export const COLOR_DARKBLUE_OPACITY_10 = "eon-darkblue-opacity-10";
export const COLOR_DARKBLUE_OPACITY_15 = "eon-darkblue-opacity-15";
export const COLOR_DARKBLUE_OPACITY_20 = "eon-darkblue-opacity-20";
export const COLOR_DARKBLUE_OPACITY_25 = "eon-darkblue-opacity-25";
export const COLOR_DARKBLUE_OPACITY_30 = "eon-darkblue-opacity-30";
export const COLOR_DARKBLUE_OPACITY_35 = "eon-darkblue-opacity-35";
export const COLOR_DARKBLUE_OPACITY_40 = "eon-darkblue-opacity-40";
export const COLOR_DARKBLUE_OPACITY_45 = "eon-darkblue-opacity-45";
export const COLOR_DARKBLUE_OPACITY_50 = "eon-darkblue-opacity-50";
export const COLOR_DARKBLUE_OPACITY_55 = "eon-darkblue-opacity-55";
export const COLOR_DARKBLUE_OPACITY_60 = "eon-darkblue-opacity-60";
export const COLOR_DARKBLUE_OPACITY_65 = "eon-darkblue-opacity-65";
export const COLOR_DARKBLUE_OPACITY_70 = "eon-darkblue-opacity-70";
export const COLOR_DARKBLUE_OPACITY_75 = "eon-darkblue-opacity-75";
export const COLOR_DARKBLUE_OPACITY_80 = "eon-darkblue-opacity-80";
export const COLOR_DARKBLUE_OPACITY_85 = "eon-darkblue-opacity-85";
export const COLOR_DARKBLUE_OPACITY_90 = "eon-darkblue-opacity-90";
export const COLOR_DARKBLUE_OPACITY_95 = "eon-darkblue-opacity-95";
export const COLOR_RED_SHADE_1 = "eon-red-shade-1";
export const COLOR_RED_SHADE_2 = "eon-red-shade-2";
export const COLOR_RED_TINT_1 = "eon-red-tint-1";
export const COLOR_RED_TINT_2 = "eon-red-tint-2";
export const COLOR_RED_5 = "eon-red-5";
export const COLOR_RED_10 = "eon-red-10";
export const COLOR_RED_15 = "eon-red-15";
export const COLOR_RED_20 = "eon-red-20";
export const COLOR_RED_25 = "eon-red-25";
export const COLOR_RED_30 = "eon-red-30";
export const COLOR_RED_35 = "eon-red-35";
export const COLOR_RED_40 = "eon-red-40";
export const COLOR_RED_45 = "eon-red-45";
export const COLOR_RED_50 = "eon-red-50";
export const COLOR_RED_55 = "eon-red-55";
export const COLOR_RED_60 = "eon-red-60";
export const COLOR_RED_65 = "eon-red-65";
export const COLOR_RED_70 = "eon-red-70";
export const COLOR_RED_75 = "eon-red-75";
export const COLOR_RED_80 = "eon-red-80";
export const COLOR_RED_85 = "eon-red-85";
export const COLOR_RED_90 = "eon-red-90";
export const COLOR_RED_95 = "eon-red-95";
export const COLOR_RED_OPACITY_5 = "eon-red-opacity-5";
export const COLOR_RED_OPACITY_10 = "eon-red-opacity-10";
export const COLOR_RED_OPACITY_15 = "eon-red-opacity-15";
export const COLOR_RED_OPACITY_20 = "eon-red-opacity-20";
export const COLOR_RED_OPACITY_25 = "eon-red-opacity-25";
export const COLOR_RED_OPACITY_30 = "eon-red-opacity-30";
export const COLOR_RED_OPACITY_35 = "eon-red-opacity-35";
export const COLOR_RED_OPACITY_40 = "eon-red-opacity-40";
export const COLOR_RED_OPACITY_45 = "eon-red-opacity-45";
export const COLOR_RED_OPACITY_50 = "eon-red-opacity-50";
export const COLOR_RED_OPACITY_55 = "eon-red-opacity-55";
export const COLOR_RED_OPACITY_60 = "eon-red-opacity-60";
export const COLOR_RED_OPACITY_65 = "eon-red-opacity-65";
export const COLOR_RED_OPACITY_70 = "eon-red-opacity-70";
export const COLOR_RED_OPACITY_75 = "eon-red-opacity-75";
export const COLOR_RED_OPACITY_80 = "eon-red-opacity-80";
export const COLOR_RED_OPACITY_85 = "eon-red-opacity-85";
export const COLOR_RED_OPACITY_90 = "eon-red-opacity-90";
export const COLOR_RED_OPACITY_95 = "eon-red-opacity-95";
export const COLOR_YELLOW_SHADE_1 = "eon-yellow-shade-1";
export const COLOR_YELLOW_SHADE_2 = "eon-yellow-shade-2";
export const COLOR_YELLOW_TINT_1 = "eon-yellow-tint-1";
export const COLOR_YELLOW_TINT_2 = "eon-yellow-tint-2";
export const COLOR_YELLOW_5 = "eon-yellow-5";
export const COLOR_YELLOW_10 = "eon-yellow-10";
export const COLOR_YELLOW_15 = "eon-yellow-15";
export const COLOR_YELLOW_20 = "eon-yellow-20";
export const COLOR_YELLOW_25 = "eon-yellow-25";
export const COLOR_YELLOW_30 = "eon-yellow-30";
export const COLOR_YELLOW_35 = "eon-yellow-35";
export const COLOR_YELLOW_40 = "eon-yellow-40";
export const COLOR_YELLOW_45 = "eon-yellow-45";
export const COLOR_YELLOW_50 = "eon-yellow-50";
export const COLOR_YELLOW_55 = "eon-yellow-55";
export const COLOR_YELLOW_60 = "eon-yellow-60";
export const COLOR_YELLOW_65 = "eon-yellow-65";
export const COLOR_YELLOW_70 = "eon-yellow-70";
export const COLOR_YELLOW_75 = "eon-yellow-75";
export const COLOR_YELLOW_80 = "eon-yellow-80";
export const COLOR_YELLOW_85 = "eon-yellow-85";
export const COLOR_YELLOW_90 = "eon-yellow-90";
export const COLOR_YELLOW_95 = "eon-yellow-95";
export const COLOR_YELLOW_OPACITY_5 = "eon-yellow-opacity-5";
export const COLOR_YELLOW_OPACITY_10 = "eon-yellow-opacity-10";
export const COLOR_YELLOW_OPACITY_15 = "eon-yellow-opacity-15";
export const COLOR_YELLOW_OPACITY_20 = "eon-yellow-opacity-20";
export const COLOR_YELLOW_OPACITY_25 = "eon-yellow-opacity-25";
export const COLOR_YELLOW_OPACITY_30 = "eon-yellow-opacity-30";
export const COLOR_YELLOW_OPACITY_35 = "eon-yellow-opacity-35";
export const COLOR_YELLOW_OPACITY_40 = "eon-yellow-opacity-40";
export const COLOR_YELLOW_OPACITY_45 = "eon-yellow-opacity-45";
export const COLOR_YELLOW_OPACITY_50 = "eon-yellow-opacity-50";
export const COLOR_YELLOW_OPACITY_55 = "eon-yellow-opacity-55";
export const COLOR_YELLOW_OPACITY_60 = "eon-yellow-opacity-60";
export const COLOR_YELLOW_OPACITY_65 = "eon-yellow-opacity-65";
export const COLOR_YELLOW_OPACITY_70 = "eon-yellow-opacity-70";
export const COLOR_YELLOW_OPACITY_75 = "eon-yellow-opacity-75";
export const COLOR_YELLOW_OPACITY_80 = "eon-yellow-opacity-80";
export const COLOR_YELLOW_OPACITY_85 = "eon-yellow-opacity-85";
export const COLOR_YELLOW_OPACITY_90 = "eon-yellow-opacity-90";
export const COLOR_YELLOW_OPACITY_95 = "eon-yellow-opacity-95";
export const COLOR_GREEN_SHADE_1 = "eon-green-shade-1";
export const COLOR_GREEN_SHADE_2 = "eon-green-shade-2";
export const COLOR_GREEN_TINT_1 = "eon-green-tint-1";
export const COLOR_GREEN_TINT_2 = "eon-green-tint-2";
export const COLOR_GREEN_5 = "eon-green-5";
export const COLOR_GREEN_10 = "eon-green-10";
export const COLOR_GREEN_15 = "eon-green-15";
export const COLOR_GREEN_20 = "eon-green-20";
export const COLOR_GREEN_25 = "eon-green-25";
export const COLOR_GREEN_30 = "eon-green-30";
export const COLOR_GREEN_35 = "eon-green-35";
export const COLOR_GREEN_40 = "eon-green-40";
export const COLOR_GREEN_45 = "eon-green-45";
export const COLOR_GREEN_50 = "eon-green-50";
export const COLOR_GREEN_55 = "eon-green-55";
export const COLOR_GREEN_60 = "eon-green-60";
export const COLOR_GREEN_65 = "eon-green-65";
export const COLOR_GREEN_70 = "eon-green-70";
export const COLOR_GREEN_75 = "eon-green-75";
export const COLOR_GREEN_80 = "eon-green-80";
export const COLOR_GREEN_85 = "eon-green-85";
export const COLOR_GREEN_90 = "eon-green-90";
export const COLOR_GREEN_95 = "eon-green-95";
export const COLOR_GREEN_OPACITY_5 = "eon-green-opacity-5";
export const COLOR_GREEN_OPACITY_10 = "eon-green-opacity-10";
export const COLOR_GREEN_OPACITY_15 = "eon-green-opacity-15";
export const COLOR_GREEN_OPACITY_20 = "eon-green-opacity-20";
export const COLOR_GREEN_OPACITY_25 = "eon-green-opacity-25";
export const COLOR_GREEN_OPACITY_30 = "eon-green-opacity-30";
export const COLOR_GREEN_OPACITY_35 = "eon-green-opacity-35";
export const COLOR_GREEN_OPACITY_40 = "eon-green-opacity-40";
export const COLOR_GREEN_OPACITY_45 = "eon-green-opacity-45";
export const COLOR_GREEN_OPACITY_50 = "eon-green-opacity-50";
export const COLOR_GREEN_OPACITY_55 = "eon-green-opacity-55";
export const COLOR_GREEN_OPACITY_60 = "eon-green-opacity-60";
export const COLOR_GREEN_OPACITY_65 = "eon-green-opacity-65";
export const COLOR_GREEN_OPACITY_70 = "eon-green-opacity-70";
export const COLOR_GREEN_OPACITY_75 = "eon-green-opacity-75";
export const COLOR_GREEN_OPACITY_80 = "eon-green-opacity-80";
export const COLOR_GREEN_OPACITY_85 = "eon-green-opacity-85";
export const COLOR_GREEN_OPACITY_90 = "eon-green-opacity-90";
export const COLOR_GREEN_OPACITY_95 = "eon-green-opacity-95";
export const COLOR_WHITE_SHADE_1 = "eon-white-shade-1";
export const COLOR_WHITE_SHADE_2 = "eon-white-shade-2";
export const COLOR_WHITE_TINT_1 = "eon-white-tint-1";
export const COLOR_WHITE_TINT_2 = "eon-white-tint-2";
export const COLOR_WHITE_5 = "eon-white-5";
export const COLOR_WHITE_10 = "eon-white-10";
export const COLOR_WHITE_15 = "eon-white-15";
export const COLOR_WHITE_20 = "eon-white-20";
export const COLOR_WHITE_25 = "eon-white-25";
export const COLOR_WHITE_30 = "eon-white-30";
export const COLOR_WHITE_35 = "eon-white-35";
export const COLOR_WHITE_40 = "eon-white-40";
export const COLOR_WHITE_45 = "eon-white-45";
export const COLOR_WHITE_50 = "eon-white-50";
export const COLOR_WHITE_55 = "eon-white-55";
export const COLOR_WHITE_60 = "eon-white-60";
export const COLOR_WHITE_65 = "eon-white-65";
export const COLOR_WHITE_70 = "eon-white-70";
export const COLOR_WHITE_75 = "eon-white-75";
export const COLOR_WHITE_80 = "eon-white-80";
export const COLOR_WHITE_85 = "eon-white-85";
export const COLOR_WHITE_90 = "eon-white-90";
export const COLOR_WHITE_95 = "eon-white-95";
export const COLOR_WHITE_OPACITY_5 = "eon-white-opacity-5";
export const COLOR_WHITE_OPACITY_10 = "eon-white-opacity-10";
export const COLOR_WHITE_OPACITY_15 = "eon-white-opacity-15";
export const COLOR_WHITE_OPACITY_20 = "eon-white-opacity-20";
export const COLOR_WHITE_OPACITY_25 = "eon-white-opacity-25";
export const COLOR_WHITE_OPACITY_30 = "eon-white-opacity-30";
export const COLOR_WHITE_OPACITY_35 = "eon-white-opacity-35";
export const COLOR_WHITE_OPACITY_40 = "eon-white-opacity-40";
export const COLOR_WHITE_OPACITY_45 = "eon-white-opacity-45";
export const COLOR_WHITE_OPACITY_50 = "eon-white-opacity-50";
export const COLOR_WHITE_OPACITY_55 = "eon-white-opacity-55";
export const COLOR_WHITE_OPACITY_60 = "eon-white-opacity-60";
export const COLOR_WHITE_OPACITY_65 = "eon-white-opacity-65";
export const COLOR_WHITE_OPACITY_70 = "eon-white-opacity-70";
export const COLOR_WHITE_OPACITY_75 = "eon-white-opacity-75";
export const COLOR_WHITE_OPACITY_80 = "eon-white-opacity-80";
export const COLOR_WHITE_OPACITY_85 = "eon-white-opacity-85";
export const COLOR_WHITE_OPACITY_90 = "eon-white-opacity-90";
export const COLOR_WHITE_OPACITY_95 = "eon-white-opacity-95";
export const COLOR_BRIGHT_SHADE_1 = "eon-bright-shade-1";
export const COLOR_BRIGHT_SHADE_2 = "eon-bright-shade-2";
export const COLOR_BRIGHT_TINT_1 = "eon-bright-tint-1";
export const COLOR_BRIGHT_TINT_2 = "eon-bright-tint-2";
export const COLOR_BRIGHT_5 = "eon-bright-5";
export const COLOR_BRIGHT_10 = "eon-bright-10";
export const COLOR_BRIGHT_15 = "eon-bright-15";
export const COLOR_BRIGHT_20 = "eon-bright-20";
export const COLOR_BRIGHT_25 = "eon-bright-25";
export const COLOR_BRIGHT_30 = "eon-bright-30";
export const COLOR_BRIGHT_35 = "eon-bright-35";
export const COLOR_BRIGHT_40 = "eon-bright-40";
export const COLOR_BRIGHT_45 = "eon-bright-45";
export const COLOR_BRIGHT_50 = "eon-bright-50";
export const COLOR_BRIGHT_55 = "eon-bright-55";
export const COLOR_BRIGHT_60 = "eon-bright-60";
export const COLOR_BRIGHT_65 = "eon-bright-65";
export const COLOR_BRIGHT_70 = "eon-bright-70";
export const COLOR_BRIGHT_75 = "eon-bright-75";
export const COLOR_BRIGHT_80 = "eon-bright-80";
export const COLOR_BRIGHT_85 = "eon-bright-85";
export const COLOR_BRIGHT_90 = "eon-bright-90";
export const COLOR_BRIGHT_95 = "eon-bright-95";
export const COLOR_BRIGHT_OPACITY_5 = "eon-bright-opacity-5";
export const COLOR_BRIGHT_OPACITY_10 = "eon-bright-opacity-10";
export const COLOR_BRIGHT_OPACITY_15 = "eon-bright-opacity-15";
export const COLOR_BRIGHT_OPACITY_20 = "eon-bright-opacity-20";
export const COLOR_BRIGHT_OPACITY_25 = "eon-bright-opacity-25";
export const COLOR_BRIGHT_OPACITY_30 = "eon-bright-opacity-30";
export const COLOR_BRIGHT_OPACITY_35 = "eon-bright-opacity-35";
export const COLOR_BRIGHT_OPACITY_40 = "eon-bright-opacity-40";
export const COLOR_BRIGHT_OPACITY_45 = "eon-bright-opacity-45";
export const COLOR_BRIGHT_OPACITY_50 = "eon-bright-opacity-50";
export const COLOR_BRIGHT_OPACITY_55 = "eon-bright-opacity-55";
export const COLOR_BRIGHT_OPACITY_60 = "eon-bright-opacity-60";
export const COLOR_BRIGHT_OPACITY_65 = "eon-bright-opacity-65";
export const COLOR_BRIGHT_OPACITY_70 = "eon-bright-opacity-70";
export const COLOR_BRIGHT_OPACITY_75 = "eon-bright-opacity-75";
export const COLOR_BRIGHT_OPACITY_80 = "eon-bright-opacity-80";
export const COLOR_BRIGHT_OPACITY_85 = "eon-bright-opacity-85";
export const COLOR_BRIGHT_OPACITY_90 = "eon-bright-opacity-90";
export const COLOR_BRIGHT_OPACITY_95 = "eon-bright-opacity-95";
export const COLOR_DARK_SHADE_1 = "eon-dark-shade-1";
export const COLOR_DARK_SHADE_2 = "eon-dark-shade-2";
export const COLOR_DARK_TINT_1 = "eon-dark-tint-1";
export const COLOR_DARK_TINT_2 = "eon-dark-tint-2";
export const COLOR_DARK_5 = "eon-dark-5";
export const COLOR_DARK_10 = "eon-dark-10";
export const COLOR_DARK_15 = "eon-dark-15";
export const COLOR_DARK_20 = "eon-dark-20";
export const COLOR_DARK_25 = "eon-dark-25";
export const COLOR_DARK_30 = "eon-dark-30";
export const COLOR_DARK_35 = "eon-dark-35";
export const COLOR_DARK_40 = "eon-dark-40";
export const COLOR_DARK_45 = "eon-dark-45";
export const COLOR_DARK_50 = "eon-dark-50";
export const COLOR_DARK_55 = "eon-dark-55";
export const COLOR_DARK_60 = "eon-dark-60";
export const COLOR_DARK_65 = "eon-dark-65";
export const COLOR_DARK_70 = "eon-dark-70";
export const COLOR_DARK_75 = "eon-dark-75";
export const COLOR_DARK_80 = "eon-dark-80";
export const COLOR_DARK_85 = "eon-dark-85";
export const COLOR_DARK_90 = "eon-dark-90";
export const COLOR_DARK_95 = "eon-dark-95";
export const COLOR_DARK_OPACITY_5 = "eon-dark-opacity-5";
export const COLOR_DARK_OPACITY_10 = "eon-dark-opacity-10";
export const COLOR_DARK_OPACITY_15 = "eon-dark-opacity-15";
export const COLOR_DARK_OPACITY_20 = "eon-dark-opacity-20";
export const COLOR_DARK_OPACITY_25 = "eon-dark-opacity-25";
export const COLOR_DARK_OPACITY_30 = "eon-dark-opacity-30";
export const COLOR_DARK_OPACITY_35 = "eon-dark-opacity-35";
export const COLOR_DARK_OPACITY_40 = "eon-dark-opacity-40";
export const COLOR_DARK_OPACITY_45 = "eon-dark-opacity-45";
export const COLOR_DARK_OPACITY_50 = "eon-dark-opacity-50";
export const COLOR_DARK_OPACITY_55 = "eon-dark-opacity-55";
export const COLOR_DARK_OPACITY_60 = "eon-dark-opacity-60";
export const COLOR_DARK_OPACITY_65 = "eon-dark-opacity-65";
export const COLOR_DARK_OPACITY_70 = "eon-dark-opacity-70";
export const COLOR_DARK_OPACITY_75 = "eon-dark-opacity-75";
export const COLOR_DARK_OPACITY_80 = "eon-dark-opacity-80";
export const COLOR_DARK_OPACITY_85 = "eon-dark-opacity-85";
export const COLOR_DARK_OPACITY_90 = "eon-dark-opacity-90";
export const COLOR_DARK_OPACITY_95 = "eon-dark-opacity-95";
export const COLOR_DARK900_SHADE_1 = "eon-dark900-shade-1";
export const COLOR_DARK900_SHADE_2 = "eon-dark900-shade-2";
export const COLOR_DARK900_TINT_1 = "eon-dark900-tint-1";
export const COLOR_DARK900_TINT_2 = "eon-dark900-tint-2";
export const COLOR_DARK900_5 = "eon-dark900-5";
export const COLOR_DARK900_10 = "eon-dark900-10";
export const COLOR_DARK900_15 = "eon-dark900-15";
export const COLOR_DARK900_20 = "eon-dark900-20";
export const COLOR_DARK900_25 = "eon-dark900-25";
export const COLOR_DARK900_30 = "eon-dark900-30";
export const COLOR_DARK900_35 = "eon-dark900-35";
export const COLOR_DARK900_40 = "eon-dark900-40";
export const COLOR_DARK900_45 = "eon-dark900-45";
export const COLOR_DARK900_50 = "eon-dark900-50";
export const COLOR_DARK900_55 = "eon-dark900-55";
export const COLOR_DARK900_60 = "eon-dark900-60";
export const COLOR_DARK900_65 = "eon-dark900-65";
export const COLOR_DARK900_70 = "eon-dark900-70";
export const COLOR_DARK900_75 = "eon-dark900-75";
export const COLOR_DARK900_80 = "eon-dark900-80";
export const COLOR_DARK900_85 = "eon-dark900-85";
export const COLOR_DARK900_90 = "eon-dark900-90";
export const COLOR_DARK900_95 = "eon-dark900-95";
export const COLOR_DARK900_OPACITY_5 = "eon-dark900-opacity-5";
export const COLOR_DARK900_OPACITY_10 = "eon-dark900-opacity-10";
export const COLOR_DARK900_OPACITY_15 = "eon-dark900-opacity-15";
export const COLOR_DARK900_OPACITY_20 = "eon-dark900-opacity-20";
export const COLOR_DARK900_OPACITY_25 = "eon-dark900-opacity-25";
export const COLOR_DARK900_OPACITY_30 = "eon-dark900-opacity-30";
export const COLOR_DARK900_OPACITY_35 = "eon-dark900-opacity-35";
export const COLOR_DARK900_OPACITY_40 = "eon-dark900-opacity-40";
export const COLOR_DARK900_OPACITY_45 = "eon-dark900-opacity-45";
export const COLOR_DARK900_OPACITY_50 = "eon-dark900-opacity-50";
export const COLOR_DARK900_OPACITY_55 = "eon-dark900-opacity-55";
export const COLOR_DARK900_OPACITY_60 = "eon-dark900-opacity-60";
export const COLOR_DARK900_OPACITY_65 = "eon-dark900-opacity-65";
export const COLOR_DARK900_OPACITY_70 = "eon-dark900-opacity-70";
export const COLOR_DARK900_OPACITY_75 = "eon-dark900-opacity-75";
export const COLOR_DARK900_OPACITY_80 = "eon-dark900-opacity-80";
export const COLOR_DARK900_OPACITY_85 = "eon-dark900-opacity-85";
export const COLOR_DARK900_OPACITY_90 = "eon-dark900-opacity-90";
export const COLOR_DARK900_OPACITY_95 = "eon-dark900-opacity-95";
export const COLOR_DARK700_SHADE_1 = "eon-dark700-shade-1";
export const COLOR_DARK700_SHADE_2 = "eon-dark700-shade-2";
export const COLOR_DARK700_TINT_1 = "eon-dark700-tint-1";
export const COLOR_DARK700_TINT_2 = "eon-dark700-tint-2";
export const COLOR_DARK700_5 = "eon-dark700-5";
export const COLOR_DARK700_10 = "eon-dark700-10";
export const COLOR_DARK700_15 = "eon-dark700-15";
export const COLOR_DARK700_20 = "eon-dark700-20";
export const COLOR_DARK700_25 = "eon-dark700-25";
export const COLOR_DARK700_30 = "eon-dark700-30";
export const COLOR_DARK700_35 = "eon-dark700-35";
export const COLOR_DARK700_40 = "eon-dark700-40";
export const COLOR_DARK700_45 = "eon-dark700-45";
export const COLOR_DARK700_50 = "eon-dark700-50";
export const COLOR_DARK700_55 = "eon-dark700-55";
export const COLOR_DARK700_60 = "eon-dark700-60";
export const COLOR_DARK700_65 = "eon-dark700-65";
export const COLOR_DARK700_70 = "eon-dark700-70";
export const COLOR_DARK700_75 = "eon-dark700-75";
export const COLOR_DARK700_80 = "eon-dark700-80";
export const COLOR_DARK700_85 = "eon-dark700-85";
export const COLOR_DARK700_90 = "eon-dark700-90";
export const COLOR_DARK700_95 = "eon-dark700-95";
export const COLOR_DARK700_OPACITY_5 = "eon-dark700-opacity-5";
export const COLOR_DARK700_OPACITY_10 = "eon-dark700-opacity-10";
export const COLOR_DARK700_OPACITY_15 = "eon-dark700-opacity-15";
export const COLOR_DARK700_OPACITY_20 = "eon-dark700-opacity-20";
export const COLOR_DARK700_OPACITY_25 = "eon-dark700-opacity-25";
export const COLOR_DARK700_OPACITY_30 = "eon-dark700-opacity-30";
export const COLOR_DARK700_OPACITY_35 = "eon-dark700-opacity-35";
export const COLOR_DARK700_OPACITY_40 = "eon-dark700-opacity-40";
export const COLOR_DARK700_OPACITY_45 = "eon-dark700-opacity-45";
export const COLOR_DARK700_OPACITY_50 = "eon-dark700-opacity-50";
export const COLOR_DARK700_OPACITY_55 = "eon-dark700-opacity-55";
export const COLOR_DARK700_OPACITY_60 = "eon-dark700-opacity-60";
export const COLOR_DARK700_OPACITY_65 = "eon-dark700-opacity-65";
export const COLOR_DARK700_OPACITY_70 = "eon-dark700-opacity-70";
export const COLOR_DARK700_OPACITY_75 = "eon-dark700-opacity-75";
export const COLOR_DARK700_OPACITY_80 = "eon-dark700-opacity-80";
export const COLOR_DARK700_OPACITY_85 = "eon-dark700-opacity-85";
export const COLOR_DARK700_OPACITY_90 = "eon-dark700-opacity-90";
export const COLOR_DARK700_OPACITY_95 = "eon-dark700-opacity-95";
export const COLOR_DARK600_SHADE_1 = "eon-dark600-shade-1";
export const COLOR_DARK600_SHADE_2 = "eon-dark600-shade-2";
export const COLOR_DARK600_TINT_1 = "eon-dark600-tint-1";
export const COLOR_DARK600_TINT_2 = "eon-dark600-tint-2";
export const COLOR_DARK600_5 = "eon-dark600-5";
export const COLOR_DARK600_10 = "eon-dark600-10";
export const COLOR_DARK600_15 = "eon-dark600-15";
export const COLOR_DARK600_20 = "eon-dark600-20";
export const COLOR_DARK600_25 = "eon-dark600-25";
export const COLOR_DARK600_30 = "eon-dark600-30";
export const COLOR_DARK600_35 = "eon-dark600-35";
export const COLOR_DARK600_40 = "eon-dark600-40";
export const COLOR_DARK600_45 = "eon-dark600-45";
export const COLOR_DARK600_50 = "eon-dark600-50";
export const COLOR_DARK600_55 = "eon-dark600-55";
export const COLOR_DARK600_60 = "eon-dark600-60";
export const COLOR_DARK600_65 = "eon-dark600-65";
export const COLOR_DARK600_70 = "eon-dark600-70";
export const COLOR_DARK600_75 = "eon-dark600-75";
export const COLOR_DARK600_80 = "eon-dark600-80";
export const COLOR_DARK600_85 = "eon-dark600-85";
export const COLOR_DARK600_90 = "eon-dark600-90";
export const COLOR_DARK600_95 = "eon-dark600-95";
export const COLOR_DARK600_OPACITY_5 = "eon-dark600-opacity-5";
export const COLOR_DARK600_OPACITY_10 = "eon-dark600-opacity-10";
export const COLOR_DARK600_OPACITY_15 = "eon-dark600-opacity-15";
export const COLOR_DARK600_OPACITY_20 = "eon-dark600-opacity-20";
export const COLOR_DARK600_OPACITY_25 = "eon-dark600-opacity-25";
export const COLOR_DARK600_OPACITY_30 = "eon-dark600-opacity-30";
export const COLOR_DARK600_OPACITY_35 = "eon-dark600-opacity-35";
export const COLOR_DARK600_OPACITY_40 = "eon-dark600-opacity-40";
export const COLOR_DARK600_OPACITY_45 = "eon-dark600-opacity-45";
export const COLOR_DARK600_OPACITY_50 = "eon-dark600-opacity-50";
export const COLOR_DARK600_OPACITY_55 = "eon-dark600-opacity-55";
export const COLOR_DARK600_OPACITY_60 = "eon-dark600-opacity-60";
export const COLOR_DARK600_OPACITY_65 = "eon-dark600-opacity-65";
export const COLOR_DARK600_OPACITY_70 = "eon-dark600-opacity-70";
export const COLOR_DARK600_OPACITY_75 = "eon-dark600-opacity-75";
export const COLOR_DARK600_OPACITY_80 = "eon-dark600-opacity-80";
export const COLOR_DARK600_OPACITY_85 = "eon-dark600-opacity-85";
export const COLOR_DARK600_OPACITY_90 = "eon-dark600-opacity-90";
export const COLOR_DARK600_OPACITY_95 = "eon-dark600-opacity-95";
export const COLOR_DARK400_SHADE_1 = "eon-dark400-shade-1";
export const COLOR_DARK400_SHADE_2 = "eon-dark400-shade-2";
export const COLOR_DARK400_TINT_1 = "eon-dark400-tint-1";
export const COLOR_DARK400_TINT_2 = "eon-dark400-tint-2";
export const COLOR_DARK400_5 = "eon-dark400-5";
export const COLOR_DARK400_10 = "eon-dark400-10";
export const COLOR_DARK400_15 = "eon-dark400-15";
export const COLOR_DARK400_20 = "eon-dark400-20";
export const COLOR_DARK400_25 = "eon-dark400-25";
export const COLOR_DARK400_30 = "eon-dark400-30";
export const COLOR_DARK400_35 = "eon-dark400-35";
export const COLOR_DARK400_40 = "eon-dark400-40";
export const COLOR_DARK400_45 = "eon-dark400-45";
export const COLOR_DARK400_50 = "eon-dark400-50";
export const COLOR_DARK400_55 = "eon-dark400-55";
export const COLOR_DARK400_60 = "eon-dark400-60";
export const COLOR_DARK400_65 = "eon-dark400-65";
export const COLOR_DARK400_70 = "eon-dark400-70";
export const COLOR_DARK400_75 = "eon-dark400-75";
export const COLOR_DARK400_80 = "eon-dark400-80";
export const COLOR_DARK400_85 = "eon-dark400-85";
export const COLOR_DARK400_90 = "eon-dark400-90";
export const COLOR_DARK400_95 = "eon-dark400-95";
export const COLOR_DARK400_OPACITY_5 = "eon-dark400-opacity-5";
export const COLOR_DARK400_OPACITY_10 = "eon-dark400-opacity-10";
export const COLOR_DARK400_OPACITY_15 = "eon-dark400-opacity-15";
export const COLOR_DARK400_OPACITY_20 = "eon-dark400-opacity-20";
export const COLOR_DARK400_OPACITY_25 = "eon-dark400-opacity-25";
export const COLOR_DARK400_OPACITY_30 = "eon-dark400-opacity-30";
export const COLOR_DARK400_OPACITY_35 = "eon-dark400-opacity-35";
export const COLOR_DARK400_OPACITY_40 = "eon-dark400-opacity-40";
export const COLOR_DARK400_OPACITY_45 = "eon-dark400-opacity-45";
export const COLOR_DARK400_OPACITY_50 = "eon-dark400-opacity-50";
export const COLOR_DARK400_OPACITY_55 = "eon-dark400-opacity-55";
export const COLOR_DARK400_OPACITY_60 = "eon-dark400-opacity-60";
export const COLOR_DARK400_OPACITY_65 = "eon-dark400-opacity-65";
export const COLOR_DARK400_OPACITY_70 = "eon-dark400-opacity-70";
export const COLOR_DARK400_OPACITY_75 = "eon-dark400-opacity-75";
export const COLOR_DARK400_OPACITY_80 = "eon-dark400-opacity-80";
export const COLOR_DARK400_OPACITY_85 = "eon-dark400-opacity-85";
export const COLOR_DARK400_OPACITY_90 = "eon-dark400-opacity-90";
export const COLOR_DARK400_OPACITY_95 = "eon-dark400-opacity-95";
export const COLOR_DARK300_SHADE_1 = "eon-dark300-shade-1";
export const COLOR_DARK300_SHADE_2 = "eon-dark300-shade-2";
export const COLOR_DARK300_TINT_1 = "eon-dark300-tint-1";
export const COLOR_DARK300_TINT_2 = "eon-dark300-tint-2";
export const COLOR_DARK300_5 = "eon-dark300-5";
export const COLOR_DARK300_10 = "eon-dark300-10";
export const COLOR_DARK300_15 = "eon-dark300-15";
export const COLOR_DARK300_20 = "eon-dark300-20";
export const COLOR_DARK300_25 = "eon-dark300-25";
export const COLOR_DARK300_30 = "eon-dark300-30";
export const COLOR_DARK300_35 = "eon-dark300-35";
export const COLOR_DARK300_40 = "eon-dark300-40";
export const COLOR_DARK300_45 = "eon-dark300-45";
export const COLOR_DARK300_50 = "eon-dark300-50";
export const COLOR_DARK300_55 = "eon-dark300-55";
export const COLOR_DARK300_60 = "eon-dark300-60";
export const COLOR_DARK300_65 = "eon-dark300-65";
export const COLOR_DARK300_70 = "eon-dark300-70";
export const COLOR_DARK300_75 = "eon-dark300-75";
export const COLOR_DARK300_80 = "eon-dark300-80";
export const COLOR_DARK300_85 = "eon-dark300-85";
export const COLOR_DARK300_90 = "eon-dark300-90";
export const COLOR_DARK300_95 = "eon-dark300-95";
export const COLOR_DARK300_OPACITY_5 = "eon-dark300-opacity-5";
export const COLOR_DARK300_OPACITY_10 = "eon-dark300-opacity-10";
export const COLOR_DARK300_OPACITY_15 = "eon-dark300-opacity-15";
export const COLOR_DARK300_OPACITY_20 = "eon-dark300-opacity-20";
export const COLOR_DARK300_OPACITY_25 = "eon-dark300-opacity-25";
export const COLOR_DARK300_OPACITY_30 = "eon-dark300-opacity-30";
export const COLOR_DARK300_OPACITY_35 = "eon-dark300-opacity-35";
export const COLOR_DARK300_OPACITY_40 = "eon-dark300-opacity-40";
export const COLOR_DARK300_OPACITY_45 = "eon-dark300-opacity-45";
export const COLOR_DARK300_OPACITY_50 = "eon-dark300-opacity-50";
export const COLOR_DARK300_OPACITY_55 = "eon-dark300-opacity-55";
export const COLOR_DARK300_OPACITY_60 = "eon-dark300-opacity-60";
export const COLOR_DARK300_OPACITY_65 = "eon-dark300-opacity-65";
export const COLOR_DARK300_OPACITY_70 = "eon-dark300-opacity-70";
export const COLOR_DARK300_OPACITY_75 = "eon-dark300-opacity-75";
export const COLOR_DARK300_OPACITY_80 = "eon-dark300-opacity-80";
export const COLOR_DARK300_OPACITY_85 = "eon-dark300-opacity-85";
export const COLOR_DARK300_OPACITY_90 = "eon-dark300-opacity-90";
export const COLOR_DARK300_OPACITY_95 = "eon-dark300-opacity-95";
export const COLOR_DARK100_SHADE_1 = "eon-dark100-shade-1";
export const COLOR_DARK100_SHADE_2 = "eon-dark100-shade-2";
export const COLOR_DARK100_TINT_1 = "eon-dark100-tint-1";
export const COLOR_DARK100_TINT_2 = "eon-dark100-tint-2";
export const COLOR_DARK100_5 = "eon-dark100-5";
export const COLOR_DARK100_10 = "eon-dark100-10";
export const COLOR_DARK100_15 = "eon-dark100-15";
export const COLOR_DARK100_20 = "eon-dark100-20";
export const COLOR_DARK100_25 = "eon-dark100-25";
export const COLOR_DARK100_30 = "eon-dark100-30";
export const COLOR_DARK100_35 = "eon-dark100-35";
export const COLOR_DARK100_40 = "eon-dark100-40";
export const COLOR_DARK100_45 = "eon-dark100-45";
export const COLOR_DARK100_50 = "eon-dark100-50";
export const COLOR_DARK100_55 = "eon-dark100-55";
export const COLOR_DARK100_60 = "eon-dark100-60";
export const COLOR_DARK100_65 = "eon-dark100-65";
export const COLOR_DARK100_70 = "eon-dark100-70";
export const COLOR_DARK100_75 = "eon-dark100-75";
export const COLOR_DARK100_80 = "eon-dark100-80";
export const COLOR_DARK100_85 = "eon-dark100-85";
export const COLOR_DARK100_90 = "eon-dark100-90";
export const COLOR_DARK100_95 = "eon-dark100-95";
export const COLOR_DARK100_OPACITY_5 = "eon-dark100-opacity-5";
export const COLOR_DARK100_OPACITY_10 = "eon-dark100-opacity-10";
export const COLOR_DARK100_OPACITY_15 = "eon-dark100-opacity-15";
export const COLOR_DARK100_OPACITY_20 = "eon-dark100-opacity-20";
export const COLOR_DARK100_OPACITY_25 = "eon-dark100-opacity-25";
export const COLOR_DARK100_OPACITY_30 = "eon-dark100-opacity-30";
export const COLOR_DARK100_OPACITY_35 = "eon-dark100-opacity-35";
export const COLOR_DARK100_OPACITY_40 = "eon-dark100-opacity-40";
export const COLOR_DARK100_OPACITY_45 = "eon-dark100-opacity-45";
export const COLOR_DARK100_OPACITY_50 = "eon-dark100-opacity-50";
export const COLOR_DARK100_OPACITY_55 = "eon-dark100-opacity-55";
export const COLOR_DARK100_OPACITY_60 = "eon-dark100-opacity-60";
export const COLOR_DARK100_OPACITY_65 = "eon-dark100-opacity-65";
export const COLOR_DARK100_OPACITY_70 = "eon-dark100-opacity-70";
export const COLOR_DARK100_OPACITY_75 = "eon-dark100-opacity-75";
export const COLOR_DARK100_OPACITY_80 = "eon-dark100-opacity-80";
export const COLOR_DARK100_OPACITY_85 = "eon-dark100-opacity-85";
export const COLOR_DARK100_OPACITY_90 = "eon-dark100-opacity-90";
export const COLOR_DARK100_OPACITY_95 = "eon-dark100-opacity-95";
export const COLOR_BLUE_SHADE_1 = "eon-blue-shade-1";
export const COLOR_BLUE_SHADE_2 = "eon-blue-shade-2";
export const COLOR_BLUE_TINT_1 = "eon-blue-tint-1";
export const COLOR_BLUE_TINT_2 = "eon-blue-tint-2";
export const COLOR_BLUE_5 = "eon-blue-5";
export const COLOR_BLUE_10 = "eon-blue-10";
export const COLOR_BLUE_15 = "eon-blue-15";
export const COLOR_BLUE_20 = "eon-blue-20";
export const COLOR_BLUE_25 = "eon-blue-25";
export const COLOR_BLUE_30 = "eon-blue-30";
export const COLOR_BLUE_35 = "eon-blue-35";
export const COLOR_BLUE_40 = "eon-blue-40";
export const COLOR_BLUE_45 = "eon-blue-45";
export const COLOR_BLUE_50 = "eon-blue-50";
export const COLOR_BLUE_55 = "eon-blue-55";
export const COLOR_BLUE_60 = "eon-blue-60";
export const COLOR_BLUE_65 = "eon-blue-65";
export const COLOR_BLUE_70 = "eon-blue-70";
export const COLOR_BLUE_75 = "eon-blue-75";
export const COLOR_BLUE_80 = "eon-blue-80";
export const COLOR_BLUE_85 = "eon-blue-85";
export const COLOR_BLUE_90 = "eon-blue-90";
export const COLOR_BLUE_95 = "eon-blue-95";
export const COLOR_BLUE_OPACITY_5 = "eon-blue-opacity-5";
export const COLOR_BLUE_OPACITY_10 = "eon-blue-opacity-10";
export const COLOR_BLUE_OPACITY_15 = "eon-blue-opacity-15";
export const COLOR_BLUE_OPACITY_20 = "eon-blue-opacity-20";
export const COLOR_BLUE_OPACITY_25 = "eon-blue-opacity-25";
export const COLOR_BLUE_OPACITY_30 = "eon-blue-opacity-30";
export const COLOR_BLUE_OPACITY_35 = "eon-blue-opacity-35";
export const COLOR_BLUE_OPACITY_40 = "eon-blue-opacity-40";
export const COLOR_BLUE_OPACITY_45 = "eon-blue-opacity-45";
export const COLOR_BLUE_OPACITY_50 = "eon-blue-opacity-50";
export const COLOR_BLUE_OPACITY_55 = "eon-blue-opacity-55";
export const COLOR_BLUE_OPACITY_60 = "eon-blue-opacity-60";
export const COLOR_BLUE_OPACITY_65 = "eon-blue-opacity-65";
export const COLOR_BLUE_OPACITY_70 = "eon-blue-opacity-70";
export const COLOR_BLUE_OPACITY_75 = "eon-blue-opacity-75";
export const COLOR_BLUE_OPACITY_80 = "eon-blue-opacity-80";
export const COLOR_BLUE_OPACITY_85 = "eon-blue-opacity-85";
export const COLOR_BLUE_OPACITY_90 = "eon-blue-opacity-90";
export const COLOR_BLUE_OPACITY_95 = "eon-blue-opacity-95";
export const COLOR_ULTRALIGHTGREY_SHADE_1 = "eon-ultralightgrey-shade-1";
export const COLOR_ULTRALIGHTGREY_SHADE_2 = "eon-ultralightgrey-shade-2";
export const COLOR_ULTRALIGHTGREY_TINT_1 = "eon-ultralightgrey-tint-1";
export const COLOR_ULTRALIGHTGREY_TINT_2 = "eon-ultralightgrey-tint-2";
export const COLOR_ULTRALIGHTGREY_5 = "eon-ultralightgrey-5";
export const COLOR_ULTRALIGHTGREY_10 = "eon-ultralightgrey-10";
export const COLOR_ULTRALIGHTGREY_15 = "eon-ultralightgrey-15";
export const COLOR_ULTRALIGHTGREY_20 = "eon-ultralightgrey-20";
export const COLOR_ULTRALIGHTGREY_25 = "eon-ultralightgrey-25";
export const COLOR_ULTRALIGHTGREY_30 = "eon-ultralightgrey-30";
export const COLOR_ULTRALIGHTGREY_35 = "eon-ultralightgrey-35";
export const COLOR_ULTRALIGHTGREY_40 = "eon-ultralightgrey-40";
export const COLOR_ULTRALIGHTGREY_45 = "eon-ultralightgrey-45";
export const COLOR_ULTRALIGHTGREY_50 = "eon-ultralightgrey-50";
export const COLOR_ULTRALIGHTGREY_55 = "eon-ultralightgrey-55";
export const COLOR_ULTRALIGHTGREY_60 = "eon-ultralightgrey-60";
export const COLOR_ULTRALIGHTGREY_65 = "eon-ultralightgrey-65";
export const COLOR_ULTRALIGHTGREY_70 = "eon-ultralightgrey-70";
export const COLOR_ULTRALIGHTGREY_75 = "eon-ultralightgrey-75";
export const COLOR_ULTRALIGHTGREY_80 = "eon-ultralightgrey-80";
export const COLOR_ULTRALIGHTGREY_85 = "eon-ultralightgrey-85";
export const COLOR_ULTRALIGHTGREY_90 = "eon-ultralightgrey-90";
export const COLOR_ULTRALIGHTGREY_95 = "eon-ultralightgrey-95";
export const COLOR_ULTRALIGHTGREY_OPACITY_5 = "eon-ultralightgrey-opacity-5";
export const COLOR_ULTRALIGHTGREY_OPACITY_10 = "eon-ultralightgrey-opacity-10";
export const COLOR_ULTRALIGHTGREY_OPACITY_15 = "eon-ultralightgrey-opacity-15";
export const COLOR_ULTRALIGHTGREY_OPACITY_20 = "eon-ultralightgrey-opacity-20";
export const COLOR_ULTRALIGHTGREY_OPACITY_25 = "eon-ultralightgrey-opacity-25";
export const COLOR_ULTRALIGHTGREY_OPACITY_30 = "eon-ultralightgrey-opacity-30";
export const COLOR_ULTRALIGHTGREY_OPACITY_35 = "eon-ultralightgrey-opacity-35";
export const COLOR_ULTRALIGHTGREY_OPACITY_40 = "eon-ultralightgrey-opacity-40";
export const COLOR_ULTRALIGHTGREY_OPACITY_45 = "eon-ultralightgrey-opacity-45";
export const COLOR_ULTRALIGHTGREY_OPACITY_50 = "eon-ultralightgrey-opacity-50";
export const COLOR_ULTRALIGHTGREY_OPACITY_55 = "eon-ultralightgrey-opacity-55";
export const COLOR_ULTRALIGHTGREY_OPACITY_60 = "eon-ultralightgrey-opacity-60";
export const COLOR_ULTRALIGHTGREY_OPACITY_65 = "eon-ultralightgrey-opacity-65";
export const COLOR_ULTRALIGHTGREY_OPACITY_70 = "eon-ultralightgrey-opacity-70";
export const COLOR_ULTRALIGHTGREY_OPACITY_75 = "eon-ultralightgrey-opacity-75";
export const COLOR_ULTRALIGHTGREY_OPACITY_80 = "eon-ultralightgrey-opacity-80";
export const COLOR_ULTRALIGHTGREY_OPACITY_85 = "eon-ultralightgrey-opacity-85";
export const COLOR_ULTRALIGHTGREY_OPACITY_90 = "eon-ultralightgrey-opacity-90";
export const COLOR_ULTRALIGHTGREY_OPACITY_95 = "eon-ultralightgrey-opacity-95";
export const COLOR_LIGHT_GREEN_SHADE_1 = "eon-light-green-shade-1";
export const COLOR_LIGHT_GREEN_SHADE_2 = "eon-light-green-shade-2";
export const COLOR_LIGHT_GREEN_TINT_1 = "eon-light-green-tint-1";
export const COLOR_LIGHT_GREEN_TINT_2 = "eon-light-green-tint-2";
export const COLOR_LIGHT_GREEN_5 = "eon-light-green-5";
export const COLOR_LIGHT_GREEN_10 = "eon-light-green-10";
export const COLOR_LIGHT_GREEN_15 = "eon-light-green-15";
export const COLOR_LIGHT_GREEN_20 = "eon-light-green-20";
export const COLOR_LIGHT_GREEN_25 = "eon-light-green-25";
export const COLOR_LIGHT_GREEN_30 = "eon-light-green-30";
export const COLOR_LIGHT_GREEN_35 = "eon-light-green-35";
export const COLOR_LIGHT_GREEN_40 = "eon-light-green-40";
export const COLOR_LIGHT_GREEN_45 = "eon-light-green-45";
export const COLOR_LIGHT_GREEN_50 = "eon-light-green-50";
export const COLOR_LIGHT_GREEN_55 = "eon-light-green-55";
export const COLOR_LIGHT_GREEN_60 = "eon-light-green-60";
export const COLOR_LIGHT_GREEN_65 = "eon-light-green-65";
export const COLOR_LIGHT_GREEN_70 = "eon-light-green-70";
export const COLOR_LIGHT_GREEN_75 = "eon-light-green-75";
export const COLOR_LIGHT_GREEN_80 = "eon-light-green-80";
export const COLOR_LIGHT_GREEN_85 = "eon-light-green-85";
export const COLOR_LIGHT_GREEN_90 = "eon-light-green-90";
export const COLOR_LIGHT_GREEN_95 = "eon-light-green-95";
export const COLOR_LIGHT_GREEN_OPACITY_5 = "eon-light-green-opacity-5";
export const COLOR_LIGHT_GREEN_OPACITY_10 = "eon-light-green-opacity-10";
export const COLOR_LIGHT_GREEN_OPACITY_15 = "eon-light-green-opacity-15";
export const COLOR_LIGHT_GREEN_OPACITY_20 = "eon-light-green-opacity-20";
export const COLOR_LIGHT_GREEN_OPACITY_25 = "eon-light-green-opacity-25";
export const COLOR_LIGHT_GREEN_OPACITY_30 = "eon-light-green-opacity-30";
export const COLOR_LIGHT_GREEN_OPACITY_35 = "eon-light-green-opacity-35";
export const COLOR_LIGHT_GREEN_OPACITY_40 = "eon-light-green-opacity-40";
export const COLOR_LIGHT_GREEN_OPACITY_45 = "eon-light-green-opacity-45";
export const COLOR_LIGHT_GREEN_OPACITY_50 = "eon-light-green-opacity-50";
export const COLOR_LIGHT_GREEN_OPACITY_55 = "eon-light-green-opacity-55";
export const COLOR_LIGHT_GREEN_OPACITY_60 = "eon-light-green-opacity-60";
export const COLOR_LIGHT_GREEN_OPACITY_65 = "eon-light-green-opacity-65";
export const COLOR_LIGHT_GREEN_OPACITY_70 = "eon-light-green-opacity-70";
export const COLOR_LIGHT_GREEN_OPACITY_75 = "eon-light-green-opacity-75";
export const COLOR_LIGHT_GREEN_OPACITY_80 = "eon-light-green-opacity-80";
export const COLOR_LIGHT_GREEN_OPACITY_85 = "eon-light-green-opacity-85";
export const COLOR_LIGHT_GREEN_OPACITY_90 = "eon-light-green-opacity-90";
export const COLOR_LIGHT_GREEN_OPACITY_95 = "eon-light-green-opacity-95";
export const COLOR_LIGHT_RED_SHADE_1 = "eon-light-red-shade-1";
export const COLOR_LIGHT_RED_SHADE_2 = "eon-light-red-shade-2";
export const COLOR_LIGHT_RED_TINT_1 = "eon-light-red-tint-1";
export const COLOR_LIGHT_RED_TINT_2 = "eon-light-red-tint-2";
export const COLOR_LIGHT_RED_5 = "eon-light-red-5";
export const COLOR_LIGHT_RED_10 = "eon-light-red-10";
export const COLOR_LIGHT_RED_15 = "eon-light-red-15";
export const COLOR_LIGHT_RED_20 = "eon-light-red-20";
export const COLOR_LIGHT_RED_25 = "eon-light-red-25";
export const COLOR_LIGHT_RED_30 = "eon-light-red-30";
export const COLOR_LIGHT_RED_35 = "eon-light-red-35";
export const COLOR_LIGHT_RED_40 = "eon-light-red-40";
export const COLOR_LIGHT_RED_45 = "eon-light-red-45";
export const COLOR_LIGHT_RED_50 = "eon-light-red-50";
export const COLOR_LIGHT_RED_55 = "eon-light-red-55";
export const COLOR_LIGHT_RED_60 = "eon-light-red-60";
export const COLOR_LIGHT_RED_65 = "eon-light-red-65";
export const COLOR_LIGHT_RED_70 = "eon-light-red-70";
export const COLOR_LIGHT_RED_75 = "eon-light-red-75";
export const COLOR_LIGHT_RED_80 = "eon-light-red-80";
export const COLOR_LIGHT_RED_85 = "eon-light-red-85";
export const COLOR_LIGHT_RED_90 = "eon-light-red-90";
export const COLOR_LIGHT_RED_95 = "eon-light-red-95";
export const COLOR_LIGHT_RED_OPACITY_5 = "eon-light-red-opacity-5";
export const COLOR_LIGHT_RED_OPACITY_10 = "eon-light-red-opacity-10";
export const COLOR_LIGHT_RED_OPACITY_15 = "eon-light-red-opacity-15";
export const COLOR_LIGHT_RED_OPACITY_20 = "eon-light-red-opacity-20";
export const COLOR_LIGHT_RED_OPACITY_25 = "eon-light-red-opacity-25";
export const COLOR_LIGHT_RED_OPACITY_30 = "eon-light-red-opacity-30";
export const COLOR_LIGHT_RED_OPACITY_35 = "eon-light-red-opacity-35";
export const COLOR_LIGHT_RED_OPACITY_40 = "eon-light-red-opacity-40";
export const COLOR_LIGHT_RED_OPACITY_45 = "eon-light-red-opacity-45";
export const COLOR_LIGHT_RED_OPACITY_50 = "eon-light-red-opacity-50";
export const COLOR_LIGHT_RED_OPACITY_55 = "eon-light-red-opacity-55";
export const COLOR_LIGHT_RED_OPACITY_60 = "eon-light-red-opacity-60";
export const COLOR_LIGHT_RED_OPACITY_65 = "eon-light-red-opacity-65";
export const COLOR_LIGHT_RED_OPACITY_70 = "eon-light-red-opacity-70";
export const COLOR_LIGHT_RED_OPACITY_75 = "eon-light-red-opacity-75";
export const COLOR_LIGHT_RED_OPACITY_80 = "eon-light-red-opacity-80";
export const COLOR_LIGHT_RED_OPACITY_85 = "eon-light-red-opacity-85";
export const COLOR_LIGHT_RED_OPACITY_90 = "eon-light-red-opacity-90";
export const COLOR_LIGHT_RED_OPACITY_95 = "eon-light-red-opacity-95";
export const COLOR_LIGHT_YELLOW_SHADE_1 = "eon-light-yellow-shade-1";
export const COLOR_LIGHT_YELLOW_SHADE_2 = "eon-light-yellow-shade-2";
export const COLOR_LIGHT_YELLOW_TINT_1 = "eon-light-yellow-tint-1";
export const COLOR_LIGHT_YELLOW_TINT_2 = "eon-light-yellow-tint-2";
export const COLOR_LIGHT_YELLOW_5 = "eon-light-yellow-5";
export const COLOR_LIGHT_YELLOW_10 = "eon-light-yellow-10";
export const COLOR_LIGHT_YELLOW_15 = "eon-light-yellow-15";
export const COLOR_LIGHT_YELLOW_20 = "eon-light-yellow-20";
export const COLOR_LIGHT_YELLOW_25 = "eon-light-yellow-25";
export const COLOR_LIGHT_YELLOW_30 = "eon-light-yellow-30";
export const COLOR_LIGHT_YELLOW_35 = "eon-light-yellow-35";
export const COLOR_LIGHT_YELLOW_40 = "eon-light-yellow-40";
export const COLOR_LIGHT_YELLOW_45 = "eon-light-yellow-45";
export const COLOR_LIGHT_YELLOW_50 = "eon-light-yellow-50";
export const COLOR_LIGHT_YELLOW_55 = "eon-light-yellow-55";
export const COLOR_LIGHT_YELLOW_60 = "eon-light-yellow-60";
export const COLOR_LIGHT_YELLOW_65 = "eon-light-yellow-65";
export const COLOR_LIGHT_YELLOW_70 = "eon-light-yellow-70";
export const COLOR_LIGHT_YELLOW_75 = "eon-light-yellow-75";
export const COLOR_LIGHT_YELLOW_80 = "eon-light-yellow-80";
export const COLOR_LIGHT_YELLOW_85 = "eon-light-yellow-85";
export const COLOR_LIGHT_YELLOW_90 = "eon-light-yellow-90";
export const COLOR_LIGHT_YELLOW_95 = "eon-light-yellow-95";
export const COLOR_LIGHT_YELLOW_OPACITY_5 = "eon-light-yellow-opacity-5";
export const COLOR_LIGHT_YELLOW_OPACITY_10 = "eon-light-yellow-opacity-10";
export const COLOR_LIGHT_YELLOW_OPACITY_15 = "eon-light-yellow-opacity-15";
export const COLOR_LIGHT_YELLOW_OPACITY_20 = "eon-light-yellow-opacity-20";
export const COLOR_LIGHT_YELLOW_OPACITY_25 = "eon-light-yellow-opacity-25";
export const COLOR_LIGHT_YELLOW_OPACITY_30 = "eon-light-yellow-opacity-30";
export const COLOR_LIGHT_YELLOW_OPACITY_35 = "eon-light-yellow-opacity-35";
export const COLOR_LIGHT_YELLOW_OPACITY_40 = "eon-light-yellow-opacity-40";
export const COLOR_LIGHT_YELLOW_OPACITY_45 = "eon-light-yellow-opacity-45";
export const COLOR_LIGHT_YELLOW_OPACITY_50 = "eon-light-yellow-opacity-50";
export const COLOR_LIGHT_YELLOW_OPACITY_55 = "eon-light-yellow-opacity-55";
export const COLOR_LIGHT_YELLOW_OPACITY_60 = "eon-light-yellow-opacity-60";
export const COLOR_LIGHT_YELLOW_OPACITY_65 = "eon-light-yellow-opacity-65";
export const COLOR_LIGHT_YELLOW_OPACITY_70 = "eon-light-yellow-opacity-70";
export const COLOR_LIGHT_YELLOW_OPACITY_75 = "eon-light-yellow-opacity-75";
export const COLOR_LIGHT_YELLOW_OPACITY_80 = "eon-light-yellow-opacity-80";
export const COLOR_LIGHT_YELLOW_OPACITY_85 = "eon-light-yellow-opacity-85";
export const COLOR_LIGHT_YELLOW_OPACITY_90 = "eon-light-yellow-opacity-90";
export const COLOR_LIGHT_YELLOW_OPACITY_95 = "eon-light-yellow-opacity-95";
export const COLOR_LIGHT_BLUE_SHADE_1 = "eon-light-blue-shade-1";
export const COLOR_LIGHT_BLUE_SHADE_2 = "eon-light-blue-shade-2";
export const COLOR_LIGHT_BLUE_TINT_1 = "eon-light-blue-tint-1";
export const COLOR_LIGHT_BLUE_TINT_2 = "eon-light-blue-tint-2";
export const COLOR_LIGHT_BLUE_5 = "eon-light-blue-5";
export const COLOR_LIGHT_BLUE_10 = "eon-light-blue-10";
export const COLOR_LIGHT_BLUE_15 = "eon-light-blue-15";
export const COLOR_LIGHT_BLUE_20 = "eon-light-blue-20";
export const COLOR_LIGHT_BLUE_25 = "eon-light-blue-25";
export const COLOR_LIGHT_BLUE_30 = "eon-light-blue-30";
export const COLOR_LIGHT_BLUE_35 = "eon-light-blue-35";
export const COLOR_LIGHT_BLUE_40 = "eon-light-blue-40";
export const COLOR_LIGHT_BLUE_45 = "eon-light-blue-45";
export const COLOR_LIGHT_BLUE_50 = "eon-light-blue-50";
export const COLOR_LIGHT_BLUE_55 = "eon-light-blue-55";
export const COLOR_LIGHT_BLUE_60 = "eon-light-blue-60";
export const COLOR_LIGHT_BLUE_65 = "eon-light-blue-65";
export const COLOR_LIGHT_BLUE_70 = "eon-light-blue-70";
export const COLOR_LIGHT_BLUE_75 = "eon-light-blue-75";
export const COLOR_LIGHT_BLUE_80 = "eon-light-blue-80";
export const COLOR_LIGHT_BLUE_85 = "eon-light-blue-85";
export const COLOR_LIGHT_BLUE_90 = "eon-light-blue-90";
export const COLOR_LIGHT_BLUE_95 = "eon-light-blue-95";
export const COLOR_LIGHT_BLUE_OPACITY_5 = "eon-light-blue-opacity-5";
export const COLOR_LIGHT_BLUE_OPACITY_10 = "eon-light-blue-opacity-10";
export const COLOR_LIGHT_BLUE_OPACITY_15 = "eon-light-blue-opacity-15";
export const COLOR_LIGHT_BLUE_OPACITY_20 = "eon-light-blue-opacity-20";
export const COLOR_LIGHT_BLUE_OPACITY_25 = "eon-light-blue-opacity-25";
export const COLOR_LIGHT_BLUE_OPACITY_30 = "eon-light-blue-opacity-30";
export const COLOR_LIGHT_BLUE_OPACITY_35 = "eon-light-blue-opacity-35";
export const COLOR_LIGHT_BLUE_OPACITY_40 = "eon-light-blue-opacity-40";
export const COLOR_LIGHT_BLUE_OPACITY_45 = "eon-light-blue-opacity-45";
export const COLOR_LIGHT_BLUE_OPACITY_50 = "eon-light-blue-opacity-50";
export const COLOR_LIGHT_BLUE_OPACITY_55 = "eon-light-blue-opacity-55";
export const COLOR_LIGHT_BLUE_OPACITY_60 = "eon-light-blue-opacity-60";
export const COLOR_LIGHT_BLUE_OPACITY_65 = "eon-light-blue-opacity-65";
export const COLOR_LIGHT_BLUE_OPACITY_70 = "eon-light-blue-opacity-70";
export const COLOR_LIGHT_BLUE_OPACITY_75 = "eon-light-blue-opacity-75";
export const COLOR_LIGHT_BLUE_OPACITY_80 = "eon-light-blue-opacity-80";
export const COLOR_LIGHT_BLUE_OPACITY_85 = "eon-light-blue-opacity-85";
export const COLOR_LIGHT_BLUE_OPACITY_90 = "eon-light-blue-opacity-90";
export const COLOR_LIGHT_BLUE_OPACITY_95 = "eon-light-blue-opacity-95";

export const EON_COLORS = [
  COLOR_PINK500,
  COLOR_PINK700,
  COLOR_PURPLE500,
  COLOR_ORANGE500,
  COLOR_YELLOW500,
  COLOR_BLUE500,
  COLOR_BLUE700,
  COLOR_BLUE900,
  COLOR_BRIGHTBLUE500,
  COLOR_GREEN500,
  COLOR_GREEN900,
  COLOR_BRIGHTGREEN500,
  COLOR_PINK,
  COLOR_DARK_PINK,
  COLOR_BRIGHT_BLUE,
  COLOR_CYAN,
  COLOR_DARKBLUE,
  COLOR_RED,
  COLOR_YELLOW,
  COLOR_GREEN,
  COLOR_WHITE,
  COLOR_BRIGHT,
  COLOR_DARK,
  COLOR_DARK900,
  COLOR_DARK700,
  COLOR_DARK600,
  COLOR_DARK400,
  COLOR_DARK300,
  COLOR_DARK100,
  COLOR_BLUE,
  COLOR_ULTRALIGHTGREY,
  COLOR_LIGHT_GREEN,
  COLOR_LIGHT_RED,
  COLOR_LIGHT_YELLOW,
  COLOR_LIGHT_BLUE,
  COLOR_PINK500_SHADE_1,
  COLOR_PINK500_SHADE_2,
  COLOR_PINK500_TINT_1,
  COLOR_PINK500_TINT_2,
  COLOR_PINK500_5,
  COLOR_PINK500_10,
  COLOR_PINK500_15,
  COLOR_PINK500_20,
  COLOR_PINK500_25,
  COLOR_PINK500_30,
  COLOR_PINK500_35,
  COLOR_PINK500_40,
  COLOR_PINK500_45,
  COLOR_PINK500_50,
  COLOR_PINK500_55,
  COLOR_PINK500_60,
  COLOR_PINK500_65,
  COLOR_PINK500_70,
  COLOR_PINK500_75,
  COLOR_PINK500_80,
  COLOR_PINK500_85,
  COLOR_PINK500_90,
  COLOR_PINK500_95,
  COLOR_PINK500_OPACITY_5,
  COLOR_PINK500_OPACITY_10,
  COLOR_PINK500_OPACITY_15,
  COLOR_PINK500_OPACITY_20,
  COLOR_PINK500_OPACITY_25,
  COLOR_PINK500_OPACITY_30,
  COLOR_PINK500_OPACITY_35,
  COLOR_PINK500_OPACITY_40,
  COLOR_PINK500_OPACITY_45,
  COLOR_PINK500_OPACITY_50,
  COLOR_PINK500_OPACITY_55,
  COLOR_PINK500_OPACITY_60,
  COLOR_PINK500_OPACITY_65,
  COLOR_PINK500_OPACITY_70,
  COLOR_PINK500_OPACITY_75,
  COLOR_PINK500_OPACITY_80,
  COLOR_PINK500_OPACITY_85,
  COLOR_PINK500_OPACITY_90,
  COLOR_PINK500_OPACITY_95,
  COLOR_PINK700_SHADE_1,
  COLOR_PINK700_SHADE_2,
  COLOR_PINK700_TINT_1,
  COLOR_PINK700_TINT_2,
  COLOR_PINK700_5,
  COLOR_PINK700_10,
  COLOR_PINK700_15,
  COLOR_PINK700_20,
  COLOR_PINK700_25,
  COLOR_PINK700_30,
  COLOR_PINK700_35,
  COLOR_PINK700_40,
  COLOR_PINK700_45,
  COLOR_PINK700_50,
  COLOR_PINK700_55,
  COLOR_PINK700_60,
  COLOR_PINK700_65,
  COLOR_PINK700_70,
  COLOR_PINK700_75,
  COLOR_PINK700_80,
  COLOR_PINK700_85,
  COLOR_PINK700_90,
  COLOR_PINK700_95,
  COLOR_PINK700_OPACITY_5,
  COLOR_PINK700_OPACITY_10,
  COLOR_PINK700_OPACITY_15,
  COLOR_PINK700_OPACITY_20,
  COLOR_PINK700_OPACITY_25,
  COLOR_PINK700_OPACITY_30,
  COLOR_PINK700_OPACITY_35,
  COLOR_PINK700_OPACITY_40,
  COLOR_PINK700_OPACITY_45,
  COLOR_PINK700_OPACITY_50,
  COLOR_PINK700_OPACITY_55,
  COLOR_PINK700_OPACITY_60,
  COLOR_PINK700_OPACITY_65,
  COLOR_PINK700_OPACITY_70,
  COLOR_PINK700_OPACITY_75,
  COLOR_PINK700_OPACITY_80,
  COLOR_PINK700_OPACITY_85,
  COLOR_PINK700_OPACITY_90,
  COLOR_PINK700_OPACITY_95,
  COLOR_PURPLE500_SHADE_1,
  COLOR_PURPLE500_SHADE_2,
  COLOR_PURPLE500_TINT_1,
  COLOR_PURPLE500_TINT_2,
  COLOR_PURPLE500_5,
  COLOR_PURPLE500_10,
  COLOR_PURPLE500_15,
  COLOR_PURPLE500_20,
  COLOR_PURPLE500_25,
  COLOR_PURPLE500_30,
  COLOR_PURPLE500_35,
  COLOR_PURPLE500_40,
  COLOR_PURPLE500_45,
  COLOR_PURPLE500_50,
  COLOR_PURPLE500_55,
  COLOR_PURPLE500_60,
  COLOR_PURPLE500_65,
  COLOR_PURPLE500_70,
  COLOR_PURPLE500_75,
  COLOR_PURPLE500_80,
  COLOR_PURPLE500_85,
  COLOR_PURPLE500_90,
  COLOR_PURPLE500_95,
  COLOR_PURPLE500_OPACITY_5,
  COLOR_PURPLE500_OPACITY_10,
  COLOR_PURPLE500_OPACITY_15,
  COLOR_PURPLE500_OPACITY_20,
  COLOR_PURPLE500_OPACITY_25,
  COLOR_PURPLE500_OPACITY_30,
  COLOR_PURPLE500_OPACITY_35,
  COLOR_PURPLE500_OPACITY_40,
  COLOR_PURPLE500_OPACITY_45,
  COLOR_PURPLE500_OPACITY_50,
  COLOR_PURPLE500_OPACITY_55,
  COLOR_PURPLE500_OPACITY_60,
  COLOR_PURPLE500_OPACITY_65,
  COLOR_PURPLE500_OPACITY_70,
  COLOR_PURPLE500_OPACITY_75,
  COLOR_PURPLE500_OPACITY_80,
  COLOR_PURPLE500_OPACITY_85,
  COLOR_PURPLE500_OPACITY_90,
  COLOR_PURPLE500_OPACITY_95,
  COLOR_ORANGE500_SHADE_1,
  COLOR_ORANGE500_SHADE_2,
  COLOR_ORANGE500_TINT_1,
  COLOR_ORANGE500_TINT_2,
  COLOR_ORANGE500_5,
  COLOR_ORANGE500_10,
  COLOR_ORANGE500_15,
  COLOR_ORANGE500_20,
  COLOR_ORANGE500_25,
  COLOR_ORANGE500_30,
  COLOR_ORANGE500_35,
  COLOR_ORANGE500_40,
  COLOR_ORANGE500_45,
  COLOR_ORANGE500_50,
  COLOR_ORANGE500_55,
  COLOR_ORANGE500_60,
  COLOR_ORANGE500_65,
  COLOR_ORANGE500_70,
  COLOR_ORANGE500_75,
  COLOR_ORANGE500_80,
  COLOR_ORANGE500_85,
  COLOR_ORANGE500_90,
  COLOR_ORANGE500_95,
  COLOR_ORANGE500_OPACITY_5,
  COLOR_ORANGE500_OPACITY_10,
  COLOR_ORANGE500_OPACITY_15,
  COLOR_ORANGE500_OPACITY_20,
  COLOR_ORANGE500_OPACITY_25,
  COLOR_ORANGE500_OPACITY_30,
  COLOR_ORANGE500_OPACITY_35,
  COLOR_ORANGE500_OPACITY_40,
  COLOR_ORANGE500_OPACITY_45,
  COLOR_ORANGE500_OPACITY_50,
  COLOR_ORANGE500_OPACITY_55,
  COLOR_ORANGE500_OPACITY_60,
  COLOR_ORANGE500_OPACITY_65,
  COLOR_ORANGE500_OPACITY_70,
  COLOR_ORANGE500_OPACITY_75,
  COLOR_ORANGE500_OPACITY_80,
  COLOR_ORANGE500_OPACITY_85,
  COLOR_ORANGE500_OPACITY_90,
  COLOR_ORANGE500_OPACITY_95,
  COLOR_YELLOW500_SHADE_1,
  COLOR_YELLOW500_SHADE_2,
  COLOR_YELLOW500_TINT_1,
  COLOR_YELLOW500_TINT_2,
  COLOR_YELLOW500_5,
  COLOR_YELLOW500_10,
  COLOR_YELLOW500_15,
  COLOR_YELLOW500_20,
  COLOR_YELLOW500_25,
  COLOR_YELLOW500_30,
  COLOR_YELLOW500_35,
  COLOR_YELLOW500_40,
  COLOR_YELLOW500_45,
  COLOR_YELLOW500_50,
  COLOR_YELLOW500_55,
  COLOR_YELLOW500_60,
  COLOR_YELLOW500_65,
  COLOR_YELLOW500_70,
  COLOR_YELLOW500_75,
  COLOR_YELLOW500_80,
  COLOR_YELLOW500_85,
  COLOR_YELLOW500_90,
  COLOR_YELLOW500_95,
  COLOR_YELLOW500_OPACITY_5,
  COLOR_YELLOW500_OPACITY_10,
  COLOR_YELLOW500_OPACITY_15,
  COLOR_YELLOW500_OPACITY_20,
  COLOR_YELLOW500_OPACITY_25,
  COLOR_YELLOW500_OPACITY_30,
  COLOR_YELLOW500_OPACITY_35,
  COLOR_YELLOW500_OPACITY_40,
  COLOR_YELLOW500_OPACITY_45,
  COLOR_YELLOW500_OPACITY_50,
  COLOR_YELLOW500_OPACITY_55,
  COLOR_YELLOW500_OPACITY_60,
  COLOR_YELLOW500_OPACITY_65,
  COLOR_YELLOW500_OPACITY_70,
  COLOR_YELLOW500_OPACITY_75,
  COLOR_YELLOW500_OPACITY_80,
  COLOR_YELLOW500_OPACITY_85,
  COLOR_YELLOW500_OPACITY_90,
  COLOR_YELLOW500_OPACITY_95,
  COLOR_BLUE500_SHADE_1,
  COLOR_BLUE500_SHADE_2,
  COLOR_BLUE500_TINT_1,
  COLOR_BLUE500_TINT_2,
  COLOR_BLUE500_5,
  COLOR_BLUE500_10,
  COLOR_BLUE500_15,
  COLOR_BLUE500_20,
  COLOR_BLUE500_25,
  COLOR_BLUE500_30,
  COLOR_BLUE500_35,
  COLOR_BLUE500_40,
  COLOR_BLUE500_45,
  COLOR_BLUE500_50,
  COLOR_BLUE500_55,
  COLOR_BLUE500_60,
  COLOR_BLUE500_65,
  COLOR_BLUE500_70,
  COLOR_BLUE500_75,
  COLOR_BLUE500_80,
  COLOR_BLUE500_85,
  COLOR_BLUE500_90,
  COLOR_BLUE500_95,
  COLOR_BLUE500_OPACITY_5,
  COLOR_BLUE500_OPACITY_10,
  COLOR_BLUE500_OPACITY_15,
  COLOR_BLUE500_OPACITY_20,
  COLOR_BLUE500_OPACITY_25,
  COLOR_BLUE500_OPACITY_30,
  COLOR_BLUE500_OPACITY_35,
  COLOR_BLUE500_OPACITY_40,
  COLOR_BLUE500_OPACITY_45,
  COLOR_BLUE500_OPACITY_50,
  COLOR_BLUE500_OPACITY_55,
  COLOR_BLUE500_OPACITY_60,
  COLOR_BLUE500_OPACITY_65,
  COLOR_BLUE500_OPACITY_70,
  COLOR_BLUE500_OPACITY_75,
  COLOR_BLUE500_OPACITY_80,
  COLOR_BLUE500_OPACITY_85,
  COLOR_BLUE500_OPACITY_90,
  COLOR_BLUE500_OPACITY_95,
  COLOR_BLUE700_SHADE_1,
  COLOR_BLUE700_SHADE_2,
  COLOR_BLUE700_TINT_1,
  COLOR_BLUE700_TINT_2,
  COLOR_BLUE700_5,
  COLOR_BLUE700_10,
  COLOR_BLUE700_15,
  COLOR_BLUE700_20,
  COLOR_BLUE700_25,
  COLOR_BLUE700_30,
  COLOR_BLUE700_35,
  COLOR_BLUE700_40,
  COLOR_BLUE700_45,
  COLOR_BLUE700_50,
  COLOR_BLUE700_55,
  COLOR_BLUE700_60,
  COLOR_BLUE700_65,
  COLOR_BLUE700_70,
  COLOR_BLUE700_75,
  COLOR_BLUE700_80,
  COLOR_BLUE700_85,
  COLOR_BLUE700_90,
  COLOR_BLUE700_95,
  COLOR_BLUE700_OPACITY_5,
  COLOR_BLUE700_OPACITY_10,
  COLOR_BLUE700_OPACITY_15,
  COLOR_BLUE700_OPACITY_20,
  COLOR_BLUE700_OPACITY_25,
  COLOR_BLUE700_OPACITY_30,
  COLOR_BLUE700_OPACITY_35,
  COLOR_BLUE700_OPACITY_40,
  COLOR_BLUE700_OPACITY_45,
  COLOR_BLUE700_OPACITY_50,
  COLOR_BLUE700_OPACITY_55,
  COLOR_BLUE700_OPACITY_60,
  COLOR_BLUE700_OPACITY_65,
  COLOR_BLUE700_OPACITY_70,
  COLOR_BLUE700_OPACITY_75,
  COLOR_BLUE700_OPACITY_80,
  COLOR_BLUE700_OPACITY_85,
  COLOR_BLUE700_OPACITY_90,
  COLOR_BLUE700_OPACITY_95,
  COLOR_BLUE900_SHADE_1,
  COLOR_BLUE900_SHADE_2,
  COLOR_BLUE900_TINT_1,
  COLOR_BLUE900_TINT_2,
  COLOR_BLUE900_5,
  COLOR_BLUE900_10,
  COLOR_BLUE900_15,
  COLOR_BLUE900_20,
  COLOR_BLUE900_25,
  COLOR_BLUE900_30,
  COLOR_BLUE900_35,
  COLOR_BLUE900_40,
  COLOR_BLUE900_45,
  COLOR_BLUE900_50,
  COLOR_BLUE900_55,
  COLOR_BLUE900_60,
  COLOR_BLUE900_65,
  COLOR_BLUE900_70,
  COLOR_BLUE900_75,
  COLOR_BLUE900_80,
  COLOR_BLUE900_85,
  COLOR_BLUE900_90,
  COLOR_BLUE900_95,
  COLOR_BLUE900_OPACITY_5,
  COLOR_BLUE900_OPACITY_10,
  COLOR_BLUE900_OPACITY_15,
  COLOR_BLUE900_OPACITY_20,
  COLOR_BLUE900_OPACITY_25,
  COLOR_BLUE900_OPACITY_30,
  COLOR_BLUE900_OPACITY_35,
  COLOR_BLUE900_OPACITY_40,
  COLOR_BLUE900_OPACITY_45,
  COLOR_BLUE900_OPACITY_50,
  COLOR_BLUE900_OPACITY_55,
  COLOR_BLUE900_OPACITY_60,
  COLOR_BLUE900_OPACITY_65,
  COLOR_BLUE900_OPACITY_70,
  COLOR_BLUE900_OPACITY_75,
  COLOR_BLUE900_OPACITY_80,
  COLOR_BLUE900_OPACITY_85,
  COLOR_BLUE900_OPACITY_90,
  COLOR_BLUE900_OPACITY_95,
  COLOR_BRIGHTBLUE500_SHADE_1,
  COLOR_BRIGHTBLUE500_SHADE_2,
  COLOR_BRIGHTBLUE500_TINT_1,
  COLOR_BRIGHTBLUE500_TINT_2,
  COLOR_BRIGHTBLUE500_5,
  COLOR_BRIGHTBLUE500_10,
  COLOR_BRIGHTBLUE500_15,
  COLOR_BRIGHTBLUE500_20,
  COLOR_BRIGHTBLUE500_25,
  COLOR_BRIGHTBLUE500_30,
  COLOR_BRIGHTBLUE500_35,
  COLOR_BRIGHTBLUE500_40,
  COLOR_BRIGHTBLUE500_45,
  COLOR_BRIGHTBLUE500_50,
  COLOR_BRIGHTBLUE500_55,
  COLOR_BRIGHTBLUE500_60,
  COLOR_BRIGHTBLUE500_65,
  COLOR_BRIGHTBLUE500_70,
  COLOR_BRIGHTBLUE500_75,
  COLOR_BRIGHTBLUE500_80,
  COLOR_BRIGHTBLUE500_85,
  COLOR_BRIGHTBLUE500_90,
  COLOR_BRIGHTBLUE500_95,
  COLOR_BRIGHTBLUE500_OPACITY_5,
  COLOR_BRIGHTBLUE500_OPACITY_10,
  COLOR_BRIGHTBLUE500_OPACITY_15,
  COLOR_BRIGHTBLUE500_OPACITY_20,
  COLOR_BRIGHTBLUE500_OPACITY_25,
  COLOR_BRIGHTBLUE500_OPACITY_30,
  COLOR_BRIGHTBLUE500_OPACITY_35,
  COLOR_BRIGHTBLUE500_OPACITY_40,
  COLOR_BRIGHTBLUE500_OPACITY_45,
  COLOR_BRIGHTBLUE500_OPACITY_50,
  COLOR_BRIGHTBLUE500_OPACITY_55,
  COLOR_BRIGHTBLUE500_OPACITY_60,
  COLOR_BRIGHTBLUE500_OPACITY_65,
  COLOR_BRIGHTBLUE500_OPACITY_70,
  COLOR_BRIGHTBLUE500_OPACITY_75,
  COLOR_BRIGHTBLUE500_OPACITY_80,
  COLOR_BRIGHTBLUE500_OPACITY_85,
  COLOR_BRIGHTBLUE500_OPACITY_90,
  COLOR_BRIGHTBLUE500_OPACITY_95,
  COLOR_GREEN500_SHADE_1,
  COLOR_GREEN500_SHADE_2,
  COLOR_GREEN500_TINT_1,
  COLOR_GREEN500_TINT_2,
  COLOR_GREEN500_5,
  COLOR_GREEN500_10,
  COLOR_GREEN500_15,
  COLOR_GREEN500_20,
  COLOR_GREEN500_25,
  COLOR_GREEN500_30,
  COLOR_GREEN500_35,
  COLOR_GREEN500_40,
  COLOR_GREEN500_45,
  COLOR_GREEN500_50,
  COLOR_GREEN500_55,
  COLOR_GREEN500_60,
  COLOR_GREEN500_65,
  COLOR_GREEN500_70,
  COLOR_GREEN500_75,
  COLOR_GREEN500_80,
  COLOR_GREEN500_85,
  COLOR_GREEN500_90,
  COLOR_GREEN500_95,
  COLOR_GREEN500_OPACITY_5,
  COLOR_GREEN500_OPACITY_10,
  COLOR_GREEN500_OPACITY_15,
  COLOR_GREEN500_OPACITY_20,
  COLOR_GREEN500_OPACITY_25,
  COLOR_GREEN500_OPACITY_30,
  COLOR_GREEN500_OPACITY_35,
  COLOR_GREEN500_OPACITY_40,
  COLOR_GREEN500_OPACITY_45,
  COLOR_GREEN500_OPACITY_50,
  COLOR_GREEN500_OPACITY_55,
  COLOR_GREEN500_OPACITY_60,
  COLOR_GREEN500_OPACITY_65,
  COLOR_GREEN500_OPACITY_70,
  COLOR_GREEN500_OPACITY_75,
  COLOR_GREEN500_OPACITY_80,
  COLOR_GREEN500_OPACITY_85,
  COLOR_GREEN500_OPACITY_90,
  COLOR_GREEN500_OPACITY_95,
  COLOR_GREEN900_SHADE_1,
  COLOR_GREEN900_SHADE_2,
  COLOR_GREEN900_TINT_1,
  COLOR_GREEN900_TINT_2,
  COLOR_GREEN900_5,
  COLOR_GREEN900_10,
  COLOR_GREEN900_15,
  COLOR_GREEN900_20,
  COLOR_GREEN900_25,
  COLOR_GREEN900_30,
  COLOR_GREEN900_35,
  COLOR_GREEN900_40,
  COLOR_GREEN900_45,
  COLOR_GREEN900_50,
  COLOR_GREEN900_55,
  COLOR_GREEN900_60,
  COLOR_GREEN900_65,
  COLOR_GREEN900_70,
  COLOR_GREEN900_75,
  COLOR_GREEN900_80,
  COLOR_GREEN900_85,
  COLOR_GREEN900_90,
  COLOR_GREEN900_95,
  COLOR_GREEN900_OPACITY_5,
  COLOR_GREEN900_OPACITY_10,
  COLOR_GREEN900_OPACITY_15,
  COLOR_GREEN900_OPACITY_20,
  COLOR_GREEN900_OPACITY_25,
  COLOR_GREEN900_OPACITY_30,
  COLOR_GREEN900_OPACITY_35,
  COLOR_GREEN900_OPACITY_40,
  COLOR_GREEN900_OPACITY_45,
  COLOR_GREEN900_OPACITY_50,
  COLOR_GREEN900_OPACITY_55,
  COLOR_GREEN900_OPACITY_60,
  COLOR_GREEN900_OPACITY_65,
  COLOR_GREEN900_OPACITY_70,
  COLOR_GREEN900_OPACITY_75,
  COLOR_GREEN900_OPACITY_80,
  COLOR_GREEN900_OPACITY_85,
  COLOR_GREEN900_OPACITY_90,
  COLOR_GREEN900_OPACITY_95,
  COLOR_BRIGHTGREEN500_SHADE_1,
  COLOR_BRIGHTGREEN500_SHADE_2,
  COLOR_BRIGHTGREEN500_TINT_1,
  COLOR_BRIGHTGREEN500_TINT_2,
  COLOR_BRIGHTGREEN500_5,
  COLOR_BRIGHTGREEN500_10,
  COLOR_BRIGHTGREEN500_15,
  COLOR_BRIGHTGREEN500_20,
  COLOR_BRIGHTGREEN500_25,
  COLOR_BRIGHTGREEN500_30,
  COLOR_BRIGHTGREEN500_35,
  COLOR_BRIGHTGREEN500_40,
  COLOR_BRIGHTGREEN500_45,
  COLOR_BRIGHTGREEN500_50,
  COLOR_BRIGHTGREEN500_55,
  COLOR_BRIGHTGREEN500_60,
  COLOR_BRIGHTGREEN500_65,
  COLOR_BRIGHTGREEN500_70,
  COLOR_BRIGHTGREEN500_75,
  COLOR_BRIGHTGREEN500_80,
  COLOR_BRIGHTGREEN500_85,
  COLOR_BRIGHTGREEN500_90,
  COLOR_BRIGHTGREEN500_95,
  COLOR_BRIGHTGREEN500_OPACITY_5,
  COLOR_BRIGHTGREEN500_OPACITY_10,
  COLOR_BRIGHTGREEN500_OPACITY_15,
  COLOR_BRIGHTGREEN500_OPACITY_20,
  COLOR_BRIGHTGREEN500_OPACITY_25,
  COLOR_BRIGHTGREEN500_OPACITY_30,
  COLOR_BRIGHTGREEN500_OPACITY_35,
  COLOR_BRIGHTGREEN500_OPACITY_40,
  COLOR_BRIGHTGREEN500_OPACITY_45,
  COLOR_BRIGHTGREEN500_OPACITY_50,
  COLOR_BRIGHTGREEN500_OPACITY_55,
  COLOR_BRIGHTGREEN500_OPACITY_60,
  COLOR_BRIGHTGREEN500_OPACITY_65,
  COLOR_BRIGHTGREEN500_OPACITY_70,
  COLOR_BRIGHTGREEN500_OPACITY_75,
  COLOR_BRIGHTGREEN500_OPACITY_80,
  COLOR_BRIGHTGREEN500_OPACITY_85,
  COLOR_BRIGHTGREEN500_OPACITY_90,
  COLOR_BRIGHTGREEN500_OPACITY_95,
  COLOR_PINK_SHADE_1,
  COLOR_PINK_SHADE_2,
  COLOR_PINK_TINT_1,
  COLOR_PINK_TINT_2,
  COLOR_PINK_5,
  COLOR_PINK_10,
  COLOR_PINK_15,
  COLOR_PINK_20,
  COLOR_PINK_25,
  COLOR_PINK_30,
  COLOR_PINK_35,
  COLOR_PINK_40,
  COLOR_PINK_45,
  COLOR_PINK_50,
  COLOR_PINK_55,
  COLOR_PINK_60,
  COLOR_PINK_65,
  COLOR_PINK_70,
  COLOR_PINK_75,
  COLOR_PINK_80,
  COLOR_PINK_85,
  COLOR_PINK_90,
  COLOR_PINK_95,
  COLOR_PINK_OPACITY_5,
  COLOR_PINK_OPACITY_10,
  COLOR_PINK_OPACITY_15,
  COLOR_PINK_OPACITY_20,
  COLOR_PINK_OPACITY_25,
  COLOR_PINK_OPACITY_30,
  COLOR_PINK_OPACITY_35,
  COLOR_PINK_OPACITY_40,
  COLOR_PINK_OPACITY_45,
  COLOR_PINK_OPACITY_50,
  COLOR_PINK_OPACITY_55,
  COLOR_PINK_OPACITY_60,
  COLOR_PINK_OPACITY_65,
  COLOR_PINK_OPACITY_70,
  COLOR_PINK_OPACITY_75,
  COLOR_PINK_OPACITY_80,
  COLOR_PINK_OPACITY_85,
  COLOR_PINK_OPACITY_90,
  COLOR_PINK_OPACITY_95,
  COLOR_DARK_PINK_SHADE_1,
  COLOR_DARK_PINK_SHADE_2,
  COLOR_DARK_PINK_TINT_1,
  COLOR_DARK_PINK_TINT_2,
  COLOR_DARK_PINK_5,
  COLOR_DARK_PINK_10,
  COLOR_DARK_PINK_15,
  COLOR_DARK_PINK_20,
  COLOR_DARK_PINK_25,
  COLOR_DARK_PINK_30,
  COLOR_DARK_PINK_35,
  COLOR_DARK_PINK_40,
  COLOR_DARK_PINK_45,
  COLOR_DARK_PINK_50,
  COLOR_DARK_PINK_55,
  COLOR_DARK_PINK_60,
  COLOR_DARK_PINK_65,
  COLOR_DARK_PINK_70,
  COLOR_DARK_PINK_75,
  COLOR_DARK_PINK_80,
  COLOR_DARK_PINK_85,
  COLOR_DARK_PINK_90,
  COLOR_DARK_PINK_95,
  COLOR_DARK_PINK_OPACITY_5,
  COLOR_DARK_PINK_OPACITY_10,
  COLOR_DARK_PINK_OPACITY_15,
  COLOR_DARK_PINK_OPACITY_20,
  COLOR_DARK_PINK_OPACITY_25,
  COLOR_DARK_PINK_OPACITY_30,
  COLOR_DARK_PINK_OPACITY_35,
  COLOR_DARK_PINK_OPACITY_40,
  COLOR_DARK_PINK_OPACITY_45,
  COLOR_DARK_PINK_OPACITY_50,
  COLOR_DARK_PINK_OPACITY_55,
  COLOR_DARK_PINK_OPACITY_60,
  COLOR_DARK_PINK_OPACITY_65,
  COLOR_DARK_PINK_OPACITY_70,
  COLOR_DARK_PINK_OPACITY_75,
  COLOR_DARK_PINK_OPACITY_80,
  COLOR_DARK_PINK_OPACITY_85,
  COLOR_DARK_PINK_OPACITY_90,
  COLOR_DARK_PINK_OPACITY_95,
  COLOR_BRIGHT_BLUE_SHADE_1,
  COLOR_BRIGHT_BLUE_SHADE_2,
  COLOR_BRIGHT_BLUE_TINT_1,
  COLOR_BRIGHT_BLUE_TINT_2,
  COLOR_BRIGHT_BLUE_5,
  COLOR_BRIGHT_BLUE_10,
  COLOR_BRIGHT_BLUE_15,
  COLOR_BRIGHT_BLUE_20,
  COLOR_BRIGHT_BLUE_25,
  COLOR_BRIGHT_BLUE_30,
  COLOR_BRIGHT_BLUE_35,
  COLOR_BRIGHT_BLUE_40,
  COLOR_BRIGHT_BLUE_45,
  COLOR_BRIGHT_BLUE_50,
  COLOR_BRIGHT_BLUE_55,
  COLOR_BRIGHT_BLUE_60,
  COLOR_BRIGHT_BLUE_65,
  COLOR_BRIGHT_BLUE_70,
  COLOR_BRIGHT_BLUE_75,
  COLOR_BRIGHT_BLUE_80,
  COLOR_BRIGHT_BLUE_85,
  COLOR_BRIGHT_BLUE_90,
  COLOR_BRIGHT_BLUE_95,
  COLOR_BRIGHT_BLUE_OPACITY_5,
  COLOR_BRIGHT_BLUE_OPACITY_10,
  COLOR_BRIGHT_BLUE_OPACITY_15,
  COLOR_BRIGHT_BLUE_OPACITY_20,
  COLOR_BRIGHT_BLUE_OPACITY_25,
  COLOR_BRIGHT_BLUE_OPACITY_30,
  COLOR_BRIGHT_BLUE_OPACITY_35,
  COLOR_BRIGHT_BLUE_OPACITY_40,
  COLOR_BRIGHT_BLUE_OPACITY_45,
  COLOR_BRIGHT_BLUE_OPACITY_50,
  COLOR_BRIGHT_BLUE_OPACITY_55,
  COLOR_BRIGHT_BLUE_OPACITY_60,
  COLOR_BRIGHT_BLUE_OPACITY_65,
  COLOR_BRIGHT_BLUE_OPACITY_70,
  COLOR_BRIGHT_BLUE_OPACITY_75,
  COLOR_BRIGHT_BLUE_OPACITY_80,
  COLOR_BRIGHT_BLUE_OPACITY_85,
  COLOR_BRIGHT_BLUE_OPACITY_90,
  COLOR_BRIGHT_BLUE_OPACITY_95,
  COLOR_CYAN_SHADE_1,
  COLOR_CYAN_SHADE_2,
  COLOR_CYAN_TINT_1,
  COLOR_CYAN_TINT_2,
  COLOR_CYAN_5,
  COLOR_CYAN_10,
  COLOR_CYAN_15,
  COLOR_CYAN_20,
  COLOR_CYAN_25,
  COLOR_CYAN_30,
  COLOR_CYAN_35,
  COLOR_CYAN_40,
  COLOR_CYAN_45,
  COLOR_CYAN_50,
  COLOR_CYAN_55,
  COLOR_CYAN_60,
  COLOR_CYAN_65,
  COLOR_CYAN_70,
  COLOR_CYAN_75,
  COLOR_CYAN_80,
  COLOR_CYAN_85,
  COLOR_CYAN_90,
  COLOR_CYAN_95,
  COLOR_CYAN_OPACITY_5,
  COLOR_CYAN_OPACITY_10,
  COLOR_CYAN_OPACITY_15,
  COLOR_CYAN_OPACITY_20,
  COLOR_CYAN_OPACITY_25,
  COLOR_CYAN_OPACITY_30,
  COLOR_CYAN_OPACITY_35,
  COLOR_CYAN_OPACITY_40,
  COLOR_CYAN_OPACITY_45,
  COLOR_CYAN_OPACITY_50,
  COLOR_CYAN_OPACITY_55,
  COLOR_CYAN_OPACITY_60,
  COLOR_CYAN_OPACITY_65,
  COLOR_CYAN_OPACITY_70,
  COLOR_CYAN_OPACITY_75,
  COLOR_CYAN_OPACITY_80,
  COLOR_CYAN_OPACITY_85,
  COLOR_CYAN_OPACITY_90,
  COLOR_CYAN_OPACITY_95,
  COLOR_DARKBLUE_SHADE_1,
  COLOR_DARKBLUE_SHADE_2,
  COLOR_DARKBLUE_TINT_1,
  COLOR_DARKBLUE_TINT_2,
  COLOR_DARKBLUE_5,
  COLOR_DARKBLUE_10,
  COLOR_DARKBLUE_15,
  COLOR_DARKBLUE_20,
  COLOR_DARKBLUE_25,
  COLOR_DARKBLUE_30,
  COLOR_DARKBLUE_35,
  COLOR_DARKBLUE_40,
  COLOR_DARKBLUE_45,
  COLOR_DARKBLUE_50,
  COLOR_DARKBLUE_55,
  COLOR_DARKBLUE_60,
  COLOR_DARKBLUE_65,
  COLOR_DARKBLUE_70,
  COLOR_DARKBLUE_75,
  COLOR_DARKBLUE_80,
  COLOR_DARKBLUE_85,
  COLOR_DARKBLUE_90,
  COLOR_DARKBLUE_95,
  COLOR_DARKBLUE_OPACITY_5,
  COLOR_DARKBLUE_OPACITY_10,
  COLOR_DARKBLUE_OPACITY_15,
  COLOR_DARKBLUE_OPACITY_20,
  COLOR_DARKBLUE_OPACITY_25,
  COLOR_DARKBLUE_OPACITY_30,
  COLOR_DARKBLUE_OPACITY_35,
  COLOR_DARKBLUE_OPACITY_40,
  COLOR_DARKBLUE_OPACITY_45,
  COLOR_DARKBLUE_OPACITY_50,
  COLOR_DARKBLUE_OPACITY_55,
  COLOR_DARKBLUE_OPACITY_60,
  COLOR_DARKBLUE_OPACITY_65,
  COLOR_DARKBLUE_OPACITY_70,
  COLOR_DARKBLUE_OPACITY_75,
  COLOR_DARKBLUE_OPACITY_80,
  COLOR_DARKBLUE_OPACITY_85,
  COLOR_DARKBLUE_OPACITY_90,
  COLOR_DARKBLUE_OPACITY_95,
  COLOR_RED_SHADE_1,
  COLOR_RED_SHADE_2,
  COLOR_RED_TINT_1,
  COLOR_RED_TINT_2,
  COLOR_RED_5,
  COLOR_RED_10,
  COLOR_RED_15,
  COLOR_RED_20,
  COLOR_RED_25,
  COLOR_RED_30,
  COLOR_RED_35,
  COLOR_RED_40,
  COLOR_RED_45,
  COLOR_RED_50,
  COLOR_RED_55,
  COLOR_RED_60,
  COLOR_RED_65,
  COLOR_RED_70,
  COLOR_RED_75,
  COLOR_RED_80,
  COLOR_RED_85,
  COLOR_RED_90,
  COLOR_RED_95,
  COLOR_RED_OPACITY_5,
  COLOR_RED_OPACITY_10,
  COLOR_RED_OPACITY_15,
  COLOR_RED_OPACITY_20,
  COLOR_RED_OPACITY_25,
  COLOR_RED_OPACITY_30,
  COLOR_RED_OPACITY_35,
  COLOR_RED_OPACITY_40,
  COLOR_RED_OPACITY_45,
  COLOR_RED_OPACITY_50,
  COLOR_RED_OPACITY_55,
  COLOR_RED_OPACITY_60,
  COLOR_RED_OPACITY_65,
  COLOR_RED_OPACITY_70,
  COLOR_RED_OPACITY_75,
  COLOR_RED_OPACITY_80,
  COLOR_RED_OPACITY_85,
  COLOR_RED_OPACITY_90,
  COLOR_RED_OPACITY_95,
  COLOR_YELLOW_SHADE_1,
  COLOR_YELLOW_SHADE_2,
  COLOR_YELLOW_TINT_1,
  COLOR_YELLOW_TINT_2,
  COLOR_YELLOW_5,
  COLOR_YELLOW_10,
  COLOR_YELLOW_15,
  COLOR_YELLOW_20,
  COLOR_YELLOW_25,
  COLOR_YELLOW_30,
  COLOR_YELLOW_35,
  COLOR_YELLOW_40,
  COLOR_YELLOW_45,
  COLOR_YELLOW_50,
  COLOR_YELLOW_55,
  COLOR_YELLOW_60,
  COLOR_YELLOW_65,
  COLOR_YELLOW_70,
  COLOR_YELLOW_75,
  COLOR_YELLOW_80,
  COLOR_YELLOW_85,
  COLOR_YELLOW_90,
  COLOR_YELLOW_95,
  COLOR_YELLOW_OPACITY_5,
  COLOR_YELLOW_OPACITY_10,
  COLOR_YELLOW_OPACITY_15,
  COLOR_YELLOW_OPACITY_20,
  COLOR_YELLOW_OPACITY_25,
  COLOR_YELLOW_OPACITY_30,
  COLOR_YELLOW_OPACITY_35,
  COLOR_YELLOW_OPACITY_40,
  COLOR_YELLOW_OPACITY_45,
  COLOR_YELLOW_OPACITY_50,
  COLOR_YELLOW_OPACITY_55,
  COLOR_YELLOW_OPACITY_60,
  COLOR_YELLOW_OPACITY_65,
  COLOR_YELLOW_OPACITY_70,
  COLOR_YELLOW_OPACITY_75,
  COLOR_YELLOW_OPACITY_80,
  COLOR_YELLOW_OPACITY_85,
  COLOR_YELLOW_OPACITY_90,
  COLOR_YELLOW_OPACITY_95,
  COLOR_GREEN_SHADE_1,
  COLOR_GREEN_SHADE_2,
  COLOR_GREEN_TINT_1,
  COLOR_GREEN_TINT_2,
  COLOR_GREEN_5,
  COLOR_GREEN_10,
  COLOR_GREEN_15,
  COLOR_GREEN_20,
  COLOR_GREEN_25,
  COLOR_GREEN_30,
  COLOR_GREEN_35,
  COLOR_GREEN_40,
  COLOR_GREEN_45,
  COLOR_GREEN_50,
  COLOR_GREEN_55,
  COLOR_GREEN_60,
  COLOR_GREEN_65,
  COLOR_GREEN_70,
  COLOR_GREEN_75,
  COLOR_GREEN_80,
  COLOR_GREEN_85,
  COLOR_GREEN_90,
  COLOR_GREEN_95,
  COLOR_GREEN_OPACITY_5,
  COLOR_GREEN_OPACITY_10,
  COLOR_GREEN_OPACITY_15,
  COLOR_GREEN_OPACITY_20,
  COLOR_GREEN_OPACITY_25,
  COLOR_GREEN_OPACITY_30,
  COLOR_GREEN_OPACITY_35,
  COLOR_GREEN_OPACITY_40,
  COLOR_GREEN_OPACITY_45,
  COLOR_GREEN_OPACITY_50,
  COLOR_GREEN_OPACITY_55,
  COLOR_GREEN_OPACITY_60,
  COLOR_GREEN_OPACITY_65,
  COLOR_GREEN_OPACITY_70,
  COLOR_GREEN_OPACITY_75,
  COLOR_GREEN_OPACITY_80,
  COLOR_GREEN_OPACITY_85,
  COLOR_GREEN_OPACITY_90,
  COLOR_GREEN_OPACITY_95,
  COLOR_WHITE_SHADE_1,
  COLOR_WHITE_SHADE_2,
  COLOR_WHITE_TINT_1,
  COLOR_WHITE_TINT_2,
  COLOR_WHITE_5,
  COLOR_WHITE_10,
  COLOR_WHITE_15,
  COLOR_WHITE_20,
  COLOR_WHITE_25,
  COLOR_WHITE_30,
  COLOR_WHITE_35,
  COLOR_WHITE_40,
  COLOR_WHITE_45,
  COLOR_WHITE_50,
  COLOR_WHITE_55,
  COLOR_WHITE_60,
  COLOR_WHITE_65,
  COLOR_WHITE_70,
  COLOR_WHITE_75,
  COLOR_WHITE_80,
  COLOR_WHITE_85,
  COLOR_WHITE_90,
  COLOR_WHITE_95,
  COLOR_WHITE_OPACITY_5,
  COLOR_WHITE_OPACITY_10,
  COLOR_WHITE_OPACITY_15,
  COLOR_WHITE_OPACITY_20,
  COLOR_WHITE_OPACITY_25,
  COLOR_WHITE_OPACITY_30,
  COLOR_WHITE_OPACITY_35,
  COLOR_WHITE_OPACITY_40,
  COLOR_WHITE_OPACITY_45,
  COLOR_WHITE_OPACITY_50,
  COLOR_WHITE_OPACITY_55,
  COLOR_WHITE_OPACITY_60,
  COLOR_WHITE_OPACITY_65,
  COLOR_WHITE_OPACITY_70,
  COLOR_WHITE_OPACITY_75,
  COLOR_WHITE_OPACITY_80,
  COLOR_WHITE_OPACITY_85,
  COLOR_WHITE_OPACITY_90,
  COLOR_WHITE_OPACITY_95,
  COLOR_BRIGHT_SHADE_1,
  COLOR_BRIGHT_SHADE_2,
  COLOR_BRIGHT_TINT_1,
  COLOR_BRIGHT_TINT_2,
  COLOR_BRIGHT_5,
  COLOR_BRIGHT_10,
  COLOR_BRIGHT_15,
  COLOR_BRIGHT_20,
  COLOR_BRIGHT_25,
  COLOR_BRIGHT_30,
  COLOR_BRIGHT_35,
  COLOR_BRIGHT_40,
  COLOR_BRIGHT_45,
  COLOR_BRIGHT_50,
  COLOR_BRIGHT_55,
  COLOR_BRIGHT_60,
  COLOR_BRIGHT_65,
  COLOR_BRIGHT_70,
  COLOR_BRIGHT_75,
  COLOR_BRIGHT_80,
  COLOR_BRIGHT_85,
  COLOR_BRIGHT_90,
  COLOR_BRIGHT_95,
  COLOR_BRIGHT_OPACITY_5,
  COLOR_BRIGHT_OPACITY_10,
  COLOR_BRIGHT_OPACITY_15,
  COLOR_BRIGHT_OPACITY_20,
  COLOR_BRIGHT_OPACITY_25,
  COLOR_BRIGHT_OPACITY_30,
  COLOR_BRIGHT_OPACITY_35,
  COLOR_BRIGHT_OPACITY_40,
  COLOR_BRIGHT_OPACITY_45,
  COLOR_BRIGHT_OPACITY_50,
  COLOR_BRIGHT_OPACITY_55,
  COLOR_BRIGHT_OPACITY_60,
  COLOR_BRIGHT_OPACITY_65,
  COLOR_BRIGHT_OPACITY_70,
  COLOR_BRIGHT_OPACITY_75,
  COLOR_BRIGHT_OPACITY_80,
  COLOR_BRIGHT_OPACITY_85,
  COLOR_BRIGHT_OPACITY_90,
  COLOR_BRIGHT_OPACITY_95,
  COLOR_DARK_SHADE_1,
  COLOR_DARK_SHADE_2,
  COLOR_DARK_TINT_1,
  COLOR_DARK_TINT_2,
  COLOR_DARK_5,
  COLOR_DARK_10,
  COLOR_DARK_15,
  COLOR_DARK_20,
  COLOR_DARK_25,
  COLOR_DARK_30,
  COLOR_DARK_35,
  COLOR_DARK_40,
  COLOR_DARK_45,
  COLOR_DARK_50,
  COLOR_DARK_55,
  COLOR_DARK_60,
  COLOR_DARK_65,
  COLOR_DARK_70,
  COLOR_DARK_75,
  COLOR_DARK_80,
  COLOR_DARK_85,
  COLOR_DARK_90,
  COLOR_DARK_95,
  COLOR_DARK_OPACITY_5,
  COLOR_DARK_OPACITY_10,
  COLOR_DARK_OPACITY_15,
  COLOR_DARK_OPACITY_20,
  COLOR_DARK_OPACITY_25,
  COLOR_DARK_OPACITY_30,
  COLOR_DARK_OPACITY_35,
  COLOR_DARK_OPACITY_40,
  COLOR_DARK_OPACITY_45,
  COLOR_DARK_OPACITY_50,
  COLOR_DARK_OPACITY_55,
  COLOR_DARK_OPACITY_60,
  COLOR_DARK_OPACITY_65,
  COLOR_DARK_OPACITY_70,
  COLOR_DARK_OPACITY_75,
  COLOR_DARK_OPACITY_80,
  COLOR_DARK_OPACITY_85,
  COLOR_DARK_OPACITY_90,
  COLOR_DARK_OPACITY_95,
  COLOR_DARK900_SHADE_1,
  COLOR_DARK900_SHADE_2,
  COLOR_DARK900_TINT_1,
  COLOR_DARK900_TINT_2,
  COLOR_DARK900_5,
  COLOR_DARK900_10,
  COLOR_DARK900_15,
  COLOR_DARK900_20,
  COLOR_DARK900_25,
  COLOR_DARK900_30,
  COLOR_DARK900_35,
  COLOR_DARK900_40,
  COLOR_DARK900_45,
  COLOR_DARK900_50,
  COLOR_DARK900_55,
  COLOR_DARK900_60,
  COLOR_DARK900_65,
  COLOR_DARK900_70,
  COLOR_DARK900_75,
  COLOR_DARK900_80,
  COLOR_DARK900_85,
  COLOR_DARK900_90,
  COLOR_DARK900_95,
  COLOR_DARK900_OPACITY_5,
  COLOR_DARK900_OPACITY_10,
  COLOR_DARK900_OPACITY_15,
  COLOR_DARK900_OPACITY_20,
  COLOR_DARK900_OPACITY_25,
  COLOR_DARK900_OPACITY_30,
  COLOR_DARK900_OPACITY_35,
  COLOR_DARK900_OPACITY_40,
  COLOR_DARK900_OPACITY_45,
  COLOR_DARK900_OPACITY_50,
  COLOR_DARK900_OPACITY_55,
  COLOR_DARK900_OPACITY_60,
  COLOR_DARK900_OPACITY_65,
  COLOR_DARK900_OPACITY_70,
  COLOR_DARK900_OPACITY_75,
  COLOR_DARK900_OPACITY_80,
  COLOR_DARK900_OPACITY_85,
  COLOR_DARK900_OPACITY_90,
  COLOR_DARK900_OPACITY_95,
  COLOR_DARK700_SHADE_1,
  COLOR_DARK700_SHADE_2,
  COLOR_DARK700_TINT_1,
  COLOR_DARK700_TINT_2,
  COLOR_DARK700_5,
  COLOR_DARK700_10,
  COLOR_DARK700_15,
  COLOR_DARK700_20,
  COLOR_DARK700_25,
  COLOR_DARK700_30,
  COLOR_DARK700_35,
  COLOR_DARK700_40,
  COLOR_DARK700_45,
  COLOR_DARK700_50,
  COLOR_DARK700_55,
  COLOR_DARK700_60,
  COLOR_DARK700_65,
  COLOR_DARK700_70,
  COLOR_DARK700_75,
  COLOR_DARK700_80,
  COLOR_DARK700_85,
  COLOR_DARK700_90,
  COLOR_DARK700_95,
  COLOR_DARK700_OPACITY_5,
  COLOR_DARK700_OPACITY_10,
  COLOR_DARK700_OPACITY_15,
  COLOR_DARK700_OPACITY_20,
  COLOR_DARK700_OPACITY_25,
  COLOR_DARK700_OPACITY_30,
  COLOR_DARK700_OPACITY_35,
  COLOR_DARK700_OPACITY_40,
  COLOR_DARK700_OPACITY_45,
  COLOR_DARK700_OPACITY_50,
  COLOR_DARK700_OPACITY_55,
  COLOR_DARK700_OPACITY_60,
  COLOR_DARK700_OPACITY_65,
  COLOR_DARK700_OPACITY_70,
  COLOR_DARK700_OPACITY_75,
  COLOR_DARK700_OPACITY_80,
  COLOR_DARK700_OPACITY_85,
  COLOR_DARK700_OPACITY_90,
  COLOR_DARK700_OPACITY_95,
  COLOR_DARK600_SHADE_1,
  COLOR_DARK600_SHADE_2,
  COLOR_DARK600_TINT_1,
  COLOR_DARK600_TINT_2,
  COLOR_DARK600_5,
  COLOR_DARK600_10,
  COLOR_DARK600_15,
  COLOR_DARK600_20,
  COLOR_DARK600_25,
  COLOR_DARK600_30,
  COLOR_DARK600_35,
  COLOR_DARK600_40,
  COLOR_DARK600_45,
  COLOR_DARK600_50,
  COLOR_DARK600_55,
  COLOR_DARK600_60,
  COLOR_DARK600_65,
  COLOR_DARK600_70,
  COLOR_DARK600_75,
  COLOR_DARK600_80,
  COLOR_DARK600_85,
  COLOR_DARK600_90,
  COLOR_DARK600_95,
  COLOR_DARK600_OPACITY_5,
  COLOR_DARK600_OPACITY_10,
  COLOR_DARK600_OPACITY_15,
  COLOR_DARK600_OPACITY_20,
  COLOR_DARK600_OPACITY_25,
  COLOR_DARK600_OPACITY_30,
  COLOR_DARK600_OPACITY_35,
  COLOR_DARK600_OPACITY_40,
  COLOR_DARK600_OPACITY_45,
  COLOR_DARK600_OPACITY_50,
  COLOR_DARK600_OPACITY_55,
  COLOR_DARK600_OPACITY_60,
  COLOR_DARK600_OPACITY_65,
  COLOR_DARK600_OPACITY_70,
  COLOR_DARK600_OPACITY_75,
  COLOR_DARK600_OPACITY_80,
  COLOR_DARK600_OPACITY_85,
  COLOR_DARK600_OPACITY_90,
  COLOR_DARK600_OPACITY_95,
  COLOR_DARK400_SHADE_1,
  COLOR_DARK400_SHADE_2,
  COLOR_DARK400_TINT_1,
  COLOR_DARK400_TINT_2,
  COLOR_DARK400_5,
  COLOR_DARK400_10,
  COLOR_DARK400_15,
  COLOR_DARK400_20,
  COLOR_DARK400_25,
  COLOR_DARK400_30,
  COLOR_DARK400_35,
  COLOR_DARK400_40,
  COLOR_DARK400_45,
  COLOR_DARK400_50,
  COLOR_DARK400_55,
  COLOR_DARK400_60,
  COLOR_DARK400_65,
  COLOR_DARK400_70,
  COLOR_DARK400_75,
  COLOR_DARK400_80,
  COLOR_DARK400_85,
  COLOR_DARK400_90,
  COLOR_DARK400_95,
  COLOR_DARK400_OPACITY_5,
  COLOR_DARK400_OPACITY_10,
  COLOR_DARK400_OPACITY_15,
  COLOR_DARK400_OPACITY_20,
  COLOR_DARK400_OPACITY_25,
  COLOR_DARK400_OPACITY_30,
  COLOR_DARK400_OPACITY_35,
  COLOR_DARK400_OPACITY_40,
  COLOR_DARK400_OPACITY_45,
  COLOR_DARK400_OPACITY_50,
  COLOR_DARK400_OPACITY_55,
  COLOR_DARK400_OPACITY_60,
  COLOR_DARK400_OPACITY_65,
  COLOR_DARK400_OPACITY_70,
  COLOR_DARK400_OPACITY_75,
  COLOR_DARK400_OPACITY_80,
  COLOR_DARK400_OPACITY_85,
  COLOR_DARK400_OPACITY_90,
  COLOR_DARK400_OPACITY_95,
  COLOR_DARK300_SHADE_1,
  COLOR_DARK300_SHADE_2,
  COLOR_DARK300_TINT_1,
  COLOR_DARK300_TINT_2,
  COLOR_DARK300_5,
  COLOR_DARK300_10,
  COLOR_DARK300_15,
  COLOR_DARK300_20,
  COLOR_DARK300_25,
  COLOR_DARK300_30,
  COLOR_DARK300_35,
  COLOR_DARK300_40,
  COLOR_DARK300_45,
  COLOR_DARK300_50,
  COLOR_DARK300_55,
  COLOR_DARK300_60,
  COLOR_DARK300_65,
  COLOR_DARK300_70,
  COLOR_DARK300_75,
  COLOR_DARK300_80,
  COLOR_DARK300_85,
  COLOR_DARK300_90,
  COLOR_DARK300_95,
  COLOR_DARK300_OPACITY_5,
  COLOR_DARK300_OPACITY_10,
  COLOR_DARK300_OPACITY_15,
  COLOR_DARK300_OPACITY_20,
  COLOR_DARK300_OPACITY_25,
  COLOR_DARK300_OPACITY_30,
  COLOR_DARK300_OPACITY_35,
  COLOR_DARK300_OPACITY_40,
  COLOR_DARK300_OPACITY_45,
  COLOR_DARK300_OPACITY_50,
  COLOR_DARK300_OPACITY_55,
  COLOR_DARK300_OPACITY_60,
  COLOR_DARK300_OPACITY_65,
  COLOR_DARK300_OPACITY_70,
  COLOR_DARK300_OPACITY_75,
  COLOR_DARK300_OPACITY_80,
  COLOR_DARK300_OPACITY_85,
  COLOR_DARK300_OPACITY_90,
  COLOR_DARK300_OPACITY_95,
  COLOR_DARK100_SHADE_1,
  COLOR_DARK100_SHADE_2,
  COLOR_DARK100_TINT_1,
  COLOR_DARK100_TINT_2,
  COLOR_DARK100_5,
  COLOR_DARK100_10,
  COLOR_DARK100_15,
  COLOR_DARK100_20,
  COLOR_DARK100_25,
  COLOR_DARK100_30,
  COLOR_DARK100_35,
  COLOR_DARK100_40,
  COLOR_DARK100_45,
  COLOR_DARK100_50,
  COLOR_DARK100_55,
  COLOR_DARK100_60,
  COLOR_DARK100_65,
  COLOR_DARK100_70,
  COLOR_DARK100_75,
  COLOR_DARK100_80,
  COLOR_DARK100_85,
  COLOR_DARK100_90,
  COLOR_DARK100_95,
  COLOR_DARK100_OPACITY_5,
  COLOR_DARK100_OPACITY_10,
  COLOR_DARK100_OPACITY_15,
  COLOR_DARK100_OPACITY_20,
  COLOR_DARK100_OPACITY_25,
  COLOR_DARK100_OPACITY_30,
  COLOR_DARK100_OPACITY_35,
  COLOR_DARK100_OPACITY_40,
  COLOR_DARK100_OPACITY_45,
  COLOR_DARK100_OPACITY_50,
  COLOR_DARK100_OPACITY_55,
  COLOR_DARK100_OPACITY_60,
  COLOR_DARK100_OPACITY_65,
  COLOR_DARK100_OPACITY_70,
  COLOR_DARK100_OPACITY_75,
  COLOR_DARK100_OPACITY_80,
  COLOR_DARK100_OPACITY_85,
  COLOR_DARK100_OPACITY_90,
  COLOR_DARK100_OPACITY_95,
  COLOR_BLUE_SHADE_1,
  COLOR_BLUE_SHADE_2,
  COLOR_BLUE_TINT_1,
  COLOR_BLUE_TINT_2,
  COLOR_BLUE_5,
  COLOR_BLUE_10,
  COLOR_BLUE_15,
  COLOR_BLUE_20,
  COLOR_BLUE_25,
  COLOR_BLUE_30,
  COLOR_BLUE_35,
  COLOR_BLUE_40,
  COLOR_BLUE_45,
  COLOR_BLUE_50,
  COLOR_BLUE_55,
  COLOR_BLUE_60,
  COLOR_BLUE_65,
  COLOR_BLUE_70,
  COLOR_BLUE_75,
  COLOR_BLUE_80,
  COLOR_BLUE_85,
  COLOR_BLUE_90,
  COLOR_BLUE_95,
  COLOR_BLUE_OPACITY_5,
  COLOR_BLUE_OPACITY_10,
  COLOR_BLUE_OPACITY_15,
  COLOR_BLUE_OPACITY_20,
  COLOR_BLUE_OPACITY_25,
  COLOR_BLUE_OPACITY_30,
  COLOR_BLUE_OPACITY_35,
  COLOR_BLUE_OPACITY_40,
  COLOR_BLUE_OPACITY_45,
  COLOR_BLUE_OPACITY_50,
  COLOR_BLUE_OPACITY_55,
  COLOR_BLUE_OPACITY_60,
  COLOR_BLUE_OPACITY_65,
  COLOR_BLUE_OPACITY_70,
  COLOR_BLUE_OPACITY_75,
  COLOR_BLUE_OPACITY_80,
  COLOR_BLUE_OPACITY_85,
  COLOR_BLUE_OPACITY_90,
  COLOR_BLUE_OPACITY_95,
  COLOR_ULTRALIGHTGREY_SHADE_1,
  COLOR_ULTRALIGHTGREY_SHADE_2,
  COLOR_ULTRALIGHTGREY_TINT_1,
  COLOR_ULTRALIGHTGREY_TINT_2,
  COLOR_ULTRALIGHTGREY_5,
  COLOR_ULTRALIGHTGREY_10,
  COLOR_ULTRALIGHTGREY_15,
  COLOR_ULTRALIGHTGREY_20,
  COLOR_ULTRALIGHTGREY_25,
  COLOR_ULTRALIGHTGREY_30,
  COLOR_ULTRALIGHTGREY_35,
  COLOR_ULTRALIGHTGREY_40,
  COLOR_ULTRALIGHTGREY_45,
  COLOR_ULTRALIGHTGREY_50,
  COLOR_ULTRALIGHTGREY_55,
  COLOR_ULTRALIGHTGREY_60,
  COLOR_ULTRALIGHTGREY_65,
  COLOR_ULTRALIGHTGREY_70,
  COLOR_ULTRALIGHTGREY_75,
  COLOR_ULTRALIGHTGREY_80,
  COLOR_ULTRALIGHTGREY_85,
  COLOR_ULTRALIGHTGREY_90,
  COLOR_ULTRALIGHTGREY_95,
  COLOR_ULTRALIGHTGREY_OPACITY_5,
  COLOR_ULTRALIGHTGREY_OPACITY_10,
  COLOR_ULTRALIGHTGREY_OPACITY_15,
  COLOR_ULTRALIGHTGREY_OPACITY_20,
  COLOR_ULTRALIGHTGREY_OPACITY_25,
  COLOR_ULTRALIGHTGREY_OPACITY_30,
  COLOR_ULTRALIGHTGREY_OPACITY_35,
  COLOR_ULTRALIGHTGREY_OPACITY_40,
  COLOR_ULTRALIGHTGREY_OPACITY_45,
  COLOR_ULTRALIGHTGREY_OPACITY_50,
  COLOR_ULTRALIGHTGREY_OPACITY_55,
  COLOR_ULTRALIGHTGREY_OPACITY_60,
  COLOR_ULTRALIGHTGREY_OPACITY_65,
  COLOR_ULTRALIGHTGREY_OPACITY_70,
  COLOR_ULTRALIGHTGREY_OPACITY_75,
  COLOR_ULTRALIGHTGREY_OPACITY_80,
  COLOR_ULTRALIGHTGREY_OPACITY_85,
  COLOR_ULTRALIGHTGREY_OPACITY_90,
  COLOR_ULTRALIGHTGREY_OPACITY_95,
  COLOR_LIGHT_GREEN_SHADE_1,
  COLOR_LIGHT_GREEN_SHADE_2,
  COLOR_LIGHT_GREEN_TINT_1,
  COLOR_LIGHT_GREEN_TINT_2,
  COLOR_LIGHT_GREEN_5,
  COLOR_LIGHT_GREEN_10,
  COLOR_LIGHT_GREEN_15,
  COLOR_LIGHT_GREEN_20,
  COLOR_LIGHT_GREEN_25,
  COLOR_LIGHT_GREEN_30,
  COLOR_LIGHT_GREEN_35,
  COLOR_LIGHT_GREEN_40,
  COLOR_LIGHT_GREEN_45,
  COLOR_LIGHT_GREEN_50,
  COLOR_LIGHT_GREEN_55,
  COLOR_LIGHT_GREEN_60,
  COLOR_LIGHT_GREEN_65,
  COLOR_LIGHT_GREEN_70,
  COLOR_LIGHT_GREEN_75,
  COLOR_LIGHT_GREEN_80,
  COLOR_LIGHT_GREEN_85,
  COLOR_LIGHT_GREEN_90,
  COLOR_LIGHT_GREEN_95,
  COLOR_LIGHT_GREEN_OPACITY_5,
  COLOR_LIGHT_GREEN_OPACITY_10,
  COLOR_LIGHT_GREEN_OPACITY_15,
  COLOR_LIGHT_GREEN_OPACITY_20,
  COLOR_LIGHT_GREEN_OPACITY_25,
  COLOR_LIGHT_GREEN_OPACITY_30,
  COLOR_LIGHT_GREEN_OPACITY_35,
  COLOR_LIGHT_GREEN_OPACITY_40,
  COLOR_LIGHT_GREEN_OPACITY_45,
  COLOR_LIGHT_GREEN_OPACITY_50,
  COLOR_LIGHT_GREEN_OPACITY_55,
  COLOR_LIGHT_GREEN_OPACITY_60,
  COLOR_LIGHT_GREEN_OPACITY_65,
  COLOR_LIGHT_GREEN_OPACITY_70,
  COLOR_LIGHT_GREEN_OPACITY_75,
  COLOR_LIGHT_GREEN_OPACITY_80,
  COLOR_LIGHT_GREEN_OPACITY_85,
  COLOR_LIGHT_GREEN_OPACITY_90,
  COLOR_LIGHT_GREEN_OPACITY_95,
  COLOR_LIGHT_RED_SHADE_1,
  COLOR_LIGHT_RED_SHADE_2,
  COLOR_LIGHT_RED_TINT_1,
  COLOR_LIGHT_RED_TINT_2,
  COLOR_LIGHT_RED_5,
  COLOR_LIGHT_RED_10,
  COLOR_LIGHT_RED_15,
  COLOR_LIGHT_RED_20,
  COLOR_LIGHT_RED_25,
  COLOR_LIGHT_RED_30,
  COLOR_LIGHT_RED_35,
  COLOR_LIGHT_RED_40,
  COLOR_LIGHT_RED_45,
  COLOR_LIGHT_RED_50,
  COLOR_LIGHT_RED_55,
  COLOR_LIGHT_RED_60,
  COLOR_LIGHT_RED_65,
  COLOR_LIGHT_RED_70,
  COLOR_LIGHT_RED_75,
  COLOR_LIGHT_RED_80,
  COLOR_LIGHT_RED_85,
  COLOR_LIGHT_RED_90,
  COLOR_LIGHT_RED_95,
  COLOR_LIGHT_RED_OPACITY_5,
  COLOR_LIGHT_RED_OPACITY_10,
  COLOR_LIGHT_RED_OPACITY_15,
  COLOR_LIGHT_RED_OPACITY_20,
  COLOR_LIGHT_RED_OPACITY_25,
  COLOR_LIGHT_RED_OPACITY_30,
  COLOR_LIGHT_RED_OPACITY_35,
  COLOR_LIGHT_RED_OPACITY_40,
  COLOR_LIGHT_RED_OPACITY_45,
  COLOR_LIGHT_RED_OPACITY_50,
  COLOR_LIGHT_RED_OPACITY_55,
  COLOR_LIGHT_RED_OPACITY_60,
  COLOR_LIGHT_RED_OPACITY_65,
  COLOR_LIGHT_RED_OPACITY_70,
  COLOR_LIGHT_RED_OPACITY_75,
  COLOR_LIGHT_RED_OPACITY_80,
  COLOR_LIGHT_RED_OPACITY_85,
  COLOR_LIGHT_RED_OPACITY_90,
  COLOR_LIGHT_RED_OPACITY_95,
  COLOR_LIGHT_YELLOW_SHADE_1,
  COLOR_LIGHT_YELLOW_SHADE_2,
  COLOR_LIGHT_YELLOW_TINT_1,
  COLOR_LIGHT_YELLOW_TINT_2,
  COLOR_LIGHT_YELLOW_5,
  COLOR_LIGHT_YELLOW_10,
  COLOR_LIGHT_YELLOW_15,
  COLOR_LIGHT_YELLOW_20,
  COLOR_LIGHT_YELLOW_25,
  COLOR_LIGHT_YELLOW_30,
  COLOR_LIGHT_YELLOW_35,
  COLOR_LIGHT_YELLOW_40,
  COLOR_LIGHT_YELLOW_45,
  COLOR_LIGHT_YELLOW_50,
  COLOR_LIGHT_YELLOW_55,
  COLOR_LIGHT_YELLOW_60,
  COLOR_LIGHT_YELLOW_65,
  COLOR_LIGHT_YELLOW_70,
  COLOR_LIGHT_YELLOW_75,
  COLOR_LIGHT_YELLOW_80,
  COLOR_LIGHT_YELLOW_85,
  COLOR_LIGHT_YELLOW_90,
  COLOR_LIGHT_YELLOW_95,
  COLOR_LIGHT_YELLOW_OPACITY_5,
  COLOR_LIGHT_YELLOW_OPACITY_10,
  COLOR_LIGHT_YELLOW_OPACITY_15,
  COLOR_LIGHT_YELLOW_OPACITY_20,
  COLOR_LIGHT_YELLOW_OPACITY_25,
  COLOR_LIGHT_YELLOW_OPACITY_30,
  COLOR_LIGHT_YELLOW_OPACITY_35,
  COLOR_LIGHT_YELLOW_OPACITY_40,
  COLOR_LIGHT_YELLOW_OPACITY_45,
  COLOR_LIGHT_YELLOW_OPACITY_50,
  COLOR_LIGHT_YELLOW_OPACITY_55,
  COLOR_LIGHT_YELLOW_OPACITY_60,
  COLOR_LIGHT_YELLOW_OPACITY_65,
  COLOR_LIGHT_YELLOW_OPACITY_70,
  COLOR_LIGHT_YELLOW_OPACITY_75,
  COLOR_LIGHT_YELLOW_OPACITY_80,
  COLOR_LIGHT_YELLOW_OPACITY_85,
  COLOR_LIGHT_YELLOW_OPACITY_90,
  COLOR_LIGHT_YELLOW_OPACITY_95,
  COLOR_LIGHT_BLUE_SHADE_1,
  COLOR_LIGHT_BLUE_SHADE_2,
  COLOR_LIGHT_BLUE_TINT_1,
  COLOR_LIGHT_BLUE_TINT_2,
  COLOR_LIGHT_BLUE_5,
  COLOR_LIGHT_BLUE_10,
  COLOR_LIGHT_BLUE_15,
  COLOR_LIGHT_BLUE_20,
  COLOR_LIGHT_BLUE_25,
  COLOR_LIGHT_BLUE_30,
  COLOR_LIGHT_BLUE_35,
  COLOR_LIGHT_BLUE_40,
  COLOR_LIGHT_BLUE_45,
  COLOR_LIGHT_BLUE_50,
  COLOR_LIGHT_BLUE_55,
  COLOR_LIGHT_BLUE_60,
  COLOR_LIGHT_BLUE_65,
  COLOR_LIGHT_BLUE_70,
  COLOR_LIGHT_BLUE_75,
  COLOR_LIGHT_BLUE_80,
  COLOR_LIGHT_BLUE_85,
  COLOR_LIGHT_BLUE_90,
  COLOR_LIGHT_BLUE_95,
  COLOR_LIGHT_BLUE_OPACITY_5,
  COLOR_LIGHT_BLUE_OPACITY_10,
  COLOR_LIGHT_BLUE_OPACITY_15,
  COLOR_LIGHT_BLUE_OPACITY_20,
  COLOR_LIGHT_BLUE_OPACITY_25,
  COLOR_LIGHT_BLUE_OPACITY_30,
  COLOR_LIGHT_BLUE_OPACITY_35,
  COLOR_LIGHT_BLUE_OPACITY_40,
  COLOR_LIGHT_BLUE_OPACITY_45,
  COLOR_LIGHT_BLUE_OPACITY_50,
  COLOR_LIGHT_BLUE_OPACITY_55,
  COLOR_LIGHT_BLUE_OPACITY_60,
  COLOR_LIGHT_BLUE_OPACITY_65,
  COLOR_LIGHT_BLUE_OPACITY_70,
  COLOR_LIGHT_BLUE_OPACITY_75,
  COLOR_LIGHT_BLUE_OPACITY_80,
  COLOR_LIGHT_BLUE_OPACITY_85,
  COLOR_LIGHT_BLUE_OPACITY_90,
  COLOR_LIGHT_BLUE_OPACITY_95,
  COLOR_GREY_BLUE,
  COLOR_LIGHTER_BLUE,
  COLOR_BRIGHT_YELLOW,
  COLOR_DARK_YELLOW,
  COLOR_DARK_YELLOW_ACTIVE,
  COLOR_MIDDLEGREY,
  COLOR_DARKGREY,
  COLOR_LIGHTGREY,
  COLOR_PINK_ACTIVE,
  COLOR_TAB_BORDER_COLOR,
  COLOR_SYSTEM_SUCCESS_LIGHT,
  COLOR_SYSTEM_SUCCESS,
  COLOR_SYSTEM_WARNING_LIGHT,
  COLOR_SYSTEM_WARNING,
  COLOR_SYSTEM_ERROR_LIGHT,
  COLOR_SYSTEM_ERROR,
  COLOR_SYSTEM_HIGHLIGHT,

  COLOR_TRANSPARENT
] as const;

export const THEME_COLORS = [
  "pink500",
  "pink700",
  "purple500",
  "orange500",
  "yellow500",
  "blue500",
  "blue700",
  "blue900",
  "brightblue500",
  "green500",
  "green900",
  "brightgreen500",
  "pink",
  "darkPink",
  "brightBlue",
  "cyan",
  "darkblue",
  "red",
  "yellow",
  "green",
  "white",
  "bright",
  "dark",
  "dark900",
  "dark700",
  "dark600",
  "dark400",
  "dark300",
  "dark100",
  "blue",
  "ultralightgrey",
  "lightGreen",
  "lightRed",
  "lightYellow",
  "lightBlue"
];

export const DEFAULT_PAGE_BACKGROUND_COLOR = "eon-white" as const;

export const ACCORDION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink",
    scheme: {
      textColor: COLOR_WHITE,
      accordionBorderColor: COLOR_LIGHTGREY,
      activeAccordionBackgroundColor: COLOR_PINK,
      activeAccordionBarColor: COLOR_YELLOW,
      accordionHoverColor: COLOR_DARK_PINK,
      borderHoverColor: COLOR_PINK_75
    }
  },
  {
    schemeName: "whitePink",
    scheme: {
      textColor: COLOR_DARK,
      accordionBorderColor: COLOR_LIGHTGREY,
      activeAccordionBackgroundColor: COLOR_ULTRALIGHTGREY,
      activeAccordionBarColor: COLOR_PINK,
      accordionHoverColor: COLOR_ULTRALIGHTGREY,
      borderHoverColor: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "yellowPink",
    scheme: {
      textColor: COLOR_DARK,
      accordionBorderColor: COLOR_LIGHTGREY,
      activeAccordionBackgroundColor: COLOR_LIGHT_YELLOW,
      activeAccordionBarColor: COLOR_PINK,
      accordionHoverColor: COLOR_LIGHT_YELLOW,
      borderHoverColor: COLOR_YELLOW
    }
  },
  {
    schemeName: "greenPink",
    scheme: {
      textColor: COLOR_DARK,
      accordionBorderColor: COLOR_LIGHTGREY,
      activeAccordionBackgroundColor: COLOR_LIGHT_GREEN,
      activeAccordionBarColor: COLOR_PINK,
      accordionHoverColor: COLOR_LIGHT_GREEN,
      borderHoverColor: COLOR_GREEN
    }
  },
  {
    schemeName: "redPink",
    scheme: {
      textColor: COLOR_DARK,
      accordionBorderColor: COLOR_LIGHTGREY,
      activeAccordionBackgroundColor: COLOR_LIGHT_RED,
      activeAccordionBarColor: COLOR_PINK,
      accordionHoverColor: COLOR_LIGHT_RED,
      borderHoverColor: COLOR_PINK
    }
  },
  {
    schemeName: "blueBrightBlue",
    scheme: {
      textColor: COLOR_DARK,
      accordionBorderColor: COLOR_LIGHTGREY,
      activeAccordionBackgroundColor: COLOR_LIGHT_BLUE,
      activeAccordionBarColor: COLOR_BRIGHT_BLUE,
      accordionHoverColor: COLOR_LIGHT_BLUE,
      borderHoverColor: COLOR_BRIGHT_BLUE
    }
  },
  {
    schemeName: "brightBlue",
    scheme: {
      textColor: COLOR_WHITE,
      activeAccordionBarColor: COLOR_YELLOW
    }
  },
  {
    schemeName: "darkblue",
    scheme: {
      textColor: COLOR_WHITE,
      activeAccordionBarColor: COLOR_PINK
    }
  },
  {
    schemeName: "white",
    scheme: {
      borderHoverColor: COLOR_WHITE_SHADE_1,
      activeAccordionBarColor: COLOR_MIDDLEGREY
    }
  },
  {
    schemeName: "dark"
  }
];
export const ANSWER_CARD_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      footTextColor: COLOR_DARK,
      footTextHoverColor: COLOR_WHITE,
      imageBackgroundColor: COLOR_WHITE,
      imageBackgroundSelectedColor: COLOR_PINK,
      footBackgroundColor: COLOR_ULTRALIGHTGREY,
      footBackgroundHoverColor: COLOR_PINK,
      footBackgroundSelectedColor: COLOR_DARK_PINK,
      hoverCardBorderColor: COLOR_PINK,
      selectedCardBorderColor: COLOR_PINK,
      indicatorBordercolor: COLOR_PINK
    }
  },
  {
    schemeName: "pink",
    scheme: {
      footTextColor: COLOR_DARK,
      footTextHoverColor: COLOR_WHITE,
      imageBackgroundColor: COLOR_WHITE,
      imageBackgroundSelectedColor: COLOR_PINK,
      footBackgroundColor: COLOR_ULTRALIGHTGREY,
      footBackgroundHoverColor: COLOR_DARK_PINK,
      footBackgroundSelectedColor: COLOR_DARK_PINK,
      hoverCardBorderColor: COLOR_DARK_PINK,
      selectedCardBorderColor: COLOR_DARK_PINK,
      indicatorBordercolor: COLOR_DARK_PINK
    }
  },
  {
    schemeName: "brightBlue",
    scheme: {
      footTextColor: COLOR_DARK,
      footTextHoverColor: COLOR_WHITE,
      imageBackgroundColor: COLOR_WHITE,
      imageBackgroundSelectedColor: COLOR_BRIGHT_BLUE,
      footBackgroundColor: COLOR_ULTRALIGHTGREY,
      footBackgroundHoverColor: COLOR_DARKBLUE,
      footBackgroundSelectedColor: COLOR_DARKBLUE,
      hoverCardBorderColor: COLOR_DARKBLUE,
      selectedCardBorderColor: COLOR_DARKBLUE,
      indicatorBordercolor: COLOR_DARKBLUE
    }
  },
  {
    schemeName: "darkblue",
    scheme: {
      footTextColor: COLOR_DARK,
      footTextHoverColor: COLOR_WHITE,
      imageBackgroundColor: COLOR_WHITE,
      imageBackgroundSelectedColor: COLOR_DARKBLUE,
      footBackgroundColor: COLOR_ULTRALIGHTGREY,
      footBackgroundHoverColor: COLOR_BRIGHT_BLUE,
      footBackgroundSelectedColor: COLOR_BRIGHT_BLUE,
      hoverCardBorderColor: COLOR_BRIGHT_BLUE,
      selectedCardBorderColor: COLOR_BRIGHT_BLUE,
      indicatorBordercolor: COLOR_BRIGHT_BLUE
    }
  },
  {
    schemeName: "whiteOnYellow",
    scheme: {
      footTextColor: COLOR_DARK,
      footTextHoverColor: COLOR_WHITE,
      imageBackgroundColor: COLOR_WHITE,
      imageBackgroundSelectedColor: COLOR_YELLOW,
      footBackgroundColor: COLOR_ULTRALIGHTGREY,
      footBackgroundHoverColor: COLOR_PINK,
      footBackgroundSelectedColor: COLOR_YELLOW,
      hoverCardBorderColor: COLOR_PINK,
      selectedCardBorderColor: COLOR_PINK,
      indicatorBordercolor: COLOR_PINK
    }
  }
];
export const BASIC_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "lightGreen"
  },
  {
    schemeName: "lightRed"
  },
  {
    schemeName: "lightYellow"
  },
  {
    schemeName: "lightBlue"
  }
];
export const BADGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const BREADCRUMB_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const BOTTOM_DRAWER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  }
];
export const BULLET_LIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      highlight: COLOR_GREEN500
    }
  },
  {
    schemeName: "dark900",
    scheme: {
      highlight: COLOR_GREEN500
    }
  }
];
export const BULLET_LIST_DEPRECATED_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const BUSINESSCARD_AUTHOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink",
    scheme: {
      textHoverColor: COLOR_DARK_PINK
    }
  },
  {
    schemeName: "brightBlue",
    scheme: {
      textHoverColor: COLOR_PINK
    }
  },
  {
    schemeName: "darkblue",
    scheme: {
      textHoverColor: COLOR_PINK
    }
  },
  {
    schemeName: "white",
    scheme: {
      textHoverColor: COLOR_WHITE_OPACITY_85
    }
  },
  {
    schemeName: "dark"
  }
];
export const BUSINESSCARD_CONTACT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      backgroundColor: COLOR_WHITE,
      textcolor: COLOR_DARK,
      linkColor: COLOR_DARK,
      linkHoverColor: COLOR_PINK,
      mapsLink: COLOR_DARK
    }
  },
  {
    schemeName: "pink",
    scheme: {
      backgroundColor: COLOR_PINK,
      textcolor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85
    }
  },
  {
    schemeName: "darkPink",
    scheme: {
      backgroundColor: COLOR_DARK_PINK,
      textcolor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      mapsLink: COLOR_WHITE
    }
  },
  {
    schemeName: "darkblue",
    scheme: {
      backgroundColor: COLOR_DARKBLUE,
      textcolor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      mapsLink: COLOR_WHITE
    }
  },
  {
    schemeName: "brightBlue",
    scheme: {
      backgroundColor: COLOR_BRIGHT_BLUE,
      textcolor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      mapsLink: COLOR_WHITE
    }
  }
];
export const BOX_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "lightGreen"
  },
  {
    schemeName: "lightRed"
  },
  {
    schemeName: "lightYellow"
  },
  {
    schemeName: "lightBlue"
  }
];
export const BUTTON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "yellow",
    scheme: {
      primaryTextAndIconColor: COLOR_DARK,
      primaryTextAndIconHoverColor: COLOR_DARK,
      secondaryBackgroundColor: COLOR_TRANSPARENT,
      secondaryBackgroundHoverColor: COLOR_YELLOW,
      secondaryBackgroundFocusColor: COLOR_TRANSPARENT,
      secondaryTextAndIconColor: COLOR_DARK,
      secondaryTextAndIconHoverColor: COLOR_DARK,
      secondaryBorderColor: COLOR_YELLOW,
      secondaryBorderHoverColor: COLOR_YELLOW
    }
  },
  {
    schemeName: "pink500",
    scheme: {
      primaryTextAndIconColor: COLOR_WHITE,
      primaryTextAndIconHoverColor: COLOR_WHITE,
      secondaryBackgroundColor: COLOR_TRANSPARENT,
      secondaryBackgroundHoverColor: COLOR_TRANSPARENT,
      secondaryBackgroundFocusColor: COLOR_TRANSPARENT,
      secondaryTextAndIconColor: COLOR_PINK500,
      secondaryTextAndIconHoverColor: COLOR_PURPLE500,
      secondaryBorderColor: COLOR_TRANSPARENT,
      secondaryBorderHoverColor: COLOR_TRANSPARENT
    }
  },
  {
    schemeName: "cyan",
    scheme: {
      secondaryBackgroundColor: COLOR_TRANSPARENT,
      secondaryBackgroundHoverColor: COLOR_TRANSPARENT,
      secondaryBackgroundFocusColor: COLOR_TRANSPARENT,
      secondaryTextAndIconColor: COLOR_CYAN,
      secondaryTextAndIconHoverColor: COLOR_CYAN_SHADE_2,
      secondaryBorderColor: COLOR_CYAN,
      secondaryBorderHoverColor: COLOR_CYAN_SHADE_2
    }
  },
  {
    schemeName: "blue700",
    scheme: {
      primaryTextAndIconColor: COLOR_WHITE,
      primaryTextAndIconHoverColor: COLOR_WHITE,
      secondaryBackgroundColor: COLOR_TRANSPARENT,
      secondaryBackgroundHoverColor: COLOR_TRANSPARENT,
      secondaryBackgroundFocusColor: COLOR_TRANSPARENT,
      secondaryTextAndIconColor: COLOR_BLUE500,
      secondaryTextAndIconHoverColor: COLOR_BLUE700,
      secondaryBorderColor: COLOR_TRANSPARENT,
      secondaryBorderHoverColor: COLOR_TRANSPARENT
    }
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white",
    scheme: {
      primaryTextAndIconColor: COLOR_DARK,
      primaryTextAndIconHoverColor: COLOR_DARK600,
      primaryBorderHoverColor: COLOR_WHITE,
      primaryBackgroundHoverColor: COLOR_WHITE,
      secondaryBackgroundColor: COLOR_TRANSPARENT,
      secondaryBackgroundHoverColor: COLOR_TRANSPARENT,
      secondaryBackgroundFocusColor: COLOR_TRANSPARENT,
      secondaryTextAndIconColor: COLOR_DARK,
      secondaryTextAndIconHoverColor: COLOR_DARK600,
      secondaryBorderColor: COLOR_WHITE,
      secondaryBorderHoverColor: COLOR_WHITE
    }
  },
  {
    schemeName: "transparent",
    scheme: {
      primaryTextAndIconColor: COLOR_WHITE,
      primaryTextAndIconHoverColor: COLOR_WHITE,
      primaryBorderHoverColor: COLOR_WHITE,
      primaryBackgroundHoverColor: COLOR_TRANSPARENT,
      secondaryBackgroundColor: COLOR_TRANSPARENT,
      secondaryBackgroundHoverColor: COLOR_TRANSPARENT,
      secondaryBackgroundFocusColor: COLOR_TRANSPARENT,
      secondaryTextAndIconColor: COLOR_WHITE,
      secondaryTextAndIconHoverColor: COLOR_WHITE,
      secondaryBorderColor: COLOR_WHITE,
      secondaryBorderHoverColor: COLOR_WHITE
    }
  }
];
export const CAPTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const CARD_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink",
    scheme: {
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      headlineColor: COLOR_WHITE,
      alternativeHeadlineColor1: COLOR_WHITE,
      alternativeHeadlineColor2: COLOR_WHITE,
      headlineColorOffset: COLOR_PINK,
      categoryColor: COLOR_WHITE
    }
  },
  {
    schemeName: "brightBlue",
    scheme: {
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      headlineColor: COLOR_WHITE,
      alternativeHeadlineColor1: COLOR_WHITE,
      alternativeHeadlineColor2: COLOR_WHITE,
      headlineColorOffset: COLOR_BRIGHT_BLUE,
      categoryColor: COLOR_WHITE
    }
  },
  {
    schemeName: "darkblue",
    scheme: {
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      headlineColor: COLOR_WHITE,
      alternativeHeadlineColor1: COLOR_WHITE,
      alternativeHeadlineColor2: COLOR_WHITE,
      headlineColorOffset: COLOR_DARKBLUE,
      categoryColor: COLOR_WHITE
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      contentColor: COLOR_DARK,
      backgroundColor: COLOR_ULTRALIGHTGREY,
      linkColor: COLOR_DARK_YELLOW,
      linkHoverColor: COLOR_DARK_YELLOW_ACTIVE,
      headlineColor: COLOR_DARK,
      alternativeHeadlineColor1: COLOR_BRIGHT_BLUE,
      alternativeHeadlineColor2: COLOR_PINK,
      headlineColorOffset: COLOR_PINK,
      categoryColor: COLOR_DARK
    }
  },
  {
    schemeName: "white",
    scheme: {
      linkColor: COLOR_DARK_YELLOW,
      linkHoverColor: COLOR_DARK_YELLOW_ACTIVE,
      headlineColor: COLOR_DARK,
      alternativeHeadlineColor1: COLOR_BRIGHT_BLUE,
      alternativeHeadlineColor2: COLOR_DARKBLUE,
      headlineColorOffset: COLOR_PINK,
      categoryColor: COLOR_DARK
    }
  },
  {
    schemeName: "dark"
  }
];
export const CAROUSEL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink",
    scheme: {
      indicatorColor: COLOR_DARK_25,
      indicatorHoverColor: COLOR_MIDDLEGREY,
      controlHoverColor: COLOR_PINK_ACTIVE,
      outsideControlHoverColor: COLOR_PINK_ACTIVE
    }
  },
  {
    schemeName: "brightBlue",
    scheme: {
      indicatorColor: COLOR_DARK_25,
      indicatorHoverColor: COLOR_MIDDLEGREY,
      controlHoverColor: COLOR_DARKBLUE,
      outsideControlHoverColor: COLOR_DARKBLUE
    }
  },
  {
    schemeName: "blueInverted",
    scheme: {
      indicatorColor: COLOR_WHITE_OPACITY_30,
      indicatorHoverColor: COLOR_BRIGHT_BLUE_50,
      indicatorActColor: COLOR_WHITE,
      controlHoverColor: COLOR_DARKBLUE,
      controlHoverIconColor: COLOR_DARKBLUE,
      outsideControlColor: COLOR_WHITE,
      outsideControlIconColor: COLOR_DARK,
      outsideControlHoverColor: COLOR_WHITE,
      outsideControlHoverIconColor: COLOR_DARK
    }
  },
  {
    schemeName: "darkblue",
    scheme: {
      indicatorColor: COLOR_DARK_25,
      indicatorHoverColor: COLOR_MIDDLEGREY,
      controlHoverColor: COLOR_BRIGHT_BLUE,
      outsideControlHoverColor: COLOR_BRIGHT_BLUE
    }
  },
  {
    schemeName: "darkblueInverted",
    scheme: {
      indicatorColor: COLOR_WHITE_OPACITY_30,
      indicatorHoverColor: COLOR_DARKBLUE_50,
      indicatorActColor: COLOR_WHITE,
      controlHoverColor: COLOR_BRIGHT_BLUE,
      controlHoverIconColor: COLOR_BRIGHT_BLUE,
      outsideControlColor: COLOR_WHITE,
      outsideControlIconColor: COLOR_DARK,
      outsideControlHoverColor: COLOR_WHITE,
      outsideControlHoverIconColor: COLOR_DARK
    }
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "yellow"
  }
];
export const CHECKBOX_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      labelColor: COLOR_WHITE
    }
  },
  {
    schemeName: "dark",
    scheme: {
      errorColor: COLOR_RED,
      labelColorDisabled: COLOR_DARK300,
      outlineColor: COLOR_TRANSPARENT,
      borderColor: COLOR_BLUE500,
      borderColorHover: COLOR_BLUE500,
      outlineColorSelected: COLOR_BLUE500,
      borderColorDisabled: COLOR_DARK300,
      borderColorSelected: COLOR_BLUE500,
      borderColorSelectedHover: COLOR_TRANSPARENT,
      borderColorSelectedFocus: COLOR_TRANSPARENT,
      borderColorSelectedDisabled: COLOR_TRANSPARENT,
      backgroundColorDisabled: COLOR_TRANSPARENT,
      backgroundColorSelected: COLOR_BLUE500,
      backgroundColorSelectedHover: COLOR_BLUE500,
      backgroundColorSelectedFocus: COLOR_BLUE500,
      backgroundColorSelectedDisabled: COLOR_DARK300,
      iconColorHover: COLOR_BLUE500_OPACITY_50,
      iconColorFocus: COLOR_BLUE500_OPACITY_50,
      iconColorSelected: COLOR_WHITE,
      iconColorSelectedHover: COLOR_WHITE,
      iconColorSelectedFocus: COLOR_WHITE,
      iconColorSelectedDisabled: COLOR_WHITE
    }
  }
];
export const CHIP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "yellow"
  }
];
export const CLICKABLE_IMAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "yellow"
  }
];
export const COMPASS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  }
];
export const CONTACT_BAR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "white"
  }
];
export const CONTACT_LIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white",
    scheme: {
      linkHoverColor: COLOR_WHITE_OPACITY_85
    }
  },
  {
    schemeName: "dark"
  }
];
export const CONTACT_LAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const CONTENT_AGGREGATOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const CONTENT_AGGREGATOR_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const CONTEXT_MENU_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      backgroundColor: COLOR_WHITE,
      menuTitleBackgroundColor: COLOR_WHITE
    }
  }
];
export const CONTEXT_MENU_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      itemBackgroundColor: COLOR_WHITE,
      itemIconActiveColor: COLOR_PINK
    }
  }
];
export const DATE_EVENT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white",
    scheme: {
      dateColor: COLOR_WHITE,
      dateLeftBorder: COLOR_LIGHTGREY
    }
  },
  {
    schemeName: "dark",
    scheme: {
      dateColor: COLOR_DARK,
      dateLeftBorder: COLOR_DARK_OPACITY_50
    }
  }
];
export const DATE_PICKER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink",
    scheme: {
      popupBorderColor: COLOR_WHITE
    }
  },
  {
    schemeName: "white",
    scheme: {
      popupBorderColor: COLOR_DARK
    }
  },
  {
    schemeName: "dapurplerk",
    scheme: {
      fontColor: COLOR_DARK,
      popupBackgroundColor: COLOR_WHITE,
      popupBorderColor: COLOR_WHITE,
      separatorColor: COLOR_DARK300,
      dayBorderHoverColor: COLOR_PURPLE500,
      dayBorderSelectedColor: COLOR_PURPLE500,
      dayBackgroundTodayColor: COLOR_DARK300,
      dayFontDisabledColor: COLOR_DARK300,
      dayFontOtherMonthColor: COLOR_DARK300,
      monthYearButtonBorderColor: COLOR_DARK300,
      scrollbarBackgroundColor: COLOR_DARK300,
      scrollbarThumbColor: COLOR_DARK300,
      monthYearToggleBorderColor: COLOR_DARK300,
      monthYearToggleBorderHoverColor: COLOR_PURPLE500,
      monthYearToggleBorderActiveColor: COLOR_PURPLE500,
      monthYearToggleBackgroundActiveColor: COLOR_WHITE
    }
  }
];
export const DIVIDER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "bright"
  },
  {
    schemeName: "dark"
  }
];
export const DROPDOWN_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "dark",
    scheme: {
      background: COLOR_WHITE,
      separatorColor: COLOR_DARK400,
      borderColor: COLOR_DARK400,
      borderHoverColor: COLOR_DARK600,
      borderActiveColor: COLOR_DARK600,
      labelColor: COLOR_DARK400,
      labelColorActive: COLOR_DARK600,
      errorMessageColor: COLOR_RED,
      trailingIconBackgroundColor: COLOR_DARK100,
      trailingIconColor: COLOR_DARK700,
      trailingIconColorActive: COLOR_DARK,
      disabledBackgroundColor: COLOR_WHITE,
      disabledBorderColor: COLOR_DARK300,
      disabledTrailingIconColor: COLOR_DARK300,
      disabledOpacity: 0.6,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderHoverColor: COLOR_DARK600,
      optionsBorderBottomColor: COLOR_DARK300,
      optionsBackgroundColorHover: COLOR_DARK300,
      optionsBackgroundColorActive: COLOR_DARK400
    }
  }
];
export const DROPDOWN_OPTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "bright",
    scheme: {
      labelColor: COLOR_WHITE
    }
  },
  {
    schemeName: "dark",
    scheme: {
      borderHoverColor: COLOR_DARKGREY,
      borderBottomColor: COLOR_LIGHTGREY,
      backgroundColorHover: COLOR_LIGHTGREY,
      backgroundColorActive: COLOR_LIGHTER_BLUE
    }
  }
];
export const ERROR_MESSAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const FILE_UPLOAD_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white",
    scheme: {
      buttonScheme: "yellow",
      dropzoneIconHoverColor: COLOR_DARK,
      dropzoneContentColor: COLOR_WHITE,
      dropzoneLinkHoverColor: COLOR_DARK,
      uploadedStatusColor: COLOR_WHITE,
      uploadCompleteProgressCircleScheme: "dark"
    }
  },
  {
    schemeName: "dark",
    scheme: {
      dropzoneBorderSingle: COLOR_DARK_OPACITY_20,
      dropzoneBorderMultiple: COLOR_DARK_OPACITY_20,
      buttonScheme: "yellow",
      dropzoneHoverBorder: COLOR_DARK_TINT_2,
      dropzoneOnDragHoverBorder: COLOR_DARK_TINT_2,
      dropzoneIconHoverColor: COLOR_WHITE,
      dropzoneContentColor: COLOR_DARK,
      dropzoneLinkHoverColor: COLOR_WHITE,
      uploadedStatusColor: COLOR_DARK,
      uploadCompleteProgressCircleScheme: "white"
    }
  }
];
export const FILE_PREVIEW_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "dark",
    scheme: {
      iconColor: COLOR_WHITE,
      textColor: COLOR_WHITE,
      boxBackground: COLOR_DARK,
      fileIconColor: COLOR_WHITE,
      descriptionColor: COLOR_WHITE,
      progressCircleScheme: "white",
      previewCancelIconColor: COLOR_WHITE
    }
  },
  {
    schemeName: "white",
    scheme: {
      iconColor: COLOR_DARK,
      textColor: COLOR_DARK,
      boxBackground: COLOR_WHITE,
      fileIconColor: COLOR_DARK,
      descriptionColor: COLOR_DARK,
      progressCircleScheme: "pink",
      previewCancelIconColor: COLOR_DARK
    }
  }
];
export const FORM_MESSAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark",
    scheme: {
      errorColor: COLOR_RED
    }
  }
];
export const HEADLINE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const ICON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "yellow"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const INFO_ICON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      iconHoverColor: COLOR_WHITE_OPACITY_80
    }
  },
  {
    schemeName: "orange500"
  }
];
export const INPUT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "dark",
    scheme: {
      borderColor: COLOR_DARK400,
      borderHoverColor: COLOR_DARK600,
      borderActiveColor: COLOR_DARK600,
      labelColor: COLOR_DARK400,
      labelColorActive: COLOR_DARK600,
      errorMessageColor: COLOR_RED,
      trailingIconBackgroundColor: COLOR_WHITE,
      trailingIconColor: COLOR_DARK400,
      trailingIconColorActive: COLOR_DARK600,
      disabledBackgroundColor: COLOR_WHITE,
      disabledBorderColor: COLOR_DARK300,
      disabledTrailingIconColor: COLOR_DARK300,
      disabledOpacity: 0.6,
      optionsBackgroundColor: COLOR_WHITE,
      optionsBorderHoverColor: COLOR_DARK600,
      optionsBorderBottomColor: COLOR_DARK400,
      optionsBackgroundColorHover: COLOR_DARK400,
      optionsBackgroundColorActive: COLOR_DARK400
    }
  }
];
export const LINK_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink500",
    scheme: {
      contentHoverColor: COLOR_PINK700
    }
  },
  {
    schemeName: "dark",
    scheme: {
      contentHoverColor: COLOR_PINK500
    }
  },
  {
    schemeName: "blue700",
    scheme: {
      contentHoverColor: COLOR_BLUE900
    }
  },
  {
    schemeName: "green500",
    scheme: {
      contentHoverColor: COLOR_GREEN900
    }
  },
  {
    schemeName: "white"
  }
];
export const LINKLIST_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const MAP_INFO_LAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const MULTI_CONTENT_STAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "white"
  }
];
export const NUMBER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const OFFSET_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink",
    scheme: {
      textcolor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85
    }
  },
  {
    schemeName: "darkPink",
    scheme: {
      textcolor: COLOR_WHITE,
      linkColor: COLOR_WHITE,
      linkHoverColor: COLOR_WHITE_OPACITY_85,
      mapsLink: COLOR_WHITE
    }
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "white",
    scheme: {
      contentColor: COLOR_DARK,
      textcolor: COLOR_DARK,
      linkColor: COLOR_PINK500,
      linkHoverColor: COLOR_PINK700,
      mapsLink: COLOR_DARK
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      contentColor: COLOR_DARK,
      textcolor: COLOR_DARK,
      linkColor: COLOR_DARK_YELLOW,
      linkHoverColor: COLOR_DARK_YELLOW_ACTIVE,
      mapsLink: COLOR_DARK
    }
  }
];
export const OFFSET_TEASER5_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "darkPink"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "ultralightgrey"
  },
  {
    schemeName: "white"
  }
];
export const OPTION_PICKER_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "lightblue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const PAGINATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "yellow"
  }
];
export const PRELOADER_CIRCLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "colorful",
    scheme: {
      spinnerColor: COLOR_PINK,
      trackColor: COLOR_DARK_OPACITY_5
    }
  },
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const PRELOADER_SQUARES_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const PROGRESS_CIRCLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "red"
  }
];
export const PROMO_FLAG_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const PAGE_HEADER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const PICTOGRAM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "yellow"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const RADIO_BUTTON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "blue500"
  },
  {
    schemeName: "white",
    scheme: {
      labelColor: COLOR_WHITE
    }
  }
];
export const READ_MORE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "darkPink"
  }
];
export const RTE_RENDERER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white",
    scheme: {
      paragraphColor: COLOR_WHITE,
      sublineColor: COLOR_WHITE,
      blockquoteColor: COLOR_WHITE
    }
  },
  {
    schemeName: "dark"
  }
];
export const SECTION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "darkPink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "blue"
  },
  {
    schemeName: "cyan"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "lightgrey"
  },
  {
    schemeName: "ultralightgrey"
  },
  {
    schemeName: "lightYellow"
  },
  {
    schemeName: "lightBlue"
  },
  {
    schemeName: "lightRed"
  },
  {
    schemeName: "lightGreen"
  },
  {
    schemeName: "transparent"
  }
];
export const SEARCH_RESULT_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "red"
  }
];
export const SEGMENTED_BUTTON_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const SITELINK_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const SLIDER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "red"
  }
];
export const SWITCH_TOGGLE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "pink"
  },
  {
    schemeName: "white"
  }
];
export const STAGE_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink",
    scheme: {
      headlineScheme: "pink",
      linkScheme: "pink"
    }
  },
  {
    schemeName: "brightBlue",
    scheme: {
      headlineScheme: "brightBlue",
      linkScheme: "brightBlue"
    }
  },
  {
    schemeName: "darkblue",
    scheme: {
      headlineScheme: "darkblue",
      linkScheme: "darkblue"
    }
  },
  {
    schemeName: "white",
    scheme: {
      headlineScheme: "white",
      linkScheme: "white"
    }
  },
  {
    schemeName: "dark",
    scheme: {
      headlineScheme: "dark",
      linkScheme: "dark"
    }
  },
  {
    schemeName: "red",
    scheme: {
      headlineScheme: "red",
      linkScheme: "red"
    }
  }
];
export const STEP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "orange500"
  }
];
export const STEPS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "orange500",
    scheme: {
      inactiveSeparatorColor: COLOR_DARK300
    }
  }
];
export const TABLE_RENDERER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "whitePinkHighlighting",
    scheme: {
      paragraphColor: COLOR_DARK,
      tableBorderColor: COLOR_DARK,
      tableHighlightColor: COLOR_PINK,
      tableBackgroundColor: COLOR_WHITE,
      tableAlternateBackgroundColor: COLOR_ULTRALIGHTGREY
    }
  },
  {
    schemeName: "whiteBlueHighlighting",
    scheme: {
      paragraphColor: COLOR_DARK,
      tableBorderColor: COLOR_DARK,
      tableHighlightColor: COLOR_BLUE,
      tableBackgroundColor: COLOR_WHITE,
      tableAlternateBackgroundColor: COLOR_ULTRALIGHTGREY
    }
  },
  {
    schemeName: "pink",
    scheme: {
      paragraphColor: COLOR_WHITE,
      tableBorderColor: COLOR_WHITE,
      tableHighlightColor: COLOR_YELLOW,
      tableBackgroundColor: COLOR_PINK,
      tableAlternateBackgroundColor: COLOR_PINK_ACTIVE
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      paragraphColor: COLOR_DARK,
      tableBorderColor: COLOR_DARK,
      tableHighlightColor: COLOR_PINK,
      tableBackgroundColor: COLOR_ULTRALIGHTGREY,
      tableAlternateBackgroundColor: COLOR_PINK_ACTIVE
    }
  },
  {
    schemeName: "brightBlue",
    scheme: {
      paragraphColor: COLOR_WHITE,
      tableBorderColor: COLOR_WHITE,
      tableHighlightColor: COLOR_YELLOW,
      tableBackgroundColor: COLOR_BLUE,
      tableAlternateBackgroundColor: COLOR_DARKBLUE
    }
  },
  {
    schemeName: "darkblue",
    scheme: {
      paragraphColor: COLOR_WHITE,
      tableBorderColor: COLOR_WHITE,
      tableHighlightColor: COLOR_YELLOW,
      tableBackgroundColor: COLOR_DARKBLUE,
      tableAlternateBackgroundColor: COLOR_BLUE
    }
  }
];
export const TABS_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "purple500",
    scheme: {
      textColor: COLOR_DARK,
      tabBorderColor: COLOR_DARK300,
      tabActiveBorderColor: COLOR_PURPLE500,
      tabHoverColor: COLOR_WHITE,
      tabFocusColor: COLOR_WHITE
    }
  }
];
export const TAG_PILL_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "orange500",
    scheme: {
      textAndIconColor: COLOR_DARK,
      textAndIconHoverColor: COLOR_DARK,
      textAndIconActiveColor: COLOR_DARK,
      textAndIconActiveHoverColor: COLOR_DARK,
      borderColor: COLOR_ORANGE500,
      focusBorderColor: COLOR_YELLOW
    }
  }
];
export const TEXT_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  }
];
export const TEXT_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink",
    scheme: {
      valueTextColor: COLOR_WHITE,
      contentColor: COLOR_WHITE,
      contentBackgroundColor: COLOR_PINK
    }
  },
  {
    schemeName: "darkPink",
    scheme: {
      valueTextColor: COLOR_WHITE,
      contentColor: COLOR_WHITE,
      contentBackgroundColor: COLOR_PINK
    }
  },
  {
    schemeName: "brightBlue",
    scheme: {
      valueTextColor: COLOR_WHITE,
      contentColor: COLOR_WHITE,
      contentBackgroundColor: COLOR_BRIGHT_BLUE
    }
  },
  {
    schemeName: "darkblue",
    scheme: {
      valueTextColor: COLOR_WHITE,
      contentColor: COLOR_WHITE,
      contentBackgroundColor: COLOR_DARKBLUE
    }
  },
  {
    schemeName: "white",
    scheme: {
      valueTextColor: COLOR_DARK,
      contentColor: COLOR_DARK,
      contentBackgroundColor: COLOR_WHITE
    }
  },
  {
    schemeName: "ultralightgrey",
    scheme: {
      valueTextColor: COLOR_PINK,
      contentColor: COLOR_DARK,
      contentBackgroundColor: COLOR_ULTRALIGHTGREY
    }
  },
  {
    schemeName: "lightRed",
    scheme: {
      valueTextColor: COLOR_DARK,
      contentColor: COLOR_DARK,
      contentBackgroundColor: COLOR_LIGHT_RED
    }
  },
  {
    schemeName: "lightBlue",
    scheme: {
      valueTextColor: COLOR_DARK,
      contentColor: COLOR_DARK,
      contentBackgroundColor: COLOR_LIGHT_BLUE
    }
  },
  {
    schemeName: "lightYellow",
    scheme: {
      valueTextColor: COLOR_DARK,
      contentColor: COLOR_DARK,
      contentBackgroundColor: COLOR_LIGHT_YELLOW
    }
  }
];
export const THIRD_LEVEL_NAVIGATION_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "red"
  }
];
export const THIRD_LEVEL_NAVIGATION_ITEM_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "red"
  }
];
export const TILES_TEASER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink",
    scheme: {
      backgroundColor: COLOR_PINK,
      hoverBackgroundColor: COLOR_DARK_PINK
    }
  },
  {
    schemeName: "brightBlue",
    scheme: {
      backgroundColor: COLOR_BRIGHT_BLUE,
      hoverBackgroundColor: COLOR_DARKBLUE
    }
  },
  {
    schemeName: "darkblue",
    scheme: {
      backgroundColor: COLOR_DARKBLUE,
      hoverBackgroundColor: COLOR_BRIGHT_BLUE
    }
  },
  {
    schemeName: "white",
    scheme: {
      backgroundColor: COLOR_WHITE,
      hoverBackgroundColor: COLOR_ULTRALIGHTGREY,
      hoverColor: COLOR_PINK
    }
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "red"
  }
];
export const TOOLTIP_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "ultralightgrey"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "darkPink"
  }
];
export const VIDEOPLAYER_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "pink500"
  },
  {
    schemeName: "white"
  }
];
export const VIOLATOR_SCHEMES: Array<SchemeConfig> = [
  {
    schemeName: "pink"
  },
  {
    schemeName: "brightBlue"
  },
  {
    schemeName: "darkblue"
  },
  {
    schemeName: "white"
  },
  {
    schemeName: "dark"
  },
  {
    schemeName: "red"
  }
];

export interface AccordionSchemeConfiguration<T> {
  pink?: T;
  whitePink?: T;
  yellowPink?: T;
  greenPink?: T;
  redPink?: T;
  blueBrightBlue?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface AnswerCardSchemeConfiguration<T> {
  white?: T;
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  whiteOnYellow?: T;
}
export interface BasicTeaserSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
  lightGreen?: T;
  lightRed?: T;
  lightYellow?: T;
  lightBlue?: T;
}
export interface BadgeSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface BreadcrumbSchemeConfiguration<T> {
  white?: T;
  dark?: T;
}
export interface BottomDrawerSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
}
export interface BulletListSchemeConfiguration<T> {
  white?: T;
  dark900?: T;
}
export interface BulletListDeprecatedSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface BusinesscardAuthorSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface BusinesscardContactSchemeConfiguration<T> {
  white?: T;
  pink?: T;
  darkPink?: T;
  darkblue?: T;
  brightBlue?: T;
}
export interface BoxSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
  lightGreen?: T;
  lightRed?: T;
  lightYellow?: T;
  lightBlue?: T;
}
export interface ButtonSchemeConfiguration<T> {
  yellow?: T;
  pink500?: T;
  cyan?: T;
  blue700?: T;
  darkblue?: T;
  white?: T;
  transparent?: T;
}
export interface CaptionSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface CardTeaserSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  ultralightgrey?: T;
  white?: T;
  dark?: T;
}
export interface CarouselSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  blueInverted?: T;
  darkblue?: T;
  darkblueInverted?: T;
  white?: T;
  dark?: T;
  yellow?: T;
}
export interface CheckboxSchemeConfiguration<T> {
  white?: T;
  dark?: T;
}
export interface ChipSchemeConfiguration<T> {
  yellow?: T;
}
export interface ClickableImageSchemeConfiguration<T> {
  yellow?: T;
}
export interface CompassSchemeConfiguration<T> {
  pink?: T;
}
export interface ContactBarSchemeConfiguration<T> {
  pink?: T;
  white?: T;
}
export interface ContactListSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface ContactLayerSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  white?: T;
  dark?: T;
}
export interface ContentAggregatorSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  bright?: T;
  dark?: T;
}
export interface ContentAggregatorItemSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface ContextMenuSchemeConfiguration<T> {
  white?: T;
}
export interface ContextMenuItemSchemeConfiguration<T> {
  white?: T;
}
export interface DateEventSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface DatePickerSchemeConfiguration<T> {
  pink?: T;
  white?: T;
  dapurplerk?: T;
}
export interface DividerSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  bright?: T;
  dark?: T;
}
export interface DropdownSchemeConfiguration<T> {
  dark?: T;
}
export interface DropdownOptionSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  bright?: T;
  dark?: T;
}
export interface ErrorMessageSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  white?: T;
  dark?: T;
}
export interface FileUploadSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface FilePreviewSchemeConfiguration<T> {
  dark?: T;
  white?: T;
}
export interface FormMessageSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface HeadlineSchemeConfiguration<T> {
  white?: T;
  dark?: T;
}
export interface IconSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  yellow?: T;
  white?: T;
  dark?: T;
}
export interface InfoIconSchemeConfiguration<T> {
  white?: T;
  orange500?: T;
}
export interface InputSchemeConfiguration<T> {
  dark?: T;
}
export interface LinkSchemeConfiguration<T> {
  pink500?: T;
  dark?: T;
  blue700?: T;
  green500?: T;
  white?: T;
}
export interface LinklistSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface MapInfoLayerSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface MultiContentStageSchemeConfiguration<T> {
  brightBlue?: T;
  white?: T;
}
export interface NumberSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  white?: T;
  dark?: T;
}
export interface OffsetTeaserSchemeConfiguration<T> {
  pink?: T;
  darkPink?: T;
  darkblue?: T;
  brightBlue?: T;
  white?: T;
  ultralightgrey?: T;
}
export interface OffsetTeaser5SchemeConfiguration<T> {
  pink?: T;
  darkPink?: T;
  darkblue?: T;
  brightBlue?: T;
  ultralightgrey?: T;
  white?: T;
}
export interface OptionPickerItemSchemeConfiguration<T> {
  pink?: T;
  lightblue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface PaginationSchemeConfiguration<T> {
  yellow?: T;
}
export interface PreloaderCircleSchemeConfiguration<T> {
  colorful?: T;
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface PreloaderSquaresSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface ProgressCircleSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
  red?: T;
}
export interface PromoFlagSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface PageHeaderSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface PictogramSchemeConfiguration<T> {
  pink?: T;
  yellow?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface RadioButtonSchemeConfiguration<T> {
  blue500?: T;
  white?: T;
}
export interface ReadMoreSchemeConfiguration<T> {
  darkPink?: T;
}
export interface RteRendererSchemeConfiguration<T> {
  white?: T;
  dark?: T;
}
export interface SectionSchemeConfiguration<T> {
  pink?: T;
  darkPink?: T;
  brightBlue?: T;
  blue?: T;
  cyan?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
  lightgrey?: T;
  ultralightgrey?: T;
  lightYellow?: T;
  lightBlue?: T;
  lightRed?: T;
  lightGreen?: T;
  transparent?: T;
}
export interface SearchResultItemSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
  red?: T;
}
export interface SegmentedButtonSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface SitelinkSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
}
export interface SliderSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
  red?: T;
}
export interface SwitchToggleSchemeConfiguration<T> {
  brightBlue?: T;
  pink?: T;
  white?: T;
}
export interface StageSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
  red?: T;
}
export interface StepSchemeConfiguration<T> {
  orange500?: T;
}
export interface StepsSchemeConfiguration<T> {
  orange500?: T;
}
export interface TableRendererSchemeConfiguration<T> {
  whitePinkHighlighting?: T;
  whiteBlueHighlighting?: T;
  pink?: T;
  ultralightgrey?: T;
  brightBlue?: T;
  darkblue?: T;
}
export interface TabsSchemeConfiguration<T> {
  purple500?: T;
}
export interface TagPillSchemeConfiguration<T> {
  orange500?: T;
}
export interface TextSchemeConfiguration<T> {
  white?: T;
  dark?: T;
}
export interface TextTeaserSchemeConfiguration<T> {
  pink?: T;
  darkPink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  ultralightgrey?: T;
  lightRed?: T;
  lightBlue?: T;
  lightYellow?: T;
}
export interface ThirdLevelNavigationSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
  red?: T;
}
export interface ThirdLevelNavigationItemSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
  red?: T;
}
export interface TilesTeaserSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
  red?: T;
}
export interface TooltipSchemeConfiguration<T> {
  pink?: T;
  ultralightgrey?: T;
  white?: T;
  brightBlue?: T;
  darkblue?: T;
  darkPink?: T;
}
export interface VideoplayerSchemeConfiguration<T> {
  brightBlue?: T;
  pink500?: T;
  white?: T;
}
export interface ViolatorSchemeConfiguration<T> {
  pink?: T;
  brightBlue?: T;
  darkblue?: T;
  white?: T;
  dark?: T;
  red?: T;
}
//add Components Color-Variables from colorDefinitions
export const ANCHOR_NAVIGATION_BACKGROUND_COLOR = "eon-anchor-navigation-background-color" as const;
export const ANCHOR_NAVIGATION_BACKGROUND_HOVER_COLOR = "eon-anchor-navigation-background-hover-color" as const;
export const ANCHOR_NAVIGATION_ICON_COLOR = "eon-anchor-navigation-icon-color" as const;
export const ANCHOR_NAVIGATION_ICON_HOVER_COLOR = "eon-anchor-navigation-icon-hover-color" as const;
export const ANCHOR_NAVIGATION_ICON_HIGHLIGHT_COLOR = "eon-anchor-navigation-icon-highlight-color" as const;
export const ANCHOR_NAVIGATION_ITEM_BACKGROUND_COLOR = "eon-anchor-navigation-item-background-color" as const;
export const ANCHOR_NAVIGATION_ITEM_HOVER_COLOR = "eon-anchor-navigation-item-hover-color" as const;
export const ANCHOR_NAVIGATION_LINK_COLOR = "eon-anchor-navigation-link-color" as const;
export const ANCHOR_NAVIGATION_LINK_HOVER_COLOR = "eon-anchor-navigation-link-hover-color" as const;
export const ANCHOR_NAVIGATION_LINK_HIGHLIGHT_COLOR = "eon-anchor-navigation-link-highlight-color" as const;
export const CAROUSEL_CONTROL_COLOR_WHITE = "eon-carousel-control-color-white" as const;
export const CAROUSEL_CONTROL_COLOR_DARK = "eon-carousel-control-color-dark" as const;
export const CAROUSEL_CONTROL_ICON_COLOR_WHITE = "eon-carousel-control-icon-color-white" as const;
export const CAROUSEL_CONTROL_ICON_COLOR_DARK = "eon-carousel-control-icon-color-dark" as const;
export const COLOR_SEPARATOR_FIRST_COLOR = "eon-color-separator-first-color" as const;
export const COLOR_SEPARATOR_SECOND_COLOR = "eon-color-separator-second-color" as const;
export const COLOR_SEPARATOR_THIRD_COLOR = "eon-color-separator-third-color" as const;
export const CONTACT_BAR_MODAL_BACKGROUND_COLOR = "eon-contact-bar-modal-background-color" as const;
export const CONTEXT_MENU_ITEM_BACKGROUND_HOVER_COLOR = "eon-context-menu-item-background-hover-color" as const;
export const CONTEXT_MENU_ITEM_BACKGROUND_ACTIVE_COLOR = "eon-context-menu-item-background-active-color" as const;
export const DATA_TABLE_HEAD_CELL_COLOR = "eon-data-table-head-cell-color" as const;
export const DATA_TABLE_HEAD_CELL_ICON_COLOR = "eon-data-table-head-cell-icon-color" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND = "eon-data-table-head-cell-background" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_HOVER = "eon-data-table-head-cell-background-hover" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_ACT = "eon-data-table-head-cell-background-act" as const;
export const DATA_TABLE_HEAD_CELL_BACKGROUND_ACT_HOVER = "eon-data-table-head-cell-background-act-hover" as const;
export const DATA_TABLE_HEAD_CELL_BORDER = "eon-data-table-head-cell-border" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_HOVER = "eon-data-table-head-cell-border-hover" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_ACT = "eon-data-table-head-cell-border-act" as const;
export const DATA_TABLE_HEAD_CELL_BORDER_ACT_HOVER = "eon-data-table-head-cell-border-act-hover" as const;
export const DATA_TABLE_CELL_COLOR = "eon-data-table-cell-color" as const;
export const DATA_TABLE_CELL_ICON_COLOR = "eon-data-table-cell-icon-color" as const;
export const DATA_TABLE_CELL_BACKGROUND = "eon-data-table-cell-background" as const;
export const DATA_TABLE_CELL_BACKGROUND_HOVER = "eon-data-table-cell-background-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_SELECTED = "eon-data-table-cell-background-selected" as const;
export const DATA_TABLE_CELL_BACKGROUND_SELECTED_HOVER = "eon-data-table-cell-background-selected-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_ODD = "eon-data-table-cell-background-odd" as const;
export const DATA_TABLE_CELL_BACKGROUND_ODD_HOVER = "eon-data-table-cell-background-odd-hover" as const;
export const DATA_TABLE_CELL_BACKGROUND_EVEN = "eon-data-table-cell-background-even" as const;
export const DATA_TABLE_CELL_BACKGROUND_EVEN_HOVER = "eon-data-table-cell-background-even-hover" as const;
export const DATA_TABLE_CELL_BORDER = "eon-data-table-cell-border" as const;
export const DATA_TABLE_CELL_BORDER_HOVER = "eon-data-table-cell-border-hover" as const;
export const DATA_TABLE_CELL_BORDER_SELECTED = "eon-data-table-cell-border-selected" as const;
export const DATA_TABLE_CELL_BORDER_SELECTED_HOVER = "eon-data-table-cell-border-selected-hover" as const;
export const DATA_TABLE_CELL_BORDER_ODD = "eon-data-table-cell-border-odd" as const;
export const DATA_TABLE_CELL_BORDER_ODD_HOVER = "eon-data-table-cell-border-odd-hover" as const;
export const DATA_TABLE_CELL_BORDER_EVEN = "eon-data-table-cell-border-even" as const;
export const DATA_TABLE_CELL_BORDER_EVEN_HOVER = "eon-data-table-cell-border-even-hover" as const;
export const DATA_TABLE_TOOLBAR_BACKGROUND = "eon-data-table-toolbar-background" as const;
export const DATA_TABLE_TOOLBAR_COLOR = "eon-data-table-toolbar-color" as const;
export const DATA_TABLE_TOOLBAR_SELECTED_BACKGROUND = "eon-data-table-toolbar-selected-background" as const;
export const DATA_TABLE_TOOLBAR_SELECTED_COLOR = "eon-data-table-toolbar-selected-color" as const;
export const DATE_PICKER_FONT_COLOR = "eon-date-picker-font-color" as const;
export const DATE_PICKER_FONT_SECONDARY_COLOR = "eon-date-picker-font-secondary-color" as const;
export const DATE_PICKER_FONT_HIGHLIGHT_COLOR = "eon-date-picker-font-highlight-color" as const;
export const DATE_PICKER_FONT_DISABLED_COLOR = "eon-date-picker-font-disabled-color" as const;
export const DATE_PICKER_FONT_COLOR_HEAD = "eon-date-picker-font-color-head" as const;
export const DATE_PICKER_FONT_COLOR_OTHER_MONTH = "eon-date-picker-font-color-other-month" as const;
export const DATE_PICKER_CONTENT_BACKGROUND_COLOR = "eon-date-picker-content-background-color" as const;
export const DATE_PICKER_CALENDAR_HEAD_COLOR = "eon-date-picker-calendar-head-color" as const;
export const FOOTER_BAR_COPYRIGHT_COLOR = "eon-footer-bar-copyright-color" as const;
export const FOOTER_BAR_BACKGROUND_COLOR = "eon-footer-bar-background-color" as const;
export const FOOTER_BAR_LINK_COLOR = "eon-footer-bar-link-color" as const;
export const FOOTER_BAR_LINK_HOVER_COLOR = "eon-footer-bar-link-hover-color" as const;
export const MAP_SVG_COLOR = "eon-map-svg-color" as const;
export const MODAL_BACKGROUND_COLOR = "eon-modal-background-color" as const;
export const MODAL_BORDER_BOTTOM_COLOR = "eon-modal-border-bottom-color" as const;
export const MODAL_WRAPPER_BACKGROUND_COLOR = "eon-modal-wrapper-background-color" as const;
export const MODAL_FULL_WIDTH_BACKGROUND_COLOR = "eon-modal-full-width-background-color" as const;
export const MODAL_FULL_WIDTH_ON_FILTER_BLUR_BACKGROUND_COLOR = "eon-modal-full-width-on-filter-blur-background-color" as const;
export const NAVIGATION_BOX_SHADOW = "eon-navigation-box-shadow" as const;
export const NAVIGATION_META_BG_COLOR = "eon-navigation-meta-bg-color" as const;
export const NAVIGATION_META_BORDER_COLOR = "eon-navigation-meta-border-color" as const;
export const NAVIGATION_META_LINK_FONT_COLOR = "eon-navigation-meta-link-font-color" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_HOVER = "eon-navigation-meta-link-font-color-hover" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_FOCUS = "eon-navigation-meta-link-font-color-focus" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT = "eon-navigation-meta-link-font-color-current" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-font-color-current-hover" as const;
export const NAVIGATION_META_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-font-color-current-focus" as const;
export const NAVIGATION_META_LINK_BG_COLOR = "eon-navigation-meta-link-bg-color" as const;
export const NAVIGATION_META_LINK_BG_COLOR_HOVER = "eon-navigation-meta-link-bg-color-hover" as const;
export const NAVIGATION_META_LINK_BG_COLOR_FOCUS = "eon-navigation-meta-link-bg-color-focus" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT = "eon-navigation-meta-link-bg-color-current" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-bg-color-current-hover" as const;
export const NAVIGATION_META_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-bg-color-current-focus" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR = "eon-navigation-meta-link-border-color" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_HOVER = "eon-navigation-meta-link-border-color-hover" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_FOCUS = "eon-navigation-meta-link-border-color-focus" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT = "eon-navigation-meta-link-border-color-current" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-meta-link-border-color-current-hover" as const;
export const NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-meta-link-border-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_BG_COLOR = "eon-navigation-toolbar-bg-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR = "eon-navigation-toolbar-icon-link-font-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_HOVER = "eon-navigation-toolbar-icon-link-font-color-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_FOCUS = "eon-navigation-toolbar-icon-link-font-color-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT = "eon-navigation-toolbar-icon-link-font-color-current" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-toolbar-icon-link-font-color-current-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-toolbar-icon-link-font-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE = "eon-navigation-toolbar-icon-link-font-color-active" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-toolbar-icon-link-font-color-active-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-toolbar-icon-link-font-color-active-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR = "eon-navigation-toolbar-icon-link-bg-color" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_HOVER = "eon-navigation-toolbar-icon-link-bg-color-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT = "eon-navigation-toolbar-icon-link-bg-color-current" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-toolbar-icon-link-bg-color-current-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-current-focus" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE = "eon-navigation-toolbar-icon-link-bg-color-active" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-toolbar-icon-link-bg-color-active-hover" as const;
export const NAVIGATION_TOOLBAR_ICON_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-toolbar-icon-link-bg-color-active-focus" as const;
export const NAVIGATION_TOOLBAR_SUB_BG_COLOR = "eon-navigation-toolbar-sub-bg-color" as const;
export const NAVIGATION_MAIN_BG_COLOR = "eon-navigation-main-bg-color" as const;
export const NAVIGATION_MAIN_BORDER_COLOR = "eon-navigation-main-border-color" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR = "eon-navigation-main-link-font-color" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_HOVER = "eon-navigation-main-link-font-color-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_FOCUS = "eon-navigation-main-link-font-color-focus" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT = "eon-navigation-main-link-font-color-current" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-main-link-font-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-font-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE = "eon-navigation-main-link-font-color-active" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-font-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-font-color-active-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR = "eon-navigation-main-link-bg-color" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_HOVER = "eon-navigation-main-link-bg-color-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_FOCUS = "eon-navigation-main-link-bg-color-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT = "eon-navigation-main-link-bg-color-current" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-main-link-bg-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-bg-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE = "eon-navigation-main-link-bg-color-active" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-bg-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-bg-color-active-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR = "eon-navigation-main-link-border-color" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_HOVER = "eon-navigation-main-link-border-color-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_FOCUS = "eon-navigation-main-link-border-color-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT = "eon-navigation-main-link-border-color-current" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-main-link-border-color-current-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-main-link-border-color-current-focus" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE = "eon-navigation-main-link-border-color-active" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_HOVER = "eon-navigation-main-link-border-color-active-hover" as const;
export const NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_FOCUS = "eon-navigation-main-link-border-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR = "eon-navigation-main-icon-link-font-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_HOVER = "eon-navigation-main-icon-link-font-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_FOCUS = "eon-navigation-main-icon-link-font-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT = "eon-navigation-main-icon-link-font-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-font-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-font-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE = "eon-navigation-main-icon-link-font-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-font-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-font-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR = "eon-navigation-main-icon-link-bg-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_HOVER = "eon-navigation-main-icon-link-bg-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_FOCUS = "eon-navigation-main-icon-link-bg-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT = "eon-navigation-main-icon-link-bg-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-bg-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-bg-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE = "eon-navigation-main-icon-link-bg-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-bg-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-bg-color-active-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR = "eon-navigation-main-icon-link-border-color" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_HOVER = "eon-navigation-main-icon-link-border-color-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_FOCUS = "eon-navigation-main-icon-link-border-color-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT = "eon-navigation-main-icon-link-border-color-current" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-navigation-main-icon-link-border-color-current-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-navigation-main-icon-link-border-color-current-focus" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE = "eon-navigation-main-icon-link-border-color-active" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE_HOVER = "eon-navigation-main-icon-link-border-color-active-hover" as const;
export const NAVIGATION_MAIN_ICON_LINK_BORDER_COLOR_ACTIVE_FOCUS = "eon-navigation-main-icon-link-border-color-active-focus" as const;
export const NAVIGATION_MAIN_SUB_BG_COLOR = "eon-navigation-main-sub-bg-color" as const;
export const NAVIGATION_MAIN_SUB_BOX_SHADOW = "eon-navigation-main-sub-box-shadow" as const;
export const NAVIGATION_FLYOUT_DIVIDER_BG_COLOR = "eon-navigation-flyout-divider-bg-color" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR = "eon-navigation-flyout-link-font-color" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_HOVER = "eon-navigation-flyout-link-font-color-hover" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_FOCUS = "eon-navigation-flyout-link-font-color-focus" as const;
export const NAVIGATION_FLYOUT_LINK_FONT_COLOR_CURRENT = "eon-navigation-flyout-link-font-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_BORDER_COLOR_CURRENT = "eon-navigation-flyout-link-border-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR = "eon-navigation-flyout-link-large-font-color" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_HOVER = "eon-navigation-flyout-link-large-font-color-hover" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_FOCUS = "eon-navigation-flyout-link-large-font-color-focus" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_CURRENT = "eon-navigation-flyout-link-large-font-color-current" as const;
export const NAVIGATION_FLYOUT_LINK_LARGE_BORDER_COLOR_CURRENT = "eon-navigation-flyout-link-large-border-color-current" as const;
export const NAVIGATION_MOBILE_BG_COLOR = "eon-navigation-mobile-bg-color" as const;
export const NAVIGATION_MOBILE_LINK_FONT_COLOR = "eon-navigation-mobile-link-font-color" as const;
export const NAVIGATION_MOBILE_LINK_HIGHLIGHT_BORDER_COLOR = "eon-navigation-mobile-link-highlight-border-color" as const;
export const NAVIGATION_MOBILE_LINK_BORDER_COLOR = "eon-navigation-mobile-link-border-color" as const;
export const NAVIGATION_FOCUS_BORDER_COLOR = "eon-navigation-focus-border-color" as const;
export const NAVIGATION_MAIN_BORDER_COLOR_FOCUS_VISIBLE = "eon-navigation-main-border-color-focus-visible" as const;
export const NAVIGATION_LOGO_FOCUS_COLOR = "eon-navigation-logo-focus-color" as const;
export const PRELOADER_CIRCLE_THEME_COLOR1 = "eon-preloader-circle-theme-color1" as const;
export const PRELOADER_CIRCLE_THEME_COLOR2 = "eon-preloader-circle-theme-color2" as const;
export const PRELOADER_CIRCLE_THEME_COLOR3 = "eon-preloader-circle-theme-color3" as const;
export const PRELOADER_CIRCLE_THEME_COLOR4 = "eon-preloader-circle-theme-color4" as const;
export const PRELOADER_SQUARES_THEME_COLOR1 = "eon-preloader-squares-theme-color1" as const;
export const PRELOADER_SQUARES_THEME_COLOR2 = "eon-preloader-squares-theme-color2" as const;
export const PRELOADER_SQUARES_THEME_COLOR3 = "eon-preloader-squares-theme-color3" as const;
export const PRELOADER_SQUARES_THEME_COLOR4 = "eon-preloader-squares-theme-color4" as const;
export const SECTION_VIDEO_CONTROL_COLOR_LIGHT = "eon-section-video-control-color-light" as const;
export const SECTION_VIDEO_CONTROL_COLOR_DARK = "eon-section-video-control-color-dark" as const;
export const SEARCH_RESULT_ITEM_MARK_COLOR = "eon-search-result-item-mark-color" as const;
export const SEARCH_RESULT_ITEM_VISITED_COLOR = "eon-search-result-item-visited-color" as const;
export const STAGE_BLURRED_BACKGROUND = "eon-stage-blurred-background" as const;
export const STAGE_INDICATOR_COLOR_LIGHT = "eon-stage-indicator-color-light" as const;
export const STAGE_INDICATOR_COLOR_DARK = "eon-stage-indicator-color-dark" as const;
export const STAGE_VIDEO_CONTROL_COLOR_LIGHT = "eon-stage-video-control-color-light" as const;
export const STAGE_VIDEO_CONTROL_COLOR_DARK = "eon-stage-video-control-color-dark" as const;
export const VIDEOPLAYER_FOCUS_OUTLINE_COLOR = "eon-videoplayer-focus-outline-color" as const;
export const VIDEOPLAYER_ERROR_COLOR = "eon-videoplayer-error-color" as const;
export const VIDEOPLAYER_ERROR_BACKGROUND_COLOR = "eon-videoplayer-error-background-color" as const;
export const VIDEOPLAYER_CONTROLS_BACKGROUND = "eon-videoplayer-controls-background" as const;
export const VIDEOPLAYER_PROGRESS_BACKGROUND = "eon-videoplayer-progress-background" as const;
export const VIDEOPLAYER_PROGRESS_COLOR = "eon-videoplayer-progress-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_COLOR = "eon-videoplayer-progress-bar-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BACKGROUND = "eon-videoplayer-progress-bar-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_ACTIVE_BACKGROUND = "eon-videoplayer-progress-bar-active-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_TIME_COLOR = "eon-videoplayer-progress-bar-time-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_VALUE_BACKGROUND = "eon-videoplayer-progress-bar-value-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_COLOR = "eon-videoplayer-progress-bar-button-color" as const;
export const VIDEOPLAYER_PROGRESS_BAR_BUTTON_FOCUS = "eon-videoplayer-progress-bar-button-focus" as const;
export const VIDEOPLAYER_PROGRESS_BAR_PLAY_BUTTON_BACKGROUND = "eon-videoplayer-progress-bar-play-button-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_PLAY_BUTTON_HOVER_BACKGROUND = "eon-videoplayer-progress-bar-play-button-hover-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_MUTE_BUTTON_BACKGROUND = "eon-videoplayer-progress-bar-mute-button-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_MUTE_BUTTON_HOVER_BACKGROUND = "eon-videoplayer-progress-bar-mute-button-hover-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_FULL_SCREEN_BUTTON_BACKGROUND = "eon-videoplayer-progress-bar-full-screen-button-background" as const;
export const VIDEOPLAYER_PROGRESS_BAR_FULL_SCREEN_BUTTON_HOVER_BACKGROUND = "eon-videoplayer-progress-bar-full-screen-button-hover-background" as const;
export const VIDEOPLAYER_ICON_COLOR = "eon-videoplayer-icon-color" as const;
export const WEBSITE_NAVIGATION_BOX_SHADOW = "eon-website-navigation-box-shadow" as const;
export const WEBSITE_NAVIGATION_META_BG_COLOR = "eon-website-navigation-meta-bg-color" as const;
export const WEBSITE_NAVIGATION_META_BORDER_COLOR = "eon-website-navigation-meta-border-color" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR = "eon-website-navigation-meta-link-font-color" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR_HOVER = "eon-website-navigation-meta-link-font-color-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR_FOCUS = "eon-website-navigation-meta-link-font-color-focus" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR_CURRENT = "eon-website-navigation-meta-link-font-color-current" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR_CURRENT_HOVER = "eon-website-navigation-meta-link-font-color-current-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-website-navigation-meta-link-font-color-current-focus" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR = "eon-website-navigation-meta-link-bg-color" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR_HOVER = "eon-website-navigation-meta-link-bg-color-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR_FOCUS = "eon-website-navigation-meta-link-bg-color-focus" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR_CURRENT = "eon-website-navigation-meta-link-bg-color-current" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR_CURRENT_HOVER = "eon-website-navigation-meta-link-bg-color-current-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_BG_COLOR_CURRENT_FOCUS = "eon-website-navigation-meta-link-bg-color-current-focus" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR = "eon-website-navigation-meta-link-border-color" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR_HOVER = "eon-website-navigation-meta-link-border-color-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR_FOCUS = "eon-website-navigation-meta-link-border-color-focus" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR_CURRENT = "eon-website-navigation-meta-link-border-color-current" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-website-navigation-meta-link-border-color-current-hover" as const;
export const WEBSITE_NAVIGATION_META_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-website-navigation-meta-link-border-color-current-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_BG_COLOR = "eon-website-navigation-toolbar-bg-color" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR = "eon-website-navigation-toolbar-link-font-color" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_HOVER = "eon-website-navigation-toolbar-link-font-color-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_FOCUS = "eon-website-navigation-toolbar-link-font-color-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_CURRENT = "eon-website-navigation-toolbar-link-font-color-current" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_CURRENT_HOVER = "eon-website-navigation-toolbar-link-font-color-current-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-website-navigation-toolbar-link-font-color-current-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_ACTIVE = "eon-website-navigation-toolbar-link-font-color-active" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-website-navigation-toolbar-link-font-color-active-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-website-navigation-toolbar-link-font-color-active-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR = "eon-website-navigation-toolbar-link-bg-color" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_HOVER = "eon-website-navigation-toolbar-link-bg-color-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_FOCUS = "eon-website-navigation-toolbar-link-bg-color-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_CURRENT = "eon-website-navigation-toolbar-link-bg-color-current" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_CURRENT_HOVER = "eon-website-navigation-toolbar-link-bg-color-current-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_CURRENT_FOCUS = "eon-website-navigation-toolbar-link-bg-color-current-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_ACTIVE = "eon-website-navigation-toolbar-link-bg-color-active" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_ACTIVE_HOVER = "eon-website-navigation-toolbar-link-bg-color-active-hover" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-website-navigation-toolbar-link-bg-color-active-focus" as const;
export const WEBSITE_NAVIGATION_TOOLBAR_SUB_BG_COLOR = "eon-website-navigation-toolbar-sub-bg-color" as const;
export const WEBSITE_NAVIGATION_MAIN_BG_COLOR = "eon-website-navigation-main-bg-color" as const;
export const WEBSITE_NAVIGATION_MAIN_BORDER_COLOR = "eon-website-navigation-main-border-color" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR = "eon-website-navigation-main-link-font-color" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_HOVER = "eon-website-navigation-main-link-font-color-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_FOCUS = "eon-website-navigation-main-link-font-color-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT = "eon-website-navigation-main-link-font-color-current" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_HOVER = "eon-website-navigation-main-link-font-color-current-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_CURRENT_FOCUS = "eon-website-navigation-main-link-font-color-current-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE = "eon-website-navigation-main-link-font-color-active" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_HOVER = "eon-website-navigation-main-link-font-color-active-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_FONT_COLOR_ACTIVE_FOCUS = "eon-website-navigation-main-link-font-color-active-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR = "eon-website-navigation-main-link-bg-color" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_HOVER = "eon-website-navigation-main-link-bg-color-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_FOCUS = "eon-website-navigation-main-link-bg-color-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT = "eon-website-navigation-main-link-bg-color-current" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_HOVER = "eon-website-navigation-main-link-bg-color-current-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_CURRENT_FOCUS = "eon-website-navigation-main-link-bg-color-current-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE = "eon-website-navigation-main-link-bg-color-active" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_HOVER = "eon-website-navigation-main-link-bg-color-active-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BG_COLOR_ACTIVE_FOCUS = "eon-website-navigation-main-link-bg-color-active-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR = "eon-website-navigation-main-link-border-color" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_HOVER = "eon-website-navigation-main-link-border-color-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_FOCUS = "eon-website-navigation-main-link-border-color-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT = "eon-website-navigation-main-link-border-color-current" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_HOVER = "eon-website-navigation-main-link-border-color-current-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_CURRENT_FOCUS = "eon-website-navigation-main-link-border-color-current-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE = "eon-website-navigation-main-link-border-color-active" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_HOVER = "eon-website-navigation-main-link-border-color-active-hover" as const;
export const WEBSITE_NAVIGATION_MAIN_LINK_BORDER_COLOR_ACTIVE_FOCUS = "eon-website-navigation-main-link-border-color-active-focus" as const;
export const WEBSITE_NAVIGATION_MAIN_SUB_BG_COLOR = "eon-website-navigation-main-sub-bg-color" as const;
export const WEBSITE_NAVIGATION_MAIN_SUB_BOX_SHADOW = "eon-website-navigation-main-sub-box-shadow" as const;
export const WEBSITE_NAVIGATION_FLYOUT_DIVIDER_BG_COLOR = "eon-website-navigation-flyout-divider-bg-color" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_FONT_COLOR = "eon-website-navigation-flyout-link-font-color" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_FONT_COLOR_HOVER = "eon-website-navigation-flyout-link-font-color-hover" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_FONT_COLOR_FOCUS = "eon-website-navigation-flyout-link-font-color-focus" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_FONT_COLOR_CURRENT = "eon-website-navigation-flyout-link-font-color-current" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_BORDER_COLOR_CURRENT = "eon-website-navigation-flyout-link-border-color-current" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR = "eon-website-navigation-flyout-link-large-font-color" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_HOVER = "eon-website-navigation-flyout-link-large-font-color-hover" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_FOCUS = "eon-website-navigation-flyout-link-large-font-color-focus" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_FONT_COLOR_CURRENT = "eon-website-navigation-flyout-link-large-font-color-current" as const;
export const WEBSITE_NAVIGATION_FLYOUT_LINK_LARGE_BORDER_COLOR_CURRENT = "eon-website-navigation-flyout-link-large-border-color-current" as const;
export const WEBSITE_NAVIGATION_MOBILE_BG_COLOR = "eon-website-navigation-mobile-bg-color" as const;
export const WEBSITE_NAVIGATION_MOBILE_LINK_FONT_COLOR = "eon-website-navigation-mobile-link-font-color" as const;
export const WEBSITE_NAVIGATION_MOBILE_LINK_HIGHLIGHT_BORDER_COLOR = "eon-website-navigation-mobile-link-highlight-border-color" as const;
export const WEBSITE_NAVIGATION_MOBILE_LINK_BORDER_COLOR = "eon-website-navigation-mobile-link-border-color" as const;

export const SCHEME_ALIAS_CONFIG = {
  ACCORDION: {},
  ANCHOR_NAVIGATION: {},
  ANSWER_CARD: {},
  BASIC_TEASER: {},
  BADGE: {},
  BREADCRUMB: {},
  BOTTOM_DRAWER: {},
  BULLET_LIST: {},
  BULLET_LIST_DEPRECATED: {},
  BUSINESSCARD_AUTHOR: {},
  BUSINESSCARD_CONTACT: {},
  BOX: {},
  BUTTON: {},
  CAPTION: {},
  CARD_TEASER: {},
  CAROUSEL: {},
  CHECKBOX: {},
  CHIP: {},
  CLICKABLE_IMAGE: {},
  COLOR_SEPARATOR: {},
  COMPASS: {},
  CONTACT_BAR: {},
  CONTACT_LIST: {},
  CONTACT_LAYER: {},
  CONTENT_AGGREGATOR: {},
  CONTENT_AGGREGATOR_ITEM: {},
  CONTEXT_MENU: {},
  CONTEXT_MENU_ITEM: {},
  DATA_TABLE: {},
  DATE_EVENT: {},
  DATE_PICKER: {},
  DIVIDER: {},
  DROPDOWN: {},
  DROPDOWN_OPTION: {},
  ERROR_MESSAGE: {},
  FILE_UPLOAD: {},
  FILE_PREVIEW: {},
  FOOTER_BAR: {},
  FORM_MESSAGE: {},
  HEADLINE: {},
  ICON: {},
  IMAGE: {},
  INFO_ICON: {},
  INPUT: {},
  LINK: {},
  LINKLIST: {},
  MAP: {},
  MAP_INFO_LAYER: {},
  MODAL: {},
  MULTI_CONTENT_STAGE: {},
  NAVIGATION: {},
  NUMBER: {},
  OFFSET_TEASER: {},
  OFFSET_TEASER5: {},
  OPTION_PICKER_ITEM: {},
  PAGINATION: {},
  PRELOADER_CIRCLE: {},
  PRELOADER_SQUARES: {},
  PROGRESS_CIRCLE: {},
  PROMO_FLAG: {},
  PAGE_HEADER: {},
  PICTOGRAM: {},
  RADIO_BUTTON: {},
  READ_MORE: {},
  RTE_RENDERER: {},
  SECTION: {},
  SEARCH_RESULT_ITEM: {},
  SEGMENTED_BUTTON: {},
  SITELINK: {},
  SLIDER: {},
  SWITCH_TOGGLE: {},
  SPACER: {},
  STAGE: {},
  STEP: {},
  STEPS: {},
  TABLE_RENDERER: {},
  TABS: {},
  TAG_PILL: {},
  TEXT: {},
  TEXT_TEASER: {},
  THIRD_LEVEL_NAVIGATION: {},
  THIRD_LEVEL_NAVIGATION_ITEM: {},
  TILES_TEASER: {},
  TOOLTIP: {},
  VIDEOPLAYER: {},
  VIOLATOR: {},
  WEBSITE_NAVIGATION: {}
};

export const BACKGROUND_COLORS = [
  // COLOR_ULTRALIGHTGREY,
  // COLOR_WHITE,
  // COLOR_LIGHTGREY,

  COLOR_PINK500,
  COLOR_PINK700,
  COLOR_PURPLE500,
  COLOR_ORANGE500,
  COLOR_YELLOW500,
  COLOR_BLUE500,
  COLOR_BLUE700,
  COLOR_BLUE900,
  COLOR_BRIGHTBLUE500,
  COLOR_GREEN500,
  COLOR_GREEN900,
  COLOR_BRIGHTGREEN500,
  COLOR_PINK,
  COLOR_DARK_PINK,
  COLOR_BRIGHT_BLUE,
  COLOR_CYAN,
  COLOR_DARKBLUE,
  COLOR_RED,
  COLOR_YELLOW,
  COLOR_GREEN,
  COLOR_WHITE,
  COLOR_BRIGHT,
  COLOR_DARK,
  COLOR_DARK900,
  COLOR_DARK700,
  COLOR_DARK600,
  COLOR_DARK400,
  COLOR_DARK300,
  COLOR_DARK100,
  COLOR_BLUE,
  COLOR_ULTRALIGHTGREY,
  COLOR_LIGHT_GREEN,
  COLOR_LIGHT_RED,
  COLOR_LIGHT_YELLOW,
  COLOR_LIGHT_BLUE
];

export interface BackgroundSchemeConfiguration<T> {
  // white?: T;
  // lightgrey?: T;
  // ultralightgrey?: T;

  pink500?: T;
  pink700?: T;
  purple500?: T;
  orange500?: T;
  yellow500?: T;
  blue500?: T;
  blue700?: T;
  blue900?: T;
  brightblue500?: T;
  green500?: T;
  green900?: T;
  brightgreen500?: T;
  pink?: T;
  darkPink?: T;
  brightBlue?: T;
  cyan?: T;
  darkblue?: T;
  red?: T;
  yellow?: T;
  green?: T;
  white?: T;
  bright?: T;
  dark?: T;
  dark900?: T;
  dark700?: T;
  dark600?: T;
  dark400?: T;
  dark300?: T;
  dark100?: T;
  blue?: T;
  ultralightgrey?: T;
  lightGreen?: T;
  lightRed?: T;
  lightYellow?: T;
  lightBlue?: T;
}

interface ColorMap {
  [name: string]: string | boolean | number;
}

export interface SchemeConfig {
  schemeName: string;
  scheme?: ColorMap;
}

export type EonColor = typeof EON_COLORS[number];

/* PLOP_INJECT_ALIGNMENT */
